import { call, put, takeEvery, delay, select, takeLatest, fork, take, cancel } from 'redux-saga/effects';
import { message } from 'antd';
import {
  GET_IMPEDANCE_CONTENT,
  UPDATE_TARGET_IC,
  REFIND_DOMAIN_INFO,
  DELETE_IMPEDANCE_ROW,
  SAVE_VRM,
  SAVE_RLC_VALUE,
  SAVE_RL_MODEL,
  SAVE_CAP_MODEL,
  UPDATE_EXTENDED,
  MERGE_PART,
  UPDATE_COMP_USAGE,
  SPLIT_COMP,
  UPDATE_COMP_PREFIX,
  UPDATE_EXTRACTION,
  UPDATE_OPTIMIZATION,
  REFRESH,
  REMOVE_COMP,
  ADD_ROW,
  CHANGE_NETS,
  CHANGE_EXTRA_NETS,
  SAVE_TARGET,
  SAVE_PORTS,
  SAVE_LOAD_PORTS,
  CHANGE_PCB,
  SAVE_POWER_DOMAIN,
  POWER_NET_SELECT_PANEL,
  RE_ASSIGN_DECAP_MODEL,
  DELETE_SENSE_PORT,
  UPDATE_OPTIONS,
  SAVE_PACKAGE_PORTS,
  UPDATE_PACKAGE_NETS,
  SAVE_DOMAIN_BY_NEW_NETS,
  SWITCH_PACKAGE_PORTS_TYPE,
  SAVE_BALL_SIZE,
  SET_ADDITIONAL_NETS,
  REFRESH_PACKAGE,
  SWITCH_TARGET_DIE,
  SAVE_WIRE_BOND,
  CHANGE_PAGE,
  CREATE_NEW_LAYOUT,
  DELETE_LAYOUT,
  DELETE_LAYOUT_CONNECTOR,
  TRACE_OVERVIEW,
  DELETE_SHIP,
  CREATE_DIE,
  SAVE_ON_DIE_MODEL,
  SAVE_MULTI_PCB_TARGET,
  UPDATE_DECAP_GROUP,
  SAVE_DIE_CURRENT,
  UPDATE_DECAP_MODEL,
  CHANGE_USAGE,
  SAVE_COMP_TABLE_DISPLAY,
  SAVE_PMIC_VOLTAGE,
  SAVE_RLEAK_RRDL,
  SWITCH_PACKAGE,
  SAVE_INTERPOSER,
  SAVE_INTERPOSER_NODE,
  SAVE_HAS_INTERPOSER,
  UPDATE_IC_CURRENT_STATUS,
  SAVE_TRANSIENT_TIME_SETTING,
  SWITCH_PCB,
  CREATE_MODEL,
  SAVE_SOCKET,
  USE_PACGAGE_FILE,
  UPDATE_PACKAGE_FILE,
  SAVE_LOAD_MODEL,
  SEARCH_VRM,
  REMOVE_VRM,
  SAVE_NET_EXTENSION_TYPE,
  REFRESH_INTERPOSER,
  DIE_POWER_NET_SELECT_PANEL,
  UPDATE_PACKAGE_RELATIONSHIP,
  SAVE_VRM_PORTS,
  UPDATE_PORT_IMPEDANCE
} from './actionType';
import {
  updateImpedanceLoading,
  updateImpedanceContent,
  updateImpedanceStatus,
  updateImpedanceResultExist,
  resetSetup,
  updateSelectPowerNets,
  savaImpedanceVerificationId,
  updatePCB,
  needUpdateCompSetting,
  savaImpedanceSignOffId,
  updateOpenTargetICLoading,
  updateSelectedPowerNets,
  updateLogs,
  saveImpedanceDisplay,
  searchVRMLoading,
  updateSimMsg,
  updateOpenTargetDieLoading,
  setPackageRelationship,
  saveLimitBoundaryPowerPins,
  saveSlicingTransferHspice,
  saveParallelExtraction,
} from './action';
import { updateModelSetting, updateExpand, updateViewList, updateSelectKeys, updatePageLayout } from '../project/action';
import { LEFT_RIGHT_lAYOUT, TOP_BOTTOM_LAYOUT, SINGLE_PAGE_LAYOUT } from '@/constants/layoutConstants';
import { changeTabMenu, openTabFooter } from '../../../MonitorStore/action';
import { isExistResult } from '@/services/Cascade/simulation/simulationCtrl'
import projectDesigns from '@/services/helper/projectDesigns';
import { getVerificationWorkflow } from '../simulation/action';
import {
  getImpedanceInfo,
  ImpExtraction,
  ImpOptimization,
  saveImpedanceDomain,
  saveImpedanceSetup,
  deleteImpedanceDomains,
  mergeVRMInfo,
  filterPortsByPCB,
  getCompUpdateLog,
  ImpOptions,
  upgradeSetupDataToMulti,
  ImpSetup,
  getImpedanceLayoutComp,
  getConnectorLayoutIndex,
  mergeConnectionTrace,
  setNewConnectorNetsSpec,
  getConnectionGroundNet,
  getPortImpedanceNets,
  uploadDecapGroupExcel,
  uploadDecapModelExcel,
  filterPortsByPackage,
  getDiePortsByCPM,
  getNetExtensionData,
  ImpedanceErrorCheck,
  ImpSocket,
  ImpInterposer,
  ImpDie,
  ImpLayout,
  ImpPackageDomain,
  OVERVIEW,
  PSI
} from '../../../../services/Cascade/Impedance';
import LayoutData from '@/services/data/LayoutData';
import {
  _getVRM,
  getPowerDomain,
  getPMIC,
  CascadeCompPrefixVersion,
  getNets,
  addMultiNetsFieldToCapComps,
  getPackagePowerDomain,
  getPkgDomainInfo,
  getNewPackageComp,
  getFindVRMSpecifyComp,
  CascadeCompRLCPrefixLib,
  getAllCascadeNets,
  getCompsBetweenPowerNets,
  getLayoutNetOrder,
  getAllCascadeComponents,
  getCascadeComponentsByNets,
  getPowerPinsLumpedPort
} from '../../../../services/Cascade/helper/setupData';
import { IMPEDANCE } from '@/constants/treeConstants';
import CascadeChannels from '@/services/Cascade/DB/cascadeChannels';
import { versionCompareSize } from '@/services/helper/dataProcess';
import { selectTaskPCB } from '@/services/Cascade/project';
import componentSetting, { compareCompPrefixLib } from '../../../../services/Cascade/helper/compSettingHelper';
import { updateDesignStatus, updatePCBLog } from '../project/action';
import { updateLibSetting } from '@/services/Cascade/library';
import componentDoNotStuff from '@/services/helper/componentsHelper/compDoNotStuff';
import { updateComponentDecapModel } from '../SignOffTemplate/signOffTemplateSaga';
import { updateLibraryMenu } from '../library/action';
import compTableHelper from '@/services/Cascade/helper/compTableHelper.js'
import compPinMap from '../../../../services/Cascade/helper/compPinMap';
import { IMPEDANCE_DIE, IMPEDANCE_INTERPOSER_LAYOUT, IMPEDANCE_PACKAGE, IMPEDANCE_PACKAGE_FILE, IMPEDANCE_PACKAGE_LIST, IMPEDANCE_PCB, IMPEDANCE_PCB_LIST, IMPEDANCE_PCB_PRELAYOUT, IMPEDANCE_POST_LIST, IMPEDANCE_SOCKET, SENSE, TARGET_DIE_INDEX, TARGET_PACKAGE_INDEX, TARGET_PCB_INDEX } from '../../../../services/Cascade/constants';
import { getPortData, autoSplitRefeByPower } from '@/services/helper/portCanvasHelper';
import pinMapStore from '@/services/Cascade/library/pinMapHelper'
import designConstructor from '../../../../services/helper/designConstructor';
import { DC, PCB } from '../../../../constants/treeConstants';
import { savePackageWireBondProfile } from '../../../../services/api/Design/design';
import { BallSizeMap } from '../../../../services/helper/ballSize';
import { CAP, CONNECTOR, IC, PMIC, BGA as BGAConst, DIE as DIEConst, DIE, FERRITE, IGNORE, IND, JUMPER, RES, SWITCH, LOAD, POWER_SWITCH, IPD, VRM } from '../../../../constants/componentType';
import { checkConnectCompsPinsAndNets, getCascadeComponents } from '../../../../services/Cascade/helper/setupData';
import { splitArrayToArrays } from '../../../../services/helper/arrayHelper';
import _ from 'lodash';
import preLayoutData from '../../../../services/Cascade/prelayout/preLayoutData';
import { userDefaultSettings } from '../../../../services/userDefaultSetting/userDefaultSettingCtrl';
import { DIE_PACKAGE_PCB, PARTBASED, COMPONENTBASED } from '../../../../constants/resolution';
import auroraDBJson from '../../../../services/Designs/auroraDbData';
import { getLibraryDataInfo, getLibraryFileInfo } from '../../../../services/Cascade/library';
import { parseSPModelSelector } from '../../../../services/Library';
import { CUSTOM_SPICE, DECAP_SPICE, DECAP_TOUCHSTONE, SPICE } from '../../../../constants/libraryConstants';
import { SortComponents } from '../../../../services/helper/sort';
import { HFSS, POWERSI, SIWAVE } from '../../../../constants/extractionType';
import { SPD } from '../../../../constants/designVendor';
import { IMPEDANCE_VERSION } from '../../../../version';
import checkMaterialList from '../../../../services/helper/materialCheck';

let autoSaveTask = null, lastVerificationTask = null;
function* getImpedanceContent(action) {
  const { CascadeReducer: { project: { openProjectId } } } = yield select();
  const { id: verificationId } = action;
  yield put(resetSetup())
  if (autoSaveTask) {
    yield cancel(autoSaveTask);
  }
  if (lastVerificationTask) {
    yield cancel(lastVerificationTask);
  }
  if (!verificationId) {
    return;
  }

  yield put(updateSimMsg([], true))
  yield put(updatePCBLog([]))
  const list = CascadeChannels.getList(IMPEDANCE, openProjectId);
  const currentItem = list.find(i => i.id === verificationId);
  const signOffId = currentItem ? currentItem.signOffId : null;

  yield put(changeTabMenu({
    tabSelectKeys: ["monitor"],
    currentVerificationId: verificationId,
    verificationName: currentItem ? currentItem.name : IMPEDANCE,
    menuType: "simulation"
  }))

  yield put(updateDesignStatus(true))
  yield put(updateImpedanceLoading('Loading...'));

  const userSetting = userDefaultSettings.getLocalSetting();
  const { cascadeSettings = {} } = userSetting;
  const { impedanceOverviewDisplay = DIE_PACKAGE_PCB, impedanceComponentsTableDisplay = PARTBASED, limitBoundaryPowerPinsLumpedPort = false, slicingTransferHspice = false, parallelExtraction } = cascadeSettings;
  yield put(saveImpedanceDisplay(impedanceOverviewDisplay, impedanceComponentsTableDisplay))
  yield put(saveLimitBoundaryPowerPins(limitBoundaryPowerPinsLumpedPort))
  yield put(saveSlicingTransferHspice(slicingTransferHspice))
  yield put(saveParallelExtraction(parallelExtraction))

  let designId = "", updateCompPrefix = false, _data = [], designName = "", page = OVERVIEW;

  try {
    const res = yield call(getImpedanceInfo, verificationId);
    yield put(getVerificationWorkflow(verificationId))
    if (res) {
      const setupVersion = res.setupVersion || IMPEDANCE_VERSION;
      const impedance = yield call(updateImpedanceByVersion, { data: res, version: setupVersion, verificationId });
      const Config = new ImpExtraction({ parallelExtraction, ...impedance.Config });
      const Optimization = new ImpOptimization(impedance.Optimization);
      const Options = new ImpOptions({ slicingTransferHspice, ...impedance.Options })
      let data = impedance.layouts || [];
      const targetIC = impedance.targetIC ? impedance.targetIC : '';
      const targetDie = impedance.targetDie || [];
      let designType = impedance.type || IMPEDANCE_PCB;
      //Fix the bug of designType is PCB,actually designType is pcb/package
      if (designType === PCB) {
        designType = IMPEDANCE_PCB;
      }
      designId = impedance.designId;
      designName = impedance.designName;
      const PCBList = projectDesigns.getAvailablePCBIds(openProjectId);
      yield call([componentSetting, componentSetting.getSetting], { designId, openProjectId });
      let COMP_PREFIX_LIB = impedance.COMP_PREFIX_LIB ? impedance.COMP_PREFIX_LIB : new CascadeCompPrefixVersion('0.0.1');

      // auto set pcb if only one pcb in project
      if (!designId && !targetIC && (!data || !data.length) && PCBList.length === 1) {
        designId = PCBList[0];
        const type = designConstructor.getDesignType(designId);
        const electric = designConstructor.getPreLayoutElectric(designId);
        if ((type === IMPEDANCE_PCB || type === IMPEDANCE_PCB_PRELAYOUT) && electric !== DC) {
          yield call(selectTaskPCB, { verificationId, designId });
          const version = yield call([componentSetting, componentSetting.getVersion], designId);
          COMP_PREFIX_LIB = { version: version }
          const designName = designConstructor.getDesignName(designId);
          const vendor = designConstructor.getDesignVendor(designId);
          const meshPologen = designConstructor.getDesignMeshPolygon(designId);
          const extraction = new ImpExtraction({ parallelExtraction, type: vendor === SPD ? POWERSI : meshPologen ? HFSS : SIWAVE });
          yield call(getAuroraDB, designId);
          if (auroraDBJson.isFlexBoard(designId)) {
            extraction.CLIP = 0
          }
          data = [new ImpLayout({ index: TARGET_PCB_INDEX, designId, designName: designName, type: IMPEDANCE_PCB, COMP_PREFIX_LIB, extraction })];
        }
        if (electric === DC) {
          designId = "";
        }
      }

      yield* data.map(function* (layout) {
        if (IMPEDANCE_POST_LIST.includes(layout.type)) {
          if (layout.designId) {
            yield call(getAuroraDB, layout.designId);
          }

          const isPreLayout = designConstructor.isPreLayout(layout.designId);
          if ([IMPEDANCE_PACKAGE, IMPEDANCE_PCB].includes(layout.type) && !isPreLayout) {
            yield* checkMaterialList(layout.designId, openProjectId);
          }
        }
      })

      // check component setting
      for (let layout of data) {
        const { designId: layoutDesignId, COMP_PREFIX_LIB, powerDomains = [], extraction, ballSizeMap = {}, ICs = [], connectors = [], type, Dies = [], Bgas = [] } = layout;
        const designExist = projectDesigns.getDesignExist(openProjectId, layoutDesignId)
        if (layoutDesignId && designExist) {
          const _version = COMP_PREFIX_LIB.version ? COMP_PREFIX_LIB.version : '0.0.1';
          const setting = yield call([componentSetting, componentSetting.getSetting], { designId: layoutDesignId, openProjectId });
          if (_version === '0.0.0') {
            delete COMP_PREFIX_LIB.version
            const save = compareCompPrefixLib(COMP_PREFIX_LIB, setting.compPrefixLib);
            if (save && data && data.length) {
              updateCompPrefix = false;
            }
            layout.COMP_PREFIX_LIB = { version: setting.version }
          } else if (versionCompareSize(_version, setting.version) && powerDomains && powerDomains.length) {
            updateCompPrefix = true;
          }
        }
        let ballSizeMapObj = new BallSizeMap()
        if (type === IMPEDANCE_PCB) {
          const _connectors = connectors.filter(item => {
            return powerDomains.find(domain => {
              const vrms = domain.content.VRM.map(it => [...(it.VRM_COMP || []), it.inductance]).flat(2)
              return domain.content.Components.find(comp => comp.name === item.name && comp.usage === CONNECTOR && vrms.includes(comp.name))
            })
          })
          ballSizeMapObj = new BallSizeMap({ ballSizeMap, comps: [...ICs, ..._connectors], designId: layoutDesignId })
        } else if (type === IMPEDANCE_PACKAGE) {
          ballSizeMapObj = new BallSizeMap({ ballSizeMap, comps: [...Dies, ...Bgas], designId: layoutDesignId })
        } else if (type === IMPEDANCE_INTERPOSER_LAYOUT) {
          ballSizeMapObj = new BallSizeMap({ ballSizeMap, comps: connectors, designId: layoutDesignId })
        }
        layout.ballSizeMap = ballSizeMapObj.getBallSizeMap()
        layout.extraction = new ImpExtraction({ parallelExtraction, ...extraction })
      }

      // set select nets
      if (impedance.targetNets) {
        yield put(updateSelectedPowerNets({ select: impedance.targetNets, allPowerNets: [], allNets: [], open: false }))
      }

      delete impedance.layouts;
      delete impedance.setupVersion;
      delete impedance.type;

      const { CascadeReducer: { project: { applyModelList = [] } } } = yield select();
      // auto set apply modle
      for (let layout of data) {
        for (let item of (layout.powerDomains || [])) {
          if (!item.content.Components) {
            continue;
          }
          item.content.Components.forEach(comp => {
            if (comp.COMP_TYPE === CAP) {
              const findItem = applyModelList.find(item => item.partName === comp.part);
              //comp.model.apply === false , The model modified by the user without checking apply all
              if (findItem && !findItem.defaultId && (comp.models && comp.models.length === 1 && comp.models[0].apply !== false)) {
                comp.models = [{ ...findItem.model, key: 0 }]
              }
            }
          })
        }
      }

      _data = [...data];
      if (!designName) {
        //add design name to setup
        designName = designConstructor.getDesignName(designId);
      }
      if (data.length === 1) {
        page = data[0].designId ? data[0].designId : OVERVIEW;
      }

      if (impedance.componentsTableDisplay && ![COMPONENTBASED, PARTBASED].includes(impedance.componentsTableDisplay)) {
        const componentsTableDisplay = impedance.componentsTableDisplay === 'componentBased' ? COMPONENTBASED : PARTBASED;
        yield put(updateImpedanceContent({ componentsTableDisplay }))
        delete impedance.componentsTableDisplay
      }

      yield put(updateImpedanceContent({ ...impedance, targetIC, targetDie, COMP_PREFIX_LIB, Config, designType, Optimization, Options, data, status: true, designName, page, impTaskId: null }));
      yield put(savaImpedanceVerificationId(verificationId));
      yield put(savaImpedanceSignOffId(signOffId));
      if (data.length === 1) {
        const page = data[0].designId;
        if (page) {
          yield call(changePageByDesign, { page })
        }
      }
    } else {
      const Config = new ImpExtraction({ parallelExtraction });
      const Optimization = new ImpOptimization();
      const Options = new ImpOptions({ slicingTransferHspice });
      const COMP_PREFIX_LIB = new CascadeCompPrefixVersion('0.0.1');
      yield put(updateImpedanceContent({ Config, Optimization, COMP_PREFIX_LIB, Options, impTaskId: null }));
      yield put(savaImpedanceVerificationId(verificationId));
    }
    const { CascadeReducer: { Impedance: { verificationId: currentVerificationId } } } = yield select();
    if (currentVerificationId === verificationId) {
      yield call(saveSetup);
      const resultExist = yield call(isExistResult, verificationId);
      yield put(updateImpedanceResultExist(resultExist ? resultExist.exist : false, verificationId))
      const designExist = projectDesigns.getDesignExist(openProjectId, designId)
      if (designId && designExist) {
        try {
          if (page && page !== OVERVIEW && page !== designId) {
            yield call(getAuroraDB, page);
          }
          const isPreLayout = designConstructor.isPreLayout(designId);
          if (!isPreLayout) {
            // check component setting init
            const setting = yield call([componentSetting, componentSetting.getSetting], { designId, openProjectId });
            if (!setting.init || !Object.keys(setting.init).length || Object.values(setting.init).some(item => item === false)) {
              yield call([componentSetting, componentSetting.getSettingFromBackend], { designId, openProjectId })
              yield put(updateLibraryMenu())
            }
          }
        } catch (error) {
          console.error(error)
        }
      }
      yield put(updatePCB(designId))
      yield put(updateDesignStatus(false))
      yield put(updateImpedanceStatus(true));
      yield put(updateImpedanceLoading(false));
      autoSaveTask = yield fork(autoSave);
      yield fork(saveLayouts, { data: _data, update: true, verificationId });
      yield put(needUpdateCompSetting(updateCompPrefix));
      const { CascadeReducer: { project: { layout, selectedKeys, viewList, expandedKeys } } } = yield select();
      if ([LEFT_RIGHT_lAYOUT, TOP_BOTTOM_LAYOUT].includes(layout)) {
        if (designId && designExist) {
          let _selectedKeys = [...selectedKeys];
          let _viewList = [...viewList]
          if (projectDesigns.getAvailableDesignsLength(openProjectId) > 0) {
            _viewList = _viewList.includes('PCB') ? _viewList : [...viewList, 'PCB'];
            let _expandedKeys = [...expandedKeys];
            _selectedKeys = _selectedKeys.filter(key => !key.includes('PCB'))
            _selectedKeys.push(`PCB-${designId}`);
            let expandedKey = `PCBs-${openProjectId}`;

            if (!_expandedKeys.includes(expandedKey)) {
              _expandedKeys.push(expandedKey)
              yield put(updateExpand(_expandedKeys));
            }
          }
          yield put(updateSelectKeys(_selectedKeys));
          yield put(updateViewList(_viewList));
        } else {
          let _viewList = viewList.filter(item => item !== 'PCB');
          let _selectedKeys = selectedKeys.filter(item => !item.includes('PCB'))
          yield put(updateViewList(_viewList));
          yield put(updateSelectKeys(_selectedKeys));
          yield put(updatePageLayout(SINGLE_PAGE_LAYOUT, 'setup'))
        }
      }
    }
    yield put(openTabFooter());
  } catch (error) {
    yield put(updateImpedanceResultExist(false))
    message.error('Get Impedance content failed!');
    console.error(error)
  }

  yield put(updateImpedanceLoading(false));
}

function* getAuroraDB(designId) {
  const { CascadeReducer: { project: { openProjectId } } } = yield select();
  try {
    const isPreLayout = designConstructor.isPreLayout(designId);
    if (isPreLayout) {
      yield call([preLayoutData, preLayoutData.getPreLayout], designId);
      return;
    }
    const setting = yield call([componentSetting, componentSetting.getSetting], { designId, openProjectId });
    yield call([auroraDBJson, auroraDBJson.getAuroraJson], designId, setting, { openProjectId });
  } catch (e) {
    console.error(e);
  }
}

function getLayoutDB(id, onlyCompLayer) {
  return new Promise((resolve, reject) => {
    try {
      const isPreLayout = designConstructor.isPreLayout(id);
      if (!isPreLayout) {
        LayoutData.LoadLayoutDB(id, onlyCompLayer).then(res => {
          resolve(true);
        }, error => {
          reject(error);
        })
      } else {
        preLayoutData.getPreLayout(id).then(res => {
          resolve(true);
        }, error => {
          reject(error);
        })
      }
    } catch (error) {
      reject(error);
    }
  })
}

function* changeTargetIC(action) {
  const { value, pcbId } = action;
  yield put(updateSelectPowerNets({ open: false }))
  const { CascadeReducer: { Impedance } } = yield select();
  const verificationId = Impedance.verificationId
  const data = Impedance.data || []
  const _designId = pcbId || Impedance.designId;
  yield put(updateImpedanceContent({ targetIC: value }));
  const { powerNets, allNets } = getPowerDomain({ chip: value, designId: _designId });
  yield put(updateSelectPowerNets({ select: [], allPowerNets: [...powerNets], allNets: [...allNets], open: value ? true : false }))

  // set table to loading and close select dropdown
  yield delay(10);
  try {
    yield call(saveImpedanceSetup, {
      verificationId,
      content: {
        ...new ImpSetup({ ...Impedance, powerNetSelect: { select: [] }, targetIC: value })
      }
    })
    const ic = getImpedanceLayoutComp(value, _designId, IC);
    const packageIndex = data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
    if (packageIndex > -1 && data[packageIndex].Bgas.length) {
      ic.from = [{ components: data[packageIndex].Bgas.map(item => item.name), designId: data[packageIndex].designId }]
      data[packageIndex].Bgas.forEach(item => {
        item.to = [{ components: [value], designId: _designId }]
      })
    }
    let layouts = data.map(layout => {
      if (layout.designId === _designId) {
        return { ...layout, ICs: value ? [ic] : [], powerDomains: [] }
      }
      return { ...layout, powerDomains: [] }
    })
    yield put(updateImpedanceContent({ data: [...layouts], status: true }));
    yield call(saveLayouts, { data: [...layouts], update: true, verificationId })
  } catch (error) {
    console.error(error)
  }
}

function* getVRMs(action = {}) {
  const { notClearLog = false, designIds } = action;
  const { CascadeReducer: { project: { openProjectId }, Impedance: { designId: currentDesignId, verificationId, targetIC, data = [], powerNetSelect: { select: powerNets }, Options, limitBoundaryPowerPinsLumpedPort } } } = yield select();

  yield put(updateImpedanceLoading('Loading PCBs...'));
  yield delay(100)

  yield* data.map(function* (layout) {
    if (IMPEDANCE_POST_LIST.includes(layout.type)) {
      if (layout.designId) {
        yield call(getAuroraDB, layout.designId);
      }
    }
  })

  const designList = CascadeChannels.getList(IMPEDANCE, openProjectId);
  const currentItem = [...designList].find(i => i.id === verificationId);
  if (!notClearLog) {
    yield put(openTabFooter());
    yield put(changeTabMenu({
      tabSelectKeys: ["detail"],
      currentVerificationId: verificationId,
      verificationName: currentItem ? currentItem.name : IMPEDANCE,
      menuType: "simulation"
    }))
    yield put(updateLogs([], true))
    yield delay(100);
  }

  const fromPmic = Options ? Options.fromPmic : false;
  const netExtensionData = getNetExtensionData(data, currentDesignId)
  const hasPassiveBoard = data.find(layout => layout.asPassiveBoard === true) ? true : false
  let layoutPowerDomains = {}, extraLoads = [];
  yield* data.map(function* (layout) {
    if (designIds && !designIds.includes(layout.designId)) {
      // Skip
    } else if (layout.index !== TARGET_PACKAGE_INDEX && layout.index !== TARGET_DIE_INDEX && IMPEDANCE_PCB_LIST.includes(layout.type)) {
      const { designId, connectors, designName, powerDomainIds, powerDomains: lastPowerDomains } = layout;

      const isPreLayout = designConstructor.isPreLayout(designId);
      yield put(updateImpedanceLoading(`Tracing ${designName}...`));
      yield delay(100);
      if (powerDomainIds && powerDomainIds.length) {
        try {
          yield call(deleteImpedanceDomains, { verificationId, designId, ids: powerDomainIds });
        } catch (e) {
          console.error(e)
        }
      }

      const connectorRule = (item) => { return item.from.length && item.from.every(f => f.designId !== designId) }
      const { trueArray: fromConnectors, falseArray: toConnectors } = splitArrayToArrays({ array: connectors, rule: connectorRule });
      const setting = yield call(componentSetting.getPrefixLib, designId);
      const doNotStuff = yield call(componentDoNotStuff.getDoNotStuff, designId);
      const table = yield call(compTableHelper.getTableData, designId);
      const pinMapSense = yield call([pinMapStore, pinMapStore.getPinMapSense], designId, "pinName")
      const _pinConnection = yield call(compPinMap.getPinConnection, designId);
      const pinConnection = yield call(getPowerSwitchPinMap, _pinConnection);
      const pinMap = yield call(getImpedancePinMap, designId);
      if (designId === currentDesignId) {
        const { groundNet } = getPowerDomain({ chip: targetIC, designId, COMP_PREFIX_LIB: setting, filterGrounds: [...powerNets] });
        const designName = designConstructor.getDesignName(designId)
        let loadSelect = [{ comp: targetIC }];
        const specify = toConnectors.map(connector => { return getFindVRMSpecifyComp(connector, designId) });
        if (!pinMap.some(item => item.data.length) && !specify.length && !isPreLayout) {
          yield put(updateLogs([{ type: 'error', text: `[${designName}] The Pin Map of the current PCB is not set, please open Component Setting to set it.` }]))
          yield delay(100)
        }
        if (!powerNets.length) {
          yield put(updateLogs([{ type: 'error', text: `[${designName}] The Power Nets of the current TargetIC are not set, please click the icon on the right side of TargetIC to set it.` }]))
          yield delay(100)
        }
        let powerDomains = []
        for (let powerNet of powerNets.sort()) {
          const lastPowerDomain = lastPowerDomains.find(item => item.content.MAIN_POWER_NETS && item.content.MAIN_POWER_NETS.includes(powerNet));
          const lastLoads = lastPowerDomain ? lastPowerDomain.content.Components.filter(item => item.usage === LOAD) : [];
          const lastGroundNets = lastPowerDomain ? lastPowerDomain.content.MAIN_REF_NETS || [] : [];
          const lastComponents = lastPowerDomain ? lastPowerDomain.content.Components || [] : lastPowerDomains.map(item => item.content.Components || []).flat();
          const _groundNets = lastGroundNets.length && !lastGroundNets.includes(powerNet) ? [...lastGroundNets] : groundNet ? [groundNet] : [];
          let VRMInfo = yield call(_getVRM, {
            designId: currentDesignId,
            GroundNets: _groundNets,
            PowerNets: [powerNet],
            ExtendNets: [],
            COMP_PREFIX_LIB: setting,
            loadSelect,
            connectInductance: false,
            findExtend: true,
            isAC: true,
            PMIC: getPMIC(setting),
            powerSwitch: setting.powerSwitch,
            buckConverter: setting.discreteBuckConverter || [],
            doNotStuff,
            table,
            pinMapSense,
            pinConnection,
            pinMap,
            specify,
            extraNets: lastPowerDomain ? lastPowerDomain.content.extraNets : [],
            fuzzyMatch: true,
            connectors: toConnectors.map(to => to.name),
            fromPmic,
            hasPassiveBoard
          })

          yield put(updateLogs(VRMInfo.logs || []))

          VRMInfo.Components = yield call(updateComponentDecapModel, {
            components: VRMInfo.Components,
            prevComps: lastComponents,
            designId: currentDesignId,
            voltage: VRMInfo.voltage || "1"
          })

          VRMInfo.Components = VRMInfo.Components.map(comp => {
            if (comp.usage === IGNORE) {
              const load = lastLoads.find(item => item.name === comp.name);
              if (load) {
                extraLoads.push({ designId, compNames: [comp.name], powerNet })
              }
            } else if (lastPowerDomain && (comp.usage === LOAD || comp.usage === PMIC)) {
              const load = lastPowerDomain.content.Components.find(item => item.name === comp.name);
              comp.model = load ? load.model || {} : {};
            }
            return comp;
          })

          const ports = limitBoundaryPowerPinsLumpedPort ? getPowerPinsLumpedPort(currentDesignId, targetIC, [powerNet], _groundNets) : []
          const content = {
            voltage: "1",
            ...VRMInfo,
            ReferenceNets: _groundNets,
            MAIN_POWER_NETS: [powerNet],
            MAIN_REF_NETS: _groundNets,
            includeExtended: true,
            ports: lastPowerDomain ? lastPowerDomain.content.ports : ports,
            target: lastPowerDomain ? lastPowerDomain.content.target : [],
            extraNets: lastPowerDomain ? lastPowerDomain.content.extraNets : [],
            extraVRM: lastPowerDomain ? lastPowerDomain.content.extraVRM : [],
          }
          if (isPreLayout) {
            content.ports = VRMInfo.ports ? VRMInfo.ports : content.ports
            content.pmicPorts = VRMInfo.pmicPorts ? VRMInfo.pmicPorts : []
          }
          powerDomains.push(content)
        }
        if (!powerDomains.length) {
          yield put(updateLogs([{ type: 'error', text: `[${designName}] Can not find Power Domains.` }]))
        } else {
          const currentDomains = powerDomains.filter(item => item.DEBUG_MONITOR && item.DEBUG_MONITOR.length)
          yield put(updateLogs([{ type: 'success', text: `[${designName}] Found ${powerDomains.length} Power Domains, ${currentDomains.length} Power Domains have PMICs.` }]))
        }
        yield delay(100)
        layoutPowerDomains[designId] = powerDomains
      } else {
        const specify = toConnectors.map(connector => { return getFindVRMSpecifyComp(connector, designId) });
        const netExtension = netExtensionData[designId] || {};
        if (!pinMap.some(item => item.data.length) && !specify.length && isPreLayout) {
          const designName = designConstructor.getDesignName(designId)
          yield put(updateLogs([{ type: 'error', text: `[${designName}] The Pin Map of the current PCB is not set, please open Component Setting to set it.` }]))
          yield delay(100)
        }
        let powerDomains = []
        for (let connector of fromConnectors) {
          const { name, from } = connector;
          let powerNets = [], referenceNets = [];
          for (let f of from) {
            const { nets } = f;
            if (!nets) {
              continue;
            }
            const _nets = nets[`${name}-${designId}`];
            if (!_nets) {
              continue
            }
            let groundNet = getConnectionGroundNet({ designId, name, currentDesignId, targetIC, setting, data });
            if (!groundNet) {
              const obj = getPowerDomain({ chip: name, designId });
              groundNet = obj ? obj.groundNet : ''
            }
            const fNets = nets[`${f.components[0]}-${f.designId}`]
            const netShip = fNets.map((net, index) => net && _nets[index] ? [net, _nets[index]] : null).filter(item => !!item && item[1] !== groundNet)
            const fromLayout = data.find(item => item.designId === f.designId);
            const powerNetsOrder = getLayoutNetOrder(fromLayout, 'from');
            let sortNets = [];
            if (fromLayout.type === IMPEDANCE_INTERPOSER_LAYOUT) {
              sortNets = [...new Set(_nets)].filter(net => net !== groundNet).sort((a, b) => {
                const aIndex = powerNetsOrder.findIndex(n => n === a);
                const bIndex = powerNetsOrder.findIndex(n => n === b);
                return (aIndex > -1 ? aIndex : Infinity) > (bIndex > -1 ? bIndex : Infinity) ? 1 : -1;
              })
            } else {
              sortNets = netShip.sort((a, b) => {
                const aIndex = powerNetsOrder.findIndex(n => n === a[0]);
                const bIndex = powerNetsOrder.findIndex(n => n === b[0]);
                return (aIndex > -1 ? aIndex : Infinity) > (bIndex > -1 ? bIndex : Infinity) ? 1 : -1;
              }).map(net => net[1])
            }
            powerNets.push(...(sortNets) || [])
            referenceNets.push(...(groundNet ? [groundNet] || [] : []))
          }
          let loadSelect = [{ comp: name }];
          const { trueArray: power, falseArray: sense } = splitArrayToArrays({ array: [...new Set(powerNets)], rule: (net) => !netExtension.includes(net) })
          let filterSensePMICs = [];
          for (let powerNet of [...power, ...sense]) {
            const lastPowerDomain = lastPowerDomains.find(item => item.content.MAIN_POWER_NETS && item.content.MAIN_POWER_NETS.includes(powerNet));
            const lastLoads = lastPowerDomain ? lastPowerDomain.content.Components.filter(item => item.usage === LOAD) : [];
            const lastComponents = lastPowerDomain ? lastPowerDomain.content.Components || [] : lastPowerDomains.map(item => item.content.Components || []).flat();
            let VRMInfo = yield call(_getVRM, {
              designId,
              GroundNets: [...new Set(referenceNets)],
              PowerNets: [powerNet],
              ExtendNets: [],
              COMP_PREFIX_LIB: setting,
              loadSelect,
              connectInductance: false,
              findExtend: true,
              isAC: true,
              PMIC: getPMIC(setting),
              powerSwitch: setting.powerSwitch,
              buckConverter: setting.discreteBuckConverter || [],
              doNotStuff,
              table,
              pinMapSense,
              pinConnection,
              pinMap,
              specify,
              fuzzyMatch: true,
              connectors: [name, ...toConnectors.map(to => to.name)],
              extraNets: lastPowerDomain ? lastPowerDomain.content.extraNets : [],
              fromPmic,
              fullPaths: netExtension.includes(powerNet) ? true : false,
              filterPMICs: filterSensePMICs
            })

            yield put(updateLogs(VRMInfo.logs || []))

            if (!netExtension.includes(powerNet)) {
              const pmics = VRMInfo.Components.filter(comp => [PMIC, CONNECTOR].includes(comp.usage) && comp.name !== name).map(comp => comp.name);
              filterSensePMICs.push(...pmics);
              const vrms = VRMInfo.VRM.map(vrm => vrm.VRM_COMP).flat(2);
              filterSensePMICs.push(...vrms);
            }

            VRMInfo.Components = yield call(updateComponentDecapModel, {
              components: VRMInfo.Components,
              prevComps: lastComponents,
              designId,
              voltage: VRMInfo.voltage || "1"
            })

            VRMInfo.Components = VRMInfo.Components.map(comp => {
              if (comp.usage === IGNORE) {
                const load = lastLoads.find(item => item.name === comp.name);
                if (load) {
                  extraLoads.push({ designId, compNames: [comp.name], powerNet })
                }
              } else if (lastPowerDomain && (comp.usage === LOAD || comp.usage === PMIC)) {
                const load = lastPowerDomain.content.Components.find(item => item.name === comp.name);
                comp.model = load ? load.model || {} : {};
              }
              return comp;
            })

            const ports = limitBoundaryPowerPinsLumpedPort ? getPowerPinsLumpedPort(designId, name, [powerNet], [...new Set(referenceNets)]) : []
            const content = {
              voltage: "1",
              ...VRMInfo,
              ReferenceNets: [...new Set(referenceNets)],
              MAIN_POWER_NETS: [powerNet],
              MAIN_REF_NETS: [...new Set(referenceNets)],
              includeExtended: true,
              ports: lastPowerDomain ? lastPowerDomain.content.ports : ports,
              target: lastPowerDomain ? lastPowerDomain.content.target : [],
              extraNets: lastPowerDomain ? lastPowerDomain.content.extraNets : [],
              extraVRM: lastPowerDomain ? lastPowerDomain.content.extraVRM : [],
            }
            if (isPreLayout) {
              content.ports = VRMInfo.ports ? VRMInfo.ports : content.ports
              content.pmicPorts = VRMInfo.pmicPorts ? VRMInfo.pmicPorts : []
            }
            powerDomains.push(content);
          }
        }
        if (!powerDomains.length) {
          yield put(updateLogs([{ type: 'error', text: `[${designName}]Can not find Power Domains.` }]))
        } else {
          const currentDomains = powerDomains.filter(item => item.DEBUG_MONITOR && item.DEBUG_MONITOR.length)
          yield put(updateLogs([{ type: 'success', text: `[${designName}] Found ${powerDomains.length} Power Domains, ${currentDomains.length} Power Domains have PMICs.` }]))
        }
        layoutPowerDomains[designId] = powerDomains
      }
    }
  })

  yield put(updateImpedanceLoading(`Checking...`));
  yield delay(100)

  let _data = [...data];
  if (data.length > 1) {
    layoutPowerDomains = mergeConnectionTrace(_data, layoutPowerDomains);
  }
  yield put(updateLogs([{ type: 'normal', text: `[Layouts] Checking...` }]))
  yield delay(100)
  for (let layout of _data) {
    if (designIds && !designIds.includes(layout.designId)) {
      continue;
    }
    const { designId: layoutDesignId, connectors, index, ballSizeMap, type } = layout;
    if (index !== TARGET_PACKAGE_INDEX && index !== TARGET_DIE_INDEX && ![IMPEDANCE_SOCKET, IMPEDANCE_INTERPOSER_LAYOUT].includes(type)) {
      const powerDomains = layoutPowerDomains[layoutDesignId] || [];
      const VRMs = powerDomains.map(pow => (pow.VRM && pow.VRM.map(vrm => vrm.VRM_COMP)) || []).flat(3);
      const PMICs = [...new Set(VRMs)].filter(vrm => !connectors.find(conn => conn.name === vrm));
      layout.PMICs = PMICs.map(pmic => getImpedanceLayoutComp(pmic, layoutDesignId, PMIC));
      let loadsMonitors = [];

      for (let powerDomain of powerDomains) {
        const DEBUG_MONITOR = powerDomain.DEBUG_MONITOR;
        const loads = powerDomain.Components.filter(item => item.usage === LOAD && item.name !== targetIC);
        loadsMonitors.push(...loads.map(load => ({ name: load.name, loadMonitor: load.loadMonitor || [] })));
        layout.ICs = layout.ICs.filter(item => item.name === targetIC)
        if (layoutDesignId === currentDesignId && !layout.ICs.length) {
          const ic = getImpedanceLayoutComp(targetIC, layoutDesignId, IC);
          layout.ICs.push(ic)
        }
        if (DEBUG_MONITOR.length) {
          for (let monitor of DEBUG_MONITOR) {
            const _monitor = monitor.filter(item => item.type === 'comp');
            const first = _monitor[0].name;
            const last = _monitor[_monitor.length - 1].name;
            if (layoutDesignId === currentDesignId) {
              layout.ICs = layout.ICs.filter(item => item.name === first)
              const firstIndex = layout.ICs.findIndex(item => item.name === first);
              if (firstIndex > -1 && !layout.ICs[firstIndex].to.find(item => item.designId === layoutDesignId && item.components.includes(last))) {
                layout.ICs[firstIndex].to.push({ designId: layoutDesignId, components: [last] })
              }
            } else {
              layout.ICs = []
              const firstIndex = layout.connectors.findIndex(item => item.name === first);
              if (firstIndex > -1 && !layout.connectors[firstIndex].to.find(item => item.designId === layoutDesignId && item.components.includes(last))) {
                layout.connectors[firstIndex].to.push({ designId: layoutDesignId, components: [last] })
              }
            }

            let lastIndex = layout.connectors.findIndex(item => item.name === last);
            if (lastIndex > -1 && !layout.connectors[lastIndex].from.find(item => item.designId === layoutDesignId && item.components.includes(first))) {
              layout.connectors[lastIndex].from.push({ designId: layoutDesignId, components: [first] })
            } else {
              lastIndex = layout.PMICs.findIndex(item => item.name === last);
              if (lastIndex > -1 && !layout.PMICs[lastIndex].from.find(item => item.designId === layoutDesignId && item.components.includes(first))) {
                layout.PMICs[lastIndex].from.push({ designId: layoutDesignId, components: [first] })
              }
            }
          }
        }
      }

      const anotherLoads = [...new Set(loadsMonitors.map(item => item.name))];
      anotherLoads.forEach(load => {
        const monitors = loadsMonitors.filter(item => item.name === load).map(item => item.loadMonitor).flat(1);
        const ic = getImpedanceLayoutComp(load, layoutDesignId, IC);
        monitors.forEach(monitor => {
          const _monitor = monitor.filter(item => item.type === 'comp');
          const last = _monitor[_monitor.length - 1].name;
          ic.to.push({ designId: layoutDesignId, components: [last] })
        })
        layout.ICs.push(ic);
      })

      layout.powerDomains = powerDomains.map(domain => ({ id: "", content: domain }));
      const doNotStuff = yield call(componentDoNotStuff.getDoNotStuff, layoutDesignId);
      const newDomains = getCompsBetweenPowerNets(layoutDesignId, layout.powerDomains, doNotStuff)
      let _domains = [];
      for (let newDomain of newDomains) {
        if (!newDomain.domainComps) {
          _domains.push(newDomain);
          continue;
        }
        const domainComps = yield call(updateComponentDecapModel, {
          components: newDomain.domainComps,
          prevComps: [],
          designId: layoutDesignId,
          voltage: newDomain.content.voltage || "1"
        })
        delete newDomain.domainComps;
        domainComps.forEach(cap => {
          const findIndex = newDomain.content.Components.findIndex(comp => comp.name === cap.name)
          if (findIndex < 0) {
            newDomain.content.Components.push(cap)
          } else if (newDomain.content.Components[findIndex].usage !== cap.usage) {
            newDomain.content.Components[findIndex].usage = cap.usage
          }
        })
        _domains.push(newDomain);
      }
      layout.powerDomains = _domains
      const _connectors = ((layout && layout.connectors) || []).filter(item => {
        return _domains.find(domain => {
          const vrms = domain.content.VRM.map(it => [...(it.VRM_COMP || []), it.inductance]).flat(2)
          return domain.content.Components.find(comp => comp.name === item.name && comp.usage === CONNECTOR && vrms.includes(comp.name))
        })
      })
      let ballSizeMapObj = new BallSizeMap({ ballSizeMap, comps: [...layout.ICs, ..._connectors], designId: layoutDesignId })
      layout.ballSizeMap = ballSizeMapObj.getBallSizeMap();

      const prevPortImpedanceNets = layout.portImpedanceNets || [];
      const _netExtensionData = getNetExtensionData(_data, currentDesignId)
      const portImpedanceNets = getPortImpedanceNets(layout.powerDomains, layoutDesignId, prevPortImpedanceNets, _netExtensionData, layout.type);
      layout.portImpedanceNets = portImpedanceNets;

    } else if (type === IMPEDANCE_SOCKET) {
      layout.socket = new ImpSocket()
    } else if (type === IMPEDANCE_INTERPOSER_LAYOUT) {
      let ballSizeMapObj = new BallSizeMap({ ballSizeMap, comps: layout.connectors, designId: layoutDesignId })
      layout.ballSizeMap = ballSizeMapObj.getBallSizeMap()
    }
  }
  yield put(updateLogs([{ type: 'normal', text: `[Layouts] Saving...` }]))
  yield delay(100)
  yield call(saveLayouts, { data: _data, update: true, verificationId });

  const { CascadeReducer: { Impedance: { data: newData = [] } } } = yield select();
  yield* extraLoads.map(function* (load) {
    const { compNames, powerNet, designId } = load;
    const findIndex = newData.findIndex(item => item.designId === designId);
    if (findIndex >= 0) {
      const domain = newData[findIndex].powerDomains.find(item => item.content.MAIN_POWER_NETS.some(net => powerNet === net));
      const id = domain.id;
      if (id) {
        yield call(getVRMfromNewLoad, { id, compNames, postDesignId: designId })
      }
    }
  })

  yield put(updateImpedanceLoading(false));

  const pkg = _data.find(item => item.type === IMPEDANCE_PACKAGE)
  if (pkg) {
    yield call(updatePackageDomain, pkg.designId, true)
  }
  yield put(updateLogs([{ type: 'normal', text: `[Layouts] Trace completed.` }]))
}

function* saveSetup() {
  const { CascadeReducer: { Impedance } } = yield select();
  try {
    const verificationId = Impedance.verificationId
    if (!verificationId) {
      return;
    }
    yield call(saveImpedanceSetup, {
      verificationId,
      content: {
        ...new ImpSetup(Impedance)
      }
    })
  } catch (error) {
    console.error(error)
  }
}

function* saveLayouts(action) {
  let { data, update = false, verificationId } = action;
  const { CascadeReducer: { Impedance: { verificationId: currentVerificationId } } } = yield select();
  try {
    // check data error,update readyForSim: 0 / 1
    const { data: newData } = ImpedanceErrorCheck(data);
    data = newData;
    const res = yield call(saveImpedanceDomain, {
      verificationId: verificationId || currentVerificationId,
      layouts: data
    });
    if (update && (!verificationId || verificationId === currentVerificationId)) {
      yield put(updateImpedanceContent({ data: res && res.layouts ? res.layouts : [] }));
      yield put(updateImpedanceStatus(true));
    }
  } catch (error) {
    console.error(error)
  }
}

function* autoSave() {
  let lastTask;
  while (true) {
    const newAction = yield take([SAVE_POWER_DOMAIN]);
    let delayTime = 2000;
    if (newAction.type === SAVE_POWER_DOMAIN) {
      delayTime = 2000;
      if (lastTask) {
        yield cancel(lastTask);
      }
      lastTask = yield fork(debounce, delayTime, saveLayouts, newAction);
    }
  }
};

function* debounce(time = 0, callback, info) {
  yield delay(time);
  yield call(callback, info);
}

function* addRowForDomain() {
  const { CascadeReducer: { Impedance: { data, page, verificationId } } } = yield select();
  if (page === OVERVIEW) {
    return;
  }
  const index = data.findIndex(item => item.designId === page);
  if (index < 0) {
    return;
  }
  let _data = [...data];
  _data[index].powerDomains = [..._data[index].powerDomains, {
    id: '',
    content: _data[index].type === IMPEDANCE_PACKAGE ? new ImpPackageDomain({}) : {
      Components: [],
      DEBUG_MONITOR: [],
      MAIN_POWER_NETS: [],
      MAIN_REF_NETS: [],
      PowerNets: [],
      ReferenceNets: [],
      VRM: [],
      includeExtended: true
    }
  }]
  yield call(saveLayouts, { data: _data, update: true, verificationId })
}

function* changeNets(action) {
  const { CascadeReducer: { Impedance: { targetIC, data, page, Options, limitBoundaryPowerPinsLumpedPort, verificationId } } } = yield select();
  const { id, nets } = action;
  if (page === OVERVIEW) {
    return;
  }
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === page);
  if (findIndex < 0) { return };
  const index = _data[findIndex].powerDomains.findIndex(item => item.id === id);
  if (index < 0) { return }
  const isPreLayout = designConstructor.isPreLayout(page);
  let currentData = _data[findIndex].powerDomains[index];
  currentData.content = { ...currentData.content, ...nets }
  const { id: _id, content } = currentData;
  const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [], PowerNets, ReferenceNets, includeExtended, extraNets = [], extraVRM, Components = [] } = content;
  const setting = yield call(componentSetting.getPrefixLib, page);
  const doNotStuff = yield call(componentDoNotStuff.getDoNotStuff, page);
  const table = yield call(compTableHelper.getTableData, page);
  const _pinConnection = yield call(compPinMap.getPinConnection, page);
  const pinConnection = yield call(getPowerSwitchPinMap, _pinConnection);
  const pinMap = yield call(getImpedancePinMap, page);
  const fromPmic = Options ? Options.fromPmic : false;
  if (PowerNets && PowerNets.length && ReferenceNets && ReferenceNets.length) {
    const pinMapSense = yield call([pinMapStore, pinMapStore.getPinMapSense], page, "pinName")
    let VRMInfo = yield call(_getVRM,
      {
        designId: page,
        GroundNets: [...MAIN_REF_NETS],
        PowerNets: [...MAIN_POWER_NETS],
        ExtendNets: [],
        ExistNets: PowerNets.filter(item => !MAIN_POWER_NETS.includes(item)),
        COMP_PREFIX_LIB: setting,
        loadSelect: [{ comp: targetIC }],
        connectInductance: false,
        findExtend: includeExtended,
        isAC: true,
        PMIC: getPMIC(setting),
        powerSwitch: setting.powerSwitch,
        buckConverter: setting.discreteBuckConverter || [],
        doNotStuff,
        table,
        pinMapSense,
        pinConnection,
        pinMap,
        extraNets,
        fromPmic
      })

    yield put(updateLogs(VRMInfo.logs || []))

    VRMInfo.Components = yield call(updateComponentDecapModel, {
      components: VRMInfo.Components,
      prevComps: Components,
      page,
      voltage: "1"
    })

    let ports = limitBoundaryPowerPinsLumpedPort ? getPowerPinsLumpedPort(page, targetIC, MAIN_POWER_NETS, MAIN_REF_NETS) : []
    let pmicPorts = []
    if (isPreLayout) {
      ports = VRMInfo.ports ? VRMInfo.ports : ports
      pmicPorts = VRMInfo.pmicPorts ? VRMInfo.pmicPorts : []
    }
    currentData = {
      id: _id,
      content: {
        voltage: "1",
        ...VRMInfo,
        includeExtended: true,
        ReferenceNets: [...MAIN_REF_NETS],
        PowerNets: [...new Set([...PowerNets, ...VRMInfo.PowerNets])],
        MAIN_POWER_NETS: MAIN_POWER_NETS,
        MAIN_REF_NETS: MAIN_REF_NETS,
        extraNets: [...extraNets],
        extraVRM: [...extraVRM],
        ports: ports,
        target: []
      }
    }
    if (isPreLayout) {
      currentData.content.ports = ports
      currentData.content.pmicPorts = pmicPorts
    }
  }
  _data[findIndex].powerDomains[index] = currentData;
  const newPowerDomains = _data[findIndex].powerDomains.map(item => ({ id: item.id, ...item.content }));
  const VRMs = newPowerDomains.map(pow => (pow.VRM && pow.VRM.map(vrm => vrm.VRM_COMP)) || []).flat(3);
  const PMICs = [...new Set(VRMs)].filter(vrm => !_data[findIndex].connectors.find(conn => conn.name === vrm));
  _data[findIndex].PMICs = PMICs.map(pmic => getImpedanceLayoutComp(pmic, page, PMIC));
  yield call(saveLayouts, { data: _data, update: true, verificationId });
}

function* changeExtraNets(action) {
  const { CascadeReducer: { Impedance: { targetIC, data, page, designId: mainDesignId, verificationId } } } = yield select();
  const { id, nets } = action;
  if (page === OVERVIEW) {
    return;
  }
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === page);
  if (findIndex < 0) { return };
  const index = _data[findIndex].powerDomains.findIndex(item => item.id === id);
  if (index < 0) { return }
  const designId = page
  const netExtensionType = _data[findIndex].netExtensionType || SENSE
  const connectors = _data[findIndex].connectors
  let currentData = _data[findIndex].powerDomains[index];
  const layoutPowerNets = _data[findIndex].powerDomains.map(item => item.content ? [...(item.content.PowerNets || []), ...(item.content.extraNets || [])] : []).flat(2)
  currentData.content = { ...currentData.content, ...nets }
  const { id: _id, content } = currentData;
  const { PowerNets = [], extraNets = [], VRM, ReferenceNets = [], DEBUG_MONITOR = [], extraVRM = [], voltage } = content;
  let { Components = [] } = content
  const doNotStuff = yield call(componentDoNotStuff.getDoNotStuff, page);
  const table = yield call(compTableHelper.getTableData, page);
  const _pinConnection = yield call(compPinMap.getPinConnection, page);
  const pinConnection = yield call(getPowerSwitchPinMap, _pinConnection);
  let chips = []
  if (designId === mainDesignId) {
    chips.push(targetIC)
  } else {
    const connectorRule = (item) => { return item.from.length && item.from.every(f => f.designId !== designId) }
    const { trueArray: fromConnectors } = splitArrayToArrays({ array: connectors.filter(item => item.from.length || item.to.length), rule: connectorRule });
    for (let connector of fromConnectors) {
      const { name } = connector;
      chips.push(name);
    }
  }
  let _Components = getCascadeComponentsByNets(designId, [...extraNets, ...PowerNets]);
  let powerPinComps = [];
  for (let item of VRM || []) {
    item.powerPin && powerPinComps.push(...item.powerPin.map(it => it.comp))
  }
  yield put(updateImpedanceLoading('Loading...'));
  _Components = _Components.map(item => {
    const { name, type, pins, value, partName, partNumber } = item;

    let component = {
      name,
      COMP_TYPE: type,
      usage: type,
      pins: [...pins.values()],
      value,
      part: partName,
      partNumber: partNumber || undefined,
      isMultiNets: false,
      model: type === CAP ? { id: "", name: "" } : undefined
    }

    component.pins = component.pins.filter(pin => [...PowerNets, ...extraNets, ...ReferenceNets].includes(pin.net));
    if (type === CAP && !(component.pins.some(pin => ReferenceNets.includes(pin.net)) || (component.pins.every(pin => layoutPowerNets.includes(pin.net))))) {
      return null;
    }

    if ([SWITCH, JUMPER, FERRITE, RES, IND].includes(type)) {
      component.pins = component.pins.filter(pin => !ReferenceNets.includes(pin.net))
      component.usage = component.COMP_TYPE;
      if (component.pins.length > 2) {
        const connection = pinConnection.find(p => p.partNumber === component.partName) || { pinMap: [] };
        let pinNumbers = component.pins.map(pin => pin.pin);
        const _pins = connection.pinMap ? connection.pinMap.filter(map => map && map[0] && map[1] && (pinNumbers.includes(map[0]) || pinNumbers.includes(map[1]))).flat(2) : [];
        let pinMap = _pins.length ? _pins : [];
        if (!pinMap.length) {
          pinNumbers.sort((a, b) => a - b);
          for (let i = 0; i < Math.floor(pinNumbers.length / 2); i++) {
            if (pinNumbers[i]) {
              pinMap.push(pinNumbers[i])
            }
            if (pinNumbers[pinNumbers.length - 1 - i]) {
              pinMap.push(pinNumbers[pinNumbers.length - 1 - i])
            }
          }
        }
        component.pinMap = pinMap;
      }
    } else if (type === CAP) {
      if ([...new Set(component.pins.map(pin => pin.net))].length > 2) {
        component.isMultiNets = true;
      }
      component.value = "";
    }

    if (doNotStuff.includes(name)) {
      return { ...component, usage: IGNORE };
    }

    if ([RES, FERRITE, JUMPER, SWITCH, IND].includes(type)) {
      let itemData = table.find(data => data.name && data.name.includes(name))
      let value = itemData ? (parseFloat(itemData.value) === 0 ? '0' : itemData.value + itemData.unit) : '0'
      return { ...component, value }
    } else if (chips.includes(name)) {
      return { ...component, usage: LOAD }
    }
    return component
  }).filter(item => !!item)

  let mergeComponents = []

  // key - load, value :[ ...vrmComps ]
  let monitorComps = new Map()
  const anotherLoadComps = Components.filter(item => item.usage === LOAD && !chips.includes(item.name))
  anotherLoadComps.forEach(item => {
    monitorComps.set(item.name, item.loadMonitor && item.loadMonitor.length ? item.loadMonitor.flat().filter(item => item.type === 'comp').map(item => item.name) : [])
  })
  if (chips.length) {
    chips.forEach(chip => monitorComps.set(chip, DEBUG_MONITOR && DEBUG_MONITOR.length ? DEBUG_MONITOR.flat().filter(item => item.type === 'comp').map(item => item.name) : []))
  }
  const loads = monitorComps.keys()
  const filterLoad = [];
  const currentLoad = [];
  loads.forEach(load => {
    (_Components.map(item => item.name).includes(load) ? currentLoad : filterLoad).push(load);
  });
  if (filterLoad.length) {
    const currentComps = [...new Set(currentLoad.map(item => { return [...monitorComps.get(item)] }).flat())]
    filterLoad.forEach(item => {
      const filterComps = monitorComps.get(item)
      if (filterComps && filterComps.length) {
        Components = Components.map(comp => {
          if (filterComps.includes(comp.name) && !currentComps.includes(comp.name)) {
            return { ...comp, usage: IGNORE }
          }
          return { ...comp }
        })
      }
    })
    _data[findIndex].ICs = _data[findIndex].ICs.filter(item => !filterLoad.includes(item.name))
  }

  _Components.forEach(_comp => {
    if (_comp && _comp.name) {
      if (Components.map(comp => comp.name).includes(_comp.name)) {
        mergeComponents.push(Components.find(comp => comp.name === _comp.name))
      } else {
        mergeComponents.push(_comp)
      }
    }
  })
  const newExtraNets = nets.extraNets;
  const newComponents = getCascadeComponentsByNets(designId, [...newExtraNets]);
  const prevComponentNames = Components.map(comp => comp.name);
  let newLoads = netExtensionType === SENSE ? newComponents.filter(item => item.type === IGNORE && !prevComponentNames.includes(item.name) && !doNotStuff.includes(item.name)) : []
  const prevLoadComponents = Components.filter(item => item.usage === LOAD).map(comp => comp.name);
  const newLoadComponents = newComponents.filter(item => prevLoadComponents.includes(item.name) && !doNotStuff.includes(item.name));
  newLoadComponents.forEach(nl => {
    if (!newLoads.find(load => load.name === nl.name)) {
      newLoads.push(nl)
    }
  })

  mergeComponents = yield call(updateComponentDecapModel, {
    components: mergeComponents,
    prevComps: Components,
    designId: designId,
    voltage: voltage || "1"
  })
  mergeComponents = SortComponents(mergeComponents, chips)

  const _extraVRM = [...extraVRM].filter(item => {
    const { powerPin = [] } = item;
    for (let power of powerPin) {
      const { comp, pins = [] } = power;
      const compInfo = getCascadeComponents({ pcbId: designId, name: comp });
      if (!compInfo) {
        return false
      }
      const _pins = [...compInfo.pins.values()].filter(pin => pins.includes(pin.pin));
      const nets = _pins.map(pin => pin.net);
      return nets.some(net => extraNets.includes(net))
    }
    return false
  });

  currentData = {
    id: _id,
    content: {
      ...content,
      extraVRM: _extraVRM,
      Components: mergeComponents
    }
  }
  _data[findIndex].powerDomains[index] = currentData;

  if (!newLoads || !newLoads.length) {
    const netExtensionData = getNetExtensionData(_data, mainDesignId)
    const portImpedanceNets = getPortImpedanceNets(_data[findIndex].powerDomains, _data[findIndex].designId, _data[findIndex].portImpedanceNets, netExtensionData, _data[findIndex].type);
    _data[findIndex].portImpedanceNets = portImpedanceNets;
  }

  yield call(saveLayouts, { data: _data, update: true, verificationId });
  yield put(updateImpedanceLoading(false));

  if (newLoads && newLoads.length) {
    yield* newLoads.map(function* (load) {
      const { name, partName } = load
      yield call(changeUsage, { compNames: [name], part: partName, id, usage: LOAD })
    })
  }
}

function* reGetDomainRowInfo(action) {
  const { row } = action;
  const { CascadeReducer: { Impedance: { verificationId, targetIC, data, page, designId: currentDesignId, Options, powerNetSelect: { select: powerNets }, targetDie, packageRelationship = [], limitBoundaryPowerPinsLumpedPort } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === page);
  if (findIndex < 0) { return };
  let loadSelect = [{ comp: targetIC }]
  const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [], id, PowerNets, ReferenceNets, includeExtended, extraNets = [], extraVRM = [], Components = [] } = row;
  if (!MAIN_POWER_NETS.length || !MAIN_REF_NETS.length) {
    return;
  }
  const currentIndex = _data[findIndex].powerDomains.findIndex(item => item.id === id);
  const current = _data[findIndex].powerDomains[currentIndex] || null;
  if (current) {
    const content = current.content;
    if (content.PowerNets.length && content.ReferenceNets.length &&
      _.isEqual(PowerNets, content.PowerNets) &&
      _.isEqual(ReferenceNets, content.ReferenceNets)) {
      return;
    }
  }
  const fromPmic = Options ? Options.fromPmic : false;

  if (_data[findIndex].designId === page) {
    const newSelect = [...new Set([...powerNets, ...MAIN_POWER_NETS])]
    yield put(updateSelectPowerNets({ select: newSelect }));
    const pkg = data.find(item => item.index === TARGET_PACKAGE_INDEX);
    if (pkg) {
      let _packageRelationship = [...packageRelationship];
      const pcbId = pkg.designId;
      const isPreLayout = designConstructor.isPreLayout(pcbId);
      let setting = new CascadeCompRLCPrefixLib({})
      if (isPreLayout) {
        yield call([preLayoutData, preLayoutData.getPreLayout], pcbId)
      } else if (IMPEDANCE_POST_LIST.includes(pkg.type)) {
        setting = yield call([componentSetting, componentSetting.getPrefixLib], pcbId);
        yield call(getAuroraDB, pcbId);
      }

      const { BGA } = getPackagePowerDomain(pcbId, setting, targetDie);
      if (BGA.name) {
        const { nets } = checkConnectCompsPinsAndNets({ designId: page, name: targetIC, nets: [...MAIN_POWER_NETS] }, { designId: pcbId, name: BGA.name })
        _packageRelationship.push({ [IMPEDANCE_PCB]: [...MAIN_POWER_NETS], [IMPEDANCE_PACKAGE]: [...nets] })
        yield put(setPackageRelationship(_packageRelationship))
      }
    }
  }

  const setting = yield call(componentSetting.getPrefixLib, page);
  const doNotStuff = yield call(componentDoNotStuff.getDoNotStuff, page);
  const table = yield call(compTableHelper.getTableData, page);
  const pinMapSense = yield call([pinMapStore, pinMapStore.getPinMapSense], page, "pinName");
  const _pinConnection = yield call(compPinMap.getPinConnection, page);
  const pinConnection = yield call(getPowerSwitchPinMap, _pinConnection);
  const pinMap = yield call(getImpedancePinMap, page);
  const connectors = _data[findIndex].connectors;
  const connectorRule = (item) => { return item.from.length && item.from.every(f => f.designId !== page) }
  const { trueArray: fromConnectors, falseArray: toConnectors } = splitArrayToArrays({ array: connectors, rule: connectorRule });
  let VRMInfo = {};
  let ports = []
  const netExtensionData = getNetExtensionData(_data, currentDesignId)
  const hasPassiveBoard = _data.find(layout => layout.asPassiveBoard === true) ? true : false
  if (currentDesignId && currentDesignId === page) {
    const specify = toConnectors.map(connector => { return getFindVRMSpecifyComp(connector, page) });
    VRMInfo = yield call(_getVRM,
      {
        designId: page,
        GroundNets: [...MAIN_REF_NETS],
        PowerNets: [...MAIN_POWER_NETS],
        ExtendNets: [],
        ExistNets: PowerNets.filter(item => !MAIN_POWER_NETS.includes(item)),
        COMP_PREFIX_LIB: setting,
        loadSelect,
        connectInductance: false,
        findExtend: includeExtended,
        isAC: true,
        PMIC: getPMIC(setting),
        powerSwitch: setting.powerSwitch,
        buckConverter: setting.discreteBuckConverter || [],
        doNotStuff,
        table,
        pinMapSense,
        pinConnection,
        pinMap,
        extraNets,
        specify,
        connectors: toConnectors.map(to => to.name),
        fuzzyMatch: true,
        fromPmic,
        hasPassiveBoard
      })
    ports = limitBoundaryPowerPinsLumpedPort ? getPowerPinsLumpedPort(page, targetIC, MAIN_POWER_NETS, MAIN_REF_NETS) : []
  } else {
    const specify = toConnectors.map(connector => { return getFindVRMSpecifyComp(connector, page) });
    const chips = fromConnectors.map(connector => {
      const { name, from } = connector;
      let _nets = [];
      for (let f of from) {
        const { nets } = f;
        if (!nets) {
          continue
        }
        _nets.push(...(nets[`${name}-${page}`] || []));
      }
      return _nets.some(net => MAIN_POWER_NETS.includes(net)) ? name : null;
    }).filter(item => !!item).map(name => ({ comp: name }));
    const powerDomains = _data[findIndex].powerDomains || [];
    const filterPMICs = powerDomains.map(item => {
      if (!item.content) {
        return [];
      }
      let filterSensePMICs = []
      const vrms = item.content.VRM ? item.content.VRM.map(vrm => vrm.VRM_COMP).flat(2) : [];
      filterSensePMICs.push(...vrms);
      return filterSensePMICs
    }).flat(3);
    VRMInfo = yield call(_getVRM, {
      designId: page,
      GroundNets: [...MAIN_REF_NETS],
      PowerNets: [...MAIN_POWER_NETS],
      ExtendNets: [],
      COMP_PREFIX_LIB: setting,
      loadSelect: chips,
      connectInductance: false,
      findExtend: true,
      isAC: true,
      PMIC: getPMIC(setting),
      powerSwitch: setting.powerSwitch,
      buckConverter: setting.discreteBuckConverter || [],
      doNotStuff,
      table,
      pinMapSense,
      pinConnection,
      pinMap,
      specify,
      fuzzyMatch: true,
      connectors: [...chips.map(c => c.name), ...toConnectors.map(to => to.name)],
      extraNets,
      fromPmic,
      fullPaths: netExtensionData[page] && netExtensionData[page].some(net => MAIN_POWER_NETS.includes(net)) ? true : false,
      filterPMICs: netExtensionData[page] && netExtensionData[page].some(net => MAIN_POWER_NETS.includes(net)) ? filterPMICs : []
    })
    const comp = chips && chips.length ? chips[0].comp : ''
    ports = limitBoundaryPowerPinsLumpedPort ? getPowerPinsLumpedPort(page, comp, MAIN_POWER_NETS, MAIN_REF_NETS) : []
  }

  yield put(updateLogs(VRMInfo.logs || []))

  VRMInfo.Components = yield call(updateComponentDecapModel, {
    components: VRMInfo.Components,
    prevComps: Components,
    page,
    voltage: "1"
  })

  const isPreLayout = designConstructor.isPreLayout(page)
  let _newInfo = { ...VRMInfo, ports }
  if (isPreLayout) {
    _newInfo.ports = VRMInfo.ports ? VRMInfo.ports : []
    _newInfo.pmicPorts = VRMInfo.pmicPorts ? VRMInfo.pmicPorts : []
  }
  const newInfo = current ? mergeVRMInfo(VRMInfo, current.content, isPreLayout) : _newInfo;
  let newRow = {
    id,
    content: {
      ...newInfo,
      ReferenceNets: [...MAIN_REF_NETS],
      PowerNets: [...new Set([...PowerNets, ...VRMInfo.PowerNets])],
      MAIN_POWER_NETS: MAIN_POWER_NETS,
      MAIN_REF_NETS: MAIN_REF_NETS,
      extraNets: [...extraNets],
      extraVRM
    }
  }
  if (currentIndex > -1) {
    _data[findIndex].powerDomains[currentIndex] = newRow;
  } else {
    _data[findIndex].powerDomains.push(newRow);
  }
  const newDomains = getCompsBetweenPowerNets(page, _data[findIndex].powerDomains, doNotStuff)
  let _domains = [];
  for (let newDomain of newDomains) {
    if (!newDomain.domainComps) {
      _domains.push(newDomain);
      continue;
    }
    const domainComps = yield call(updateComponentDecapModel, {
      components: newDomain.domainComps,
      prevComps: [],
      designId: page,
      voltage: newDomain.content.voltage || "1"
    })
    delete newDomain.domainComps;
    domainComps.forEach(cap => {
      const findIndex = newDomain.content.Components.findIndex(comp => comp.name === cap.name)
      if (findIndex < 0) {
        newDomain.content.Components.push(cap)
      } else if (newDomain.content.Components[findIndex].usage !== cap.usage) {
        newDomain.content.Components[findIndex].usage = cap.usage
      }
    })
    _domains.push(newDomain);
  }
  _data[findIndex].powerDomains = newDomains;

  const newPowerDomains = _data[findIndex].powerDomains.map(item => ({ id: item.id, ...item.content }));
  const VRMs = newPowerDomains.map(pow => (pow.VRM && pow.VRM.map(vrm => vrm.VRM_COMP)) || []).flat(3);
  const PMICs = [...new Set(VRMs)].filter(vrm => !_data[findIndex].connectors.find(conn => conn.name === vrm));
  _data[findIndex].PMICs = PMICs.map(pmic => getImpedanceLayoutComp(pmic, page, PMIC));

  for (let powerDomain of newPowerDomains) {
    const DEBUG_MONITOR = powerDomain.DEBUG_MONITOR;
    if (DEBUG_MONITOR && DEBUG_MONITOR.length) {
      for (let monitor of DEBUG_MONITOR) {
        const _monitor = monitor.filter(item => item.type === 'comp');
        const first = _monitor[0].name;
        const last = _monitor[_monitor.length - 1].name;
        let lastIndex = _data[findIndex].PMICs.findIndex(item => item.name === last);
        if (lastIndex > -1 && !_data[findIndex].PMICs[lastIndex].from.find(item => item.designId === page && item.components.includes(first))) {
          _data[findIndex].PMICs[lastIndex].from.push({ designId: page, components: [first] })
        }
      }
    }
  }

  try {
    yield call(saveLayouts, { data: _data, update: true, verificationId });
    yield call(saveSetup)
  } catch (e) {
    console.error(e)
  }
}

function* deletePowerDomains(action) {
  const { id } = action;
  const { CascadeReducer: { Impedance: { data, page, verificationId, designId, packageRelationship = [], powerNetSelect: { select: powerNets } } } } = yield select();
  if (page === OVERVIEW) {
    return;
  }
  let _data = [...data]
  const designIndex = data.findIndex(item => item.designId === page);
  if (designIndex < 0) {
    return;
  }
  const delData = data[designIndex].powerDomains.find(item => item.id === id);
  if (designId === page && delData.content && delData.content.MAIN_POWER_NETS) {
    const newSelect = powerNets.filter(item => !delData.content.MAIN_POWER_NETS.includes(item));
    yield put(updateSelectPowerNets({ select: newSelect }));
    const pkg = data.find(item => item.index === TARGET_PACKAGE_INDEX);
    if (pkg) {
      let _packageRelationship = [...packageRelationship].filter(item => item[IMPEDANCE_PCB] && !item[IMPEDANCE_PCB].some(net => delData.content.MAIN_POWER_NETS.includes(net)));
      yield put(setPackageRelationship(_packageRelationship))
    }
  }

  const powerNet = delData.content.MAIN_POWER_NETS && delData.content.MAIN_POWER_NETS.length ? delData.content.MAIN_POWER_NETS[0] : null
  _data[designIndex].powerDomains = _data[designIndex].powerDomains.filter(item => item.id !== id);
  if (data[designIndex].type === IMPEDANCE_PCB) {
    const vrms = _data[designIndex].powerDomains.map(item => item.content && item.content.VRM ? item.content.VRM.map(i => i.VRM_COMP) : []).flat(3);
    _data[designIndex].PMICs = _data[designIndex].PMICs.filter(item => vrms.includes(item.name));
  } else if (data[designIndex].type === IMPEDANCE_PACKAGE) {
    const newDIEs = _data[designIndex].powerDomains.map(domain => domain && domain.content ? domain.content.Components.filter(item => item.COMP_TYPE === DIEConst) : []).flat(3);
    const newDIENames = [...new Set(newDIEs.map(item => item.name))];
    const removeDie = _data[designIndex].Dies.find(item => !newDIENames.includes(item.name));
    if (removeDie && removeDie.name) {
      const _ballSizeMap = _data[designIndex].ballSizeMap
      delete _ballSizeMap[removeDie.name]
      _data[designIndex].ballSizeMap = _ballSizeMap
    }
    _data[designIndex].Dies = _data[designIndex].Dies.filter(item => newDIENames.includes(item.name));

    const dieIndex = _data.findIndex(item => item.index === TARGET_DIE_INDEX)
    if (dieIndex > -1) {
      let ics = _data[dieIndex].ICs
      ics = ics.filter(ic => newDIENames.includes(ic.to[0].components[0]) && ic.powerNet !== powerNet)
      _data[dieIndex].ICs = ics
    }
    yield put(updateImpedanceContent({ targetDie: newDIENames }));
  }
  try {
    yield put(updateImpedanceContent({ data: _data, status: true }));
    yield call(deleteImpedanceDomains, { verificationId, designId: page, ids: [id] });
    yield call(saveLayouts, { data: _data, update: true, verificationId });
    yield call(saveSetup)
  } catch (error) {
    message.error('Delete power domain failed!');
    console.error(error)
  }
}

function* saveVRM(action) {
  const { key } = action;
  switch (key) {
    case 'model':
      yield call(saveVRMModel, action);
      break;
    case 'comp':
      yield call(saveVRMComp, action);
      break;
    case 'voltage':
      yield call(saveVoltage, action);
      break;
    default: break;
  }
}

function* saveVoltage(action) {
  const { id, voltage, designId } = action.params;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  let _data = [...data]
  if (page === OVERVIEW && !designId) {
    return;
  }
  const _designId = designId || page;
  const layoutIndex = _data.findIndex(item => item.designId === _designId);
  const rowIndex = _data[layoutIndex].powerDomains.findIndex(item => item.id === id);
  const row = _data[layoutIndex].powerDomains[rowIndex] || null;
  if (!row) {
    return;
  }
  const newRow = { ...row };
  newRow.content.voltage = voltage;
  let vrmComps = [];
  (newRow.content.VRM || []).forEach(item => {
    vrmComps.push(...(item.VRM_COMP || []))
    item.voltage = voltage
  })
  vrmComps = [...new Set(vrmComps)]
  vrmComps.forEach(item => {
    _data[layoutIndex].PMICs.forEach(pmic => {
      if (pmic.name === item) {
        pmic.voltage = voltage
      }
    })
  })
  yield put(updateImpedanceContent({ data: _data, status: true }));

  yield delay(100)
  const info = yield call(updateComponentDecapModel, {
    designId: _designId,
    components: newRow.content.Components.map(item => ({ ...item, model: {} })),
    prevComps: [],
    existModelParts: [],
    type: "re-assign",
    saveLib: false,
    voltage: voltage || "1"
  });
  newRow.content.Components = info.components;

  _data[layoutIndex].powerDomains[rowIndex] = newRow;
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* saveVRMModel(action) {
  const { id, vrm } = action.params;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  let _data = [...data];
  if (page === OVERVIEW) {
    return;
  }
  const layoutIndex = _data.findIndex(item => item.designId === page);
  const rowIndex = _data[layoutIndex].powerDomains.findIndex(item => item.id === id);
  const row = _data[layoutIndex].powerDomains[rowIndex] || null;
  if (!row) {
    return;
  }
  const newRow = { ...row };
  newRow.content.VRM = newRow.content.VRM.map(item => {
    return { ...item, model: { id: vrm.id, name: vrm.name } }
  })
  _data[layoutIndex].powerDomains[rowIndex] = newRow;
  yield put(updateImpedanceContent({ data: _data, status: false }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* saveVRMComp(action) {
  const { id, VRM } = action.params;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  let _data = [...data];
  if (page === OVERVIEW) {
    return;
  }
  const layoutIndex = _data.findIndex(item => item.designId === page);
  const rowIndex = _data[layoutIndex].powerDomains.findIndex(item => item.id === id);
  const row = _data[layoutIndex].powerDomains[rowIndex] || null;
  if (!row) {
    return;
  }
  const newRow = { ...row };
  newRow.content.VRM = VRM;
  const VRMs = newRow.content.VRM.map(vrm => vrm.VRM_COMP).flat();
  newRow.content.Components.forEach(comp => {
    if ([PMIC].includes(comp.usage) && !VRMs.includes(comp.name)) {
      comp.usage = IGNORE;
      comp.model = undefined;
    }
  })
  _data[layoutIndex].powerDomains[rowIndex] = newRow;
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* saveRLCValue(action) {
  const { rowData, value } = action;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  const { components } = rowData;
  const compName = components.map(item => item.name);
  let newData = [...data];
  const findIndex = newData.findIndex(item => item.designId === page);
  if (findIndex < 0) {
    return;
  }
  newData[findIndex].powerDomains.forEach(item => {
    item.content.Components = item.content.Components.map(comp => {
      if (compName.includes(comp.name)) {
        return { ...comp, value }
      } else {
        return { ...comp }
      }
    })
  })

  yield put(updateImpedanceContent({ data: newData, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: newData });
}

function* saveRLModel(action) {
  const { model, value, part, components } = action;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  const compName = components.map(item => item.name);
  let newData = [...data];
  const findIndex = newData.findIndex(item => item.designId === page);
  if (findIndex < 0) {
    return;
  }
  newData[findIndex].powerDomains.forEach(item => {
    item.content.Components = item.content.Components.map(comp => {
      if (comp.part === part && compName.includes(comp.name)) {
        if (model.type === 'value') {
          comp.value = value;
        }
        comp.model = { ...model };
      }
      return { ...comp }
    })
  })
  yield put(updateImpedanceContent({ data: newData, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: newData });
}

function* saveModel(action) {
  const { record, value, models, apply, applyToAll, applyModelList = [], applySweep } = action;

  const { CascadeReducer: { Impedance: { data, page }, project: { openProjectId } } } = yield select();
  const { part, components, pcbId } = record;
  const compName = components.map(item => item.name);
  let newData = [...data];
  let findIndex
  if (page === OVERVIEW) {
    findIndex = newData.findIndex(item => item.designId === pcbId);
  } else {
    findIndex = newData.findIndex(item => item.designId === page);
  }
  if (findIndex < 0) {
    return;
  }
  models.forEach(model => {
    delete model.matchWeights;
  })
  const _applySweep = models.length > 1 && applySweep

  if (apply) {
    newData.forEach(layout => {
      layout.powerDomains.forEach(item => {
        item.content.Components = item.content.Components.map(comp => {
          if (comp.part === part || compName.includes(comp.name)) {
            return { ...comp, value, models: models.map(model => { return { ...model, apply: applyToAll } }), applySweep: _applySweep };
          } else {
            if (comp.applySweep && _applySweep) {
              return { ...comp, applySweep: false }
            }
            return { ...comp }
          }
        })
      })
    })
  } else {
    newData[findIndex].powerDomains.forEach(item => {
      item.content.Components = item.content.Components.map(comp => {
        if (compName.includes(comp.name)) {
          return { ...comp, value, models: models.map(model => { return { ...model, apply: false } }), applySweep: _applySweep };
        } else {
          if (comp.applySweep && _applySweep) {
            return { ...comp, applySweep: false }
          }
          return { ...comp }
        }
      })
    })
  }
  yield put(updateImpedanceContent({ data: newData, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: newData });
  if (applyToAll) {
    try {
      yield call(updateLibSetting, { librarySettings: applyModelList, projectId: openProjectId })
      yield put(updateModelSetting(applyModelList))
    } catch (error) {
      console.error(error)
    }
  }
}

function* saveLoadModel(action) {
  const { record, model } = action;

  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  const { components, pcbId, powerDomainId } = record;
  const compName = components.map(item => item.name);
  let newData = [...data];
  let findIndex
  if (page === OVERVIEW) {
    findIndex = newData.findIndex(item => item.designId === pcbId);
  } else {
    findIndex = newData.findIndex(item => item.designId === page);
  }
  if (findIndex < 0) {
    return;
  }
  const powerDomainIndex = newData[findIndex].powerDomains.findIndex(item => item.id === powerDomainId)
  if (powerDomainIndex > -1) {
    newData[findIndex].powerDomains[powerDomainIndex].content.Components.forEach(comp => {
      if (compName.includes(comp.name)) {
        comp.model = model;
      }
    })
  }

  yield put(updateImpedanceContent({ data: newData, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: newData })
}

function* updateExtendNets(action) {
  const { checked, id } = action;

  const { CascadeReducer: { Impedance: { targetIC, data, designId, page, Options, verificationId } } } = yield select();
  let loadSelect = [{ comp: targetIC }];
  let newData = [...data];
  if (page === OVERVIEW) {
    return;
  }
  const layoutIndex = newData.findIndex(item => item.designId === page);
  const findIndex = newData[layoutIndex].powerDomains.findIndex(item => item.id === id);
  if (findIndex < 0) {
    return;
  }
  const setting = yield call(componentSetting.getPrefixLib, designId);
  const doNotStuff = yield call(componentDoNotStuff.getDoNotStuff, designId);
  let newRow = { ...newData[layoutIndex].powerDomains[findIndex] };
  const { content } = newRow;
  const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [], ReferenceNets = [], extraNets = [], extraVRM = [] } = content;
  const table = yield call(compTableHelper.getTableData, designId);
  const pinMapSense = yield call([pinMapStore, pinMapStore.getPinMapSense], designId, "pinName");
  const _pinConnection = yield call(compPinMap.getPinConnection, designId);
  const pinConnection = yield call(getPowerSwitchPinMap, _pinConnection);
  const pinMap = yield call(getImpedancePinMap, designId);
  const fromPmic = Options ? Options.fromPmic : false;
  const isPreLayout = designConstructor.isPreLayout(designId)
  const hasPassiveBoard = newData.find(layout => layout.asPassiveBoard === true) ? true : false
  let VRMInfo = yield call(_getVRM,
    {
      designId,
      GroundNets: [...MAIN_REF_NETS],
      PowerNets: [...MAIN_POWER_NETS],
      ExtendNets: [],
      COMP_PREFIX_LIB: setting,
      loadSelect,
      connectInductance: false,
      findExtend: checked,
      isAC: true,
      PMIC: getPMIC(setting),
      powerSwitch: setting.powerSwitch,
      buckConverter: setting.discreteBuckConverter || [],
      doNotStuff,
      table,
      pinMapSense,
      pinConnection,
      pinMap,
      extraNets,
      fromPmic,
      hasPassiveBoard
    })
  yield put(updateLogs(VRMInfo.logs || []))
  const newInfo = mergeVRMInfo(VRMInfo, content, isPreLayout);
  newData[layoutIndex].powerDomains[findIndex] = {
    id: id,
    content: {
      ...newInfo,
      includeExtended: checked,
      ReferenceNets: [...ReferenceNets],
      PowerNets: [...new Set([...MAIN_POWER_NETS, ...VRMInfo.PowerNets])],
      MAIN_POWER_NETS: MAIN_POWER_NETS,
      MAIN_REF_NETS: MAIN_REF_NETS,
      extraNets: [...extraNets],
      extraVRM
    }
  }
  yield call(saveLayouts, { data: newData, update: true, verificationId });
}

function* mergeCompByPart(action) {
  const { mergeList, info } = action;
  const { id, value, model, models } = info;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === page);
  if (findIndex < 0) {
    return;
  }
  const powerDomains = _data[findIndex].powerDomains;
  const index = powerDomains.findIndex(item => item.id === id);
  const currentData = powerDomains[index] || null;
  if (!currentData) {
    return;
  }
  currentData.content.Components.forEach(item => {
    if (mergeList.includes(item.part)) {
      item.part = mergeList[0];
      item.value = value;
      item.models = models;
    }
  })
  powerDomains[index] = currentData;
  _data[findIndex].powerDomains = powerDomains;
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* changeCompUsage(action) {
  const { compNames, part, checked, id } = action;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === page);
  if (findIndex < 0) {
    return;
  }
  const powerDomains = _data[findIndex].powerDomains;
  const index = powerDomains.findIndex(item => item.id === id);
  const currentData = powerDomains[index] || null;
  if (!currentData) {
    return;
  }

  currentData.content.Components.forEach(item => {
    if (item.part === part && compNames.includes(item.name)) {
      item.usage = item.COMP_TYPE === IGNORE ? IGNORE : checked ? item.COMP_TYPE : 'Unused';
    }
  })
  powerDomains[index] = currentData;
  _data[findIndex].powerDomains = powerDomains;
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* removeComp(action) {
  const { id, compNames, part } = action;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === page);
  if (findIndex < 0) {
    return;
  }
  const powerDomains = _data[findIndex].powerDomains;
  const index = powerDomains.findIndex(item => item.id === id);
  const currentData = powerDomains[index] || null;
  if (!currentData) {
    return;
  }
  currentData.content.Components.forEach(item => {
    if (item.part === part && compNames.includes(item.name)) {
      item.usage = 'Removed';
    }
  })
  powerDomains[index] = currentData;
  _data[findIndex].powerDomains = powerDomains;
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* splitComponent(action) {
  const { id, compList, part, newPart } = action;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === page);
  if (findIndex < 0) {
    return;
  }
  const powerDomains = _data[findIndex].powerDomains;
  const index = powerDomains.findIndex(item => item.id === id);
  const currentData = powerDomains[index] || null;
  if (!currentData) {
    return;
  }
  currentData.content.Components.forEach(item => {
    if (item.part === part && compList.includes(item.name)) {
      item.part = newPart;
    }
  })
  powerDomains[index] = currentData;
  _data[findIndex].powerDomains = powerDomains;
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* updateComponentPrefix(action) {
  const { update = true } = action;
  yield put(needUpdateCompSetting(false));

  if (!update) {
    const { CascadeReducer: { Impedance: { data, verificationId } } } = yield select();
    let _data = JSON.parse(JSON.stringify(data));

    yield* _data.map(function* (layout) {
      if (![IMPEDANCE_SOCKET, IMPEDANCE_DIE].includes(layout.type)) {
        const version = yield call(componentSetting.getVersion, layout.designId);
        layout.COMP_PREFIX_LIB = { version }
      }
    })
    yield call(saveLayouts, { data: _data, update: true, verificationId });
    return;
  }

  yield put(updateImpedanceLoading(true));
  const { CascadeReducer: { Impedance: { verificationId, targetIC, targetDie, designId: currentDesignId, powerNetSelect: { select: selectNets }, Options, limitBoundaryPowerPinsLumpedPort } } } = yield select();
  const res = yield call(getImpedanceInfo, verificationId);
  const data = res.layouts;
  let _data = JSON.parse(JSON.stringify(data));
  const netExtensionData = getNetExtensionData(_data, currentDesignId)
  yield put(updateImpedanceContent({ data, status: true }));
  const fromPmic = Options ? Options.fromPmic : false;
  const hasPassiveBoard = _data.find(layout => layout.asPassiveBoard === true) ? true : false
  yield* _data.map(function* (layout) {
    const { designId, connectors, COMP_PREFIX_LIB, powerDomains } = layout;
    let version = null
    if (![IMPEDANCE_SOCKET, IMPEDANCE_DIE].includes(layout.type)) {
      version = yield call(componentSetting.getVersion, designId);
    }
    const designName = designConstructor.getDesignName(designId) || layout.designName;
    const isPreLayout = designConstructor.isPreLayout(designId);
    if (layout.index !== TARGET_PACKAGE_INDEX && layout.index !== TARGET_DIE_INDEX && layout.type !== IMPEDANCE_SOCKET) {
      if (versionCompareSize(COMP_PREFIX_LIB.version, version)) {
        yield put(updateImpedanceLoading(`Tracing ${designName}...`));
        yield delay(100);
        yield call(getAuroraDB, designId);

        const connectorRule = (item) => { return item.from.length && item.from.every(f => f.designId !== designId) }
        const { falseArray: toConnectors } = splitArrayToArrays({ array: connectors.filter(item => item.from.length || item.to.length), rule: connectorRule });
        const setting = yield call(componentSetting.getPrefixLib, designId);
        const doNotStuff = yield call(componentDoNotStuff.getDoNotStuff, designId);
        const table = yield call(compTableHelper.getTableData, designId);
        const pinMapSense = yield call([pinMapStore, pinMapStore.getPinMapSense], designId, "pinName")
        const _pinConnection = yield call(compPinMap.getPinConnection, designId);
        const pinConnection = yield call(getPowerSwitchPinMap, _pinConnection);
        const pinMap = yield call(getImpedancePinMap, designId);
        if (designId === currentDesignId) {
          let loadSelect = [{ comp: targetIC }];
          const specify = toConnectors.map(connector => { return getFindVRMSpecifyComp(connector, designId) });
          let _powerDomains = []
          for (let row of powerDomains) {
            const { content, id } = row;
            const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [], includeExtended, extraNets = [] } = content;
            let VRMInfo = yield call(_getVRM, {
              designId: currentDesignId,
              GroundNets: [...MAIN_REF_NETS],
              PowerNets: [...MAIN_POWER_NETS],
              ExtendNets: [],
              COMP_PREFIX_LIB: setting,
              loadSelect,
              connectInductance: false,
              findExtend: includeExtended,
              isAC: true,
              PMIC: getPMIC(setting),
              powerSwitch: setting.powerSwitch,
              buckConverter: setting.discreteBuckConverter || [],
              doNotStuff,
              table,
              pinMapSense,
              pinConnection,
              pinMap,
              specify,
              fromPmic,
              connectors: [...toConnectors.map(to => to.name)],
              extraNets,
              hasPassiveBoard
            })
            yield put(updateLogs(VRMInfo.logs || []))
            const newInfo = mergeVRMInfo(VRMInfo, content, isPreLayout);
            let newRow = {
              id: id,
              content: {
                ...content,
                ...newInfo,
                PowerNets: [...new Set([...MAIN_POWER_NETS, ...VRMInfo.PowerNets])],
              }
            }
            _powerDomains.push(newRow)
          }
          const newDomains = getCompsBetweenPowerNets(designId, _powerDomains, doNotStuff)
          let _domains = [];
          for (let newDomain of newDomains) {
            if (!newDomain.domainComps) {
              _domains.push(newDomain);
              continue;
            }
            const domainComps = yield call(updateComponentDecapModel, {
              components: newDomain.domainComps,
              prevComps: [],
              designId: designId,
              voltage: newDomain.content.voltage || "1"
            })
            delete newDomain.domainComps;
            domainComps.forEach(cap => {
              const findIndex = newDomain.content.Components.findIndex(comp => comp.name === cap.name)
              if (findIndex < 0) {
                newDomain.content.Components.push(cap)
              } else if (newDomain.content.Components[findIndex].usage !== cap.usage) {
                newDomain.content.Components[findIndex].usage = cap.usage
              }
            })
            _domains.push(newDomain);
          }
          layout.powerDomains = _domains
        } else {
          const specify = toConnectors.map(connector => { return getFindVRMSpecifyComp(connector, designId) });
          const filterPMICs = powerDomains.map(item => {
            if (!item.content) {
              return [];
            }
            let filterSensePMICs = []
            const vrms = item.content.VRM ? item.content.VRM.map(vrm => vrm.VRM_COMP).flat(2) : [];
            filterSensePMICs.push(...vrms);
            return filterSensePMICs
          }).flat(3);
          let _powerDomains = []
          for (let row of powerDomains) {
            const { content, id } = row;
            const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [], includeExtended, DEBUG_MONITOR, extraNets = [], Components = [] } = content;
            let loadComp = DEBUG_MONITOR && DEBUG_MONITOR.length ? DEBUG_MONITOR[0].filter(item => item.type === 'comp')[0].name : '';
            if (!loadComp) {
              const connector = Components.find(item => item.usage === CONNECTOR);
              loadComp = connector ? connector.name : '';
            }
            if (!loadComp) {
              _powerDomains.push(row);
              continue;
            }
            let VRMInfo = yield call(_getVRM, {
              designId: designId,
              GroundNets: [...MAIN_REF_NETS],
              PowerNets: [...MAIN_POWER_NETS],
              ExtendNets: [],
              COMP_PREFIX_LIB: setting,
              loadSelect: [{ comp: loadComp }],
              connectInductance: false,
              findExtend: includeExtended,
              isAC: true,
              PMIC: getPMIC(setting),
              powerSwitch: setting.powerSwitch,
              buckConverter: setting.discreteBuckConverter || [],
              doNotStuff,
              table,
              pinMapSense,
              pinConnection,
              pinMap,
              specify,
              fromPmic,
              connectors: [loadComp, ...toConnectors.map(to => to.name)],
              extraNets,
              fullPaths: netExtensionData[designId] && netExtensionData[designId].some(net => MAIN_POWER_NETS.includes(net)) ? true : false,
              filterPMICs: netExtensionData[designId] && netExtensionData[designId].some(net => MAIN_POWER_NETS.includes(net)) ? filterPMICs : []
            })
            yield put(updateLogs(VRMInfo.logs || []))
            const newInfo = mergeVRMInfo(VRMInfo, content, isPreLayout);
            let newRow = {
              id: id,
              content: {
                ...content,
                ...newInfo,
                PowerNets: [...new Set([...MAIN_POWER_NETS, ...VRMInfo.PowerNets])],
              }
            }
            _powerDomains.push(newRow)
          }
          const newDomains = getCompsBetweenPowerNets(designId, _powerDomains, doNotStuff)
          let _domains = [];
          for (let newDomain of newDomains) {
            if (!newDomain.domainComps) {
              _domains.push(newDomain);
              continue;
            }
            const domainComps = yield call(updateComponentDecapModel, {
              components: newDomain.domainComps,
              prevComps: [],
              designId: designId,
              voltage: newDomain.content.voltage || "1"
            })
            delete newDomain.domainComps;
            domainComps.forEach(cap => {
              const findIndex = newDomain.content.Components.findIndex(comp => comp.name === cap.name)
              if (findIndex < 0) {
                newDomain.content.Components.push(cap)
              } else if (newDomain.content.Components[findIndex].usage !== cap.usage) {
                newDomain.content.Components[findIndex].usage = cap.usage
              }
            })
            _domains.push(newDomain);
          }
          layout.powerDomains = _domains
        }
      }
      layout.COMP_PREFIX_LIB = { version: version }
    } else if (layout.index === TARGET_PACKAGE_INDEX) {
      if (versionCompareSize(COMP_PREFIX_LIB.version, version)) {
        const setting = yield call(componentSetting.getPrefixLib, designId);
        if (setting && setting.Die && !_.isEqual(setting.Die, targetDie)) {
          const _targetDie = targetDie.length && targetDie.every(item => setting.Die.includes(item)) ? targetDie : setting.Die
          yield put(updateImpedanceContent({ targetDie: _targetDie }));
          yield delay(10);
          yield call(saveSetup);

          yield put(updateImpedanceLoading(`Tracing ${designName}...`));
          yield delay(100);
          const { powerNets, referenceNets, DIE, BGA } = getPackagePowerDomain(designId, setting, _targetDie);
          let _powerNets = [...powerNets];

          if (targetIC && selectNets.length && currentDesignId !== designId && !isPreLayout) {
            const { nets } = checkConnectCompsPinsAndNets({ designId: currentDesignId, name: targetIC, nets: selectNets }, { designId, name: BGA.name })
            if (nets && nets.length) {
              _powerNets = _powerNets.filter(item => nets.includes(item))
            }
            if (!_powerNets.length) {
              _powerNets = nets.filter(net => !referenceNets.includes(net));
            }
          }

          let _powerDomains = [];
          const newTargetDie = []
          for (let powerNet of _powerNets) {
            const lastPowerDomain = powerDomains.find(item => item.content.MAIN_POWER_NETS && item.content.MAIN_POWER_NETS.includes(powerNet));
            const lastComponents = lastPowerDomain ? lastPowerDomain.content.Components || [] : powerDomains.map(item => item.content.Components || []).flat();
            const packageVRMs = yield call(getPkgDomainInfo, {
              pcbId: designId,
              powerNet,
              referenceNets,
              DIE: DIE.map(die => die.name),
              BGA: BGA.name,
              setting,
              limitBoundaryPowerPinsLumpedPort
            })

            if (!packageVRMs.add) {
              continue;
            }
            packageVRMs.domain.Components = yield call(updateComponentDecapModel, {
              components: packageVRMs.domain ? packageVRMs.domain.Components : [],
              prevComps: lastComponents,
              designId
            })

            const die = _targetDie.find(item => {
              return packageVRMs.domain.Components.find(comp => comp.name === item)
            })
            if (die && !newTargetDie.includes(die)) {
              newTargetDie.push(die)
            }

            _powerDomains.push({
              id: "",
              content: { ...packageVRMs.domain }
            })
          }

          const { DIE: _DIE } = getPackagePowerDomain(designId, setting, newTargetDie);
          const bgaObj = getImpedanceLayoutComp(BGA.name, designId, BGAConst);
          bgaObj.from = [{ components: _DIE.map(die => die.name), designId }];
          const dieObj = _DIE.map(die => {
            const _dieObj = getImpedanceLayoutComp(die.name, designId, DIEConst)
            _dieObj.to = [{ components: [BGA.name], designId }];
            return _dieObj
          })

          if (currentDesignId !== designId && targetIC) {
            bgaObj.to = [{ components: [targetIC], designId: currentDesignId }];
            const currentIndex = _data.findIndex(item => item.designId === currentDesignId);
            if (currentIndex > -1) {
              const icIndex = _data[currentIndex].ICs.findIndex(item => item.name === targetIC);
              if (icIndex > -1) {
                _data[currentIndex].ICs[icIndex].from = [{ components: _DIE.map(die => die.name), designId }]
              }
            }
          }

          const dieIndex = _data.findIndex(item => item.index === TARGET_DIE_INDEX)
          const dieNames = _DIE.map(item => item.name)
          if (dieIndex > -1) {
            const oldICs = _data[dieIndex].ICs || []
            let newICs = []
            let notUpdate = true
            _powerDomains.forEach(domain => {
              const { content } = domain
              const { Components = [], diePorts = [] } = content
              const dieInfo = Components.find(item => item.usage === DIEConst)
              const die = dieInfo && dieInfo.name ? dieInfo.name : null
              const powerNet = content.MAIN_POWER_NETS.length ? content.MAIN_POWER_NETS[0] : null
              const ports = diePorts.length ? diePorts : [{ port: 1 }]
              const filterICs = oldICs.filter(ic => ic.to && ic.to[0] && ic.to[0].components && ic.to[0].components[0] === die)
              if (ports.length !== filterICs.length) {
                notUpdate = false
              }
              ports.forEach(p => {
                const portIndex = String(p.port)
                const oldIC = notUpdate ? filterICs.find(ic => ic.portIndex === portIndex && ic.powerNet === powerNet) || null : null
                if (notUpdate && !oldIC) notUpdate = false
                const newIC = oldIC ? Object.assign({}, oldIC, { portIndex, powerNet, to: [{ designId, components: [die] }] }) : new ImpDie({ die, designId, portIndex, powerNet })
                newICs.push(newIC)
              })
            })
            _data[dieIndex].ICs = newICs
            _data[dieIndex].customType = notUpdate ? _data[dieIndex].customType || 'perPort' : 'perPort'
          }

          const { ballSizeMap } = layout
          const ballSizeMapObj = new BallSizeMap({ ballSizeMap, comps: [...dieObj, bgaObj], designId })
          const _ballSizeMap = ballSizeMapObj.getBallSizeMap()

          layout.Dies = dieObj;
          layout.Bgas = [bgaObj];
          layout.powerDomains = _powerDomains;
          layout.ballSizeMap = _ballSizeMap;
          yield put(updateImpedanceContent({ targetDie: newTargetDie }));
          yield call(saveSetup);
        }
      }
      layout.COMP_PREFIX_LIB = { version: version }
    }
  })

  let layoutPowerDomains = {};
  if (_data.length > 1) {
    for (let layout of _data) {
      const { powerDomains, designId: design, index } = layout;
      if (index === TARGET_PACKAGE_INDEX || layout.index === TARGET_DIE_INDEX || layout.type === IMPEDANCE_SOCKET) {
        continue
      }
      layoutPowerDomains[design] = powerDomains.map(item => {
        const { id, content } = item;
        const DEBUG_MONITOR = (content && content.DEBUG_MONITOR ? content.DEBUG_MONITOR : []).map(monitor => monitor.filter(m => m.type !== 'connect'));
        return { ...content, id, DEBUG_MONITOR }
      })
    }
    layoutPowerDomains = mergeConnectionTrace(_data, layoutPowerDomains);
  }

  for (let layout of _data) {
    const { designId: layoutDesignId, connectors, index, powerDomains, type } = layout;
    if (index === TARGET_PACKAGE_INDEX || layout.index === TARGET_DIE_INDEX || [IMPEDANCE_SOCKET, IMPEDANCE_INTERPOSER_LAYOUT].includes(type)) {
      continue
    }
    const newPowerDomains = layoutPowerDomains[layoutDesignId] || powerDomains.map(item => ({ id: item.id, ...item.content }));
    const VRMs = newPowerDomains.map(pow => (pow.VRM && pow.VRM.map(vrm => vrm.VRM_COMP)) || []).flat(3);
    const PMICs = [...new Set(VRMs)].filter(vrm => !connectors.find(conn => conn.name === vrm));
    layout.PMICs = PMICs.map(pmic => getImpedanceLayoutComp(pmic, layoutDesignId, PMIC));
    let loadsMonitors = [];

    for (let powerDomain of newPowerDomains) {
      const DEBUG_MONITOR = powerDomain.DEBUG_MONITOR;
      const loads = powerDomain.Components.filter(item => item.usage === LOAD && item.name !== targetIC);
      loadsMonitors.push(...loads.map(load => ({ name: load.name, loadMonitor: load.loadMonitor || [] })));
      layout.ICs = layout.ICs.filter(item => item.name === targetIC)
      if (!layout.ICs.length) {
        const ic = getImpedanceLayoutComp(targetIC, layoutDesignId, IC);
        layout.ICs.push(ic)
      }
      if (DEBUG_MONITOR.length) {
        for (let monitor of DEBUG_MONITOR) {
          const _monitor = monitor.filter(item => item.type === 'comp');
          const first = _monitor[0].name;
          const last = _monitor[_monitor.length - 1].name;
          if (layoutDesignId === currentDesignId) {
            layout.ICs = layout.ICs.filter(item => item.name === first)
            const firstIndex = layout.ICs.findIndex(item => item.name === first);
            if (firstIndex > -1 && !layout.ICs[firstIndex].to.find(item => item.designId === layoutDesignId && item.components.includes(last))) {
              layout.ICs[firstIndex].to.push({ designId: layoutDesignId, components: [last] })
            }
          } else {
            layout.ICs = []
            const firstIndex = layout.connectors.findIndex(item => item.name === first);
            if (firstIndex > -1 && !layout.connectors[firstIndex].to.find(item => item.designId === layoutDesignId && item.components.includes(last))) {
              layout.connectors[firstIndex].to.push({ designId: layoutDesignId, components: [last] })
            }
          }

          let lastIndex = layout.connectors.findIndex(item => item.name === last);
          if (lastIndex > -1 && !layout.connectors[lastIndex].from.find(item => item.designId === layoutDesignId && item.components.includes(first))) {
            layout.connectors[lastIndex].from.push({ designId: layoutDesignId, components: [first] })
          } else {
            lastIndex = layout.PMICs.findIndex(item => item.name === last);
            if (lastIndex > -1 && !layout.PMICs[lastIndex].from.find(item => item.designId === layoutDesignId && item.components.includes(first))) {
              layout.PMICs[lastIndex].from.push({ designId: layoutDesignId, components: [first] })
            }
          }
        }
      }
    }

    const anotherLoads = [...new Set(loadsMonitors.map(item => item.name))];
    anotherLoads.forEach(load => {
      const monitors = loadsMonitors.filter(item => item.name === load).map(item => item.loadMonitor).flat(1);
      const ic = getImpedanceLayoutComp(load, layoutDesignId, IC);
      monitors.forEach(monitor => {
        const _monitor = monitor.filter(item => item.type === 'comp');
        const last = _monitor[_monitor.length - 1].name;
        ic.to.push({ designId: layoutDesignId, components: [last] })
      })
      layout.ICs.push(ic);
    })
    layout.powerDomains = newPowerDomains.map(item => {
      const { id, ...content } = item;
      return { id, content }
    })
  }
  yield call(saveLayouts, { data: _data, update: true, verificationId });

  yield put(updateImpedanceLoading(false));
}

function* updateExtraction(action) {
  const { designId, extraction, apply, parallelExtraction } = action;
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  const newConfig = new ImpExtraction({ ...extraction });
  let _data = [...data];
  const index = _data.findIndex(item => item.designId === designId);
  if (index > -1) {
    _data[index].extraction = newConfig;
    _data.forEach(d => {
      if (d.extraction) {
        d.extraction.parallelExtraction = parallelExtraction
      }
      if (apply) {
        d.extraction = newConfig
      }
    })
    yield put(updateImpedanceContent({ data: _data }));
    yield put({ type: SAVE_POWER_DOMAIN, data: _data });
  }
}

function* updateOpt(action) {
  const { config, opt } = action;
  const { CascadeReducer: { Impedance: { Config } } } = yield select();
  const newConfig = { ...Config, ...config };
  yield put(updateImpedanceContent({ Config: newConfig, Optimization: opt }));
  yield delay(500);
  yield call(saveSetup);
}

function* updateOptions(action) {
  const { options } = action;
  const { CascadeReducer: { Impedance: { Options } } } = yield select();
  const _options = new ImpOptions({ ...Options, ...options });
  const prevFromPmic = Options ? Options.fromPmic : false
  const fromPmic = options.fromPmic
  yield put(updateImpedanceContent({ Options: _options }));
  yield delay(500);
  yield call(saveSetup);
  if (prevFromPmic !== fromPmic) {
    yield call(getVRMs)
  }
}

function* updateMultiPCBTarget(action) {
  const { target } = action;
  yield put(updateImpedanceContent({ target }));
  yield delay(500);
  yield call(saveSetup);
}

function* saveDieCurrent(action) {
  const { dieCurrent, currentDesignId, currentComp, currentPowerNet, currentIndex, apply } = action;
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === currentDesignId)
  if (findIndex < 0) {
    return;
  }
  if (_data[findIndex].index === TARGET_DIE_INDEX) {
    if (apply) {
      _data[findIndex].ICs.forEach(ic => {
        if (ic.to[0].components[0] === currentComp) {
          ic.dieCurrent = dieCurrent
        }
      })
    } else {
      _data[findIndex].ICs.forEach(ic => {
        if (ic.powerNet === currentPowerNet && ic.portIndex === currentIndex && ic.to[0].components[0] === currentComp) {
          ic.dieCurrent = dieCurrent
        }
      })
    }
  } else {
    _data[findIndex].ICs.forEach(ic => {
      if (ic.name === currentComp) {
        ic.dieCurrent = dieCurrent
      }
    })
  }

  const stopTime = dieCurrent.stopTime
  _data.forEach(item => {
    item.ICs.forEach(ic => {
      if (ic.dieCurrent && Number(ic.dieCurrent.stopTime) < Number(stopTime)) {
        ic.dieCurrent.stopTime = stopTime
      }
    })
  })
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: [..._data] });
}

function* refreshImp(action) {
  const { selectNets } = action;
  const { CascadeReducer: { project: { openProjectId }, Impedance: { verificationId, designId, targetIC, targetDie, data, powerNetSelect: { allPowerNets }, packageRelationship = [] } } } = yield select();
  if (targetIC || (targetDie && targetDie.length)) {
    yield put(updateSelectPowerNets({ select: selectNets, allPowerNets: [...new Set([...allPowerNets, ...selectNets])], open: false }));
    if (packageRelationship.length) {
      let _packageRelationship = packageRelationship.filter(item => item[IMPEDANCE_PCB] && item[IMPEDANCE_PCB].some(nets => selectNets.some(net => nets.includes(net))));
      const newNets = selectNets.filter(net => !_packageRelationship.some(item => item[IMPEDANCE_PCB] && item[IMPEDANCE_PCB].some(nets => nets.includes(net))));
      if (newNets.length) {
        const pkg = data.find(item => item.index === TARGET_PACKAGE_INDEX);
        if (pkg) {
          const pcbId = pkg.designId;
          const isPreLayout = designConstructor.isPreLayout(pcbId);
          let setting = new CascadeCompRLCPrefixLib({})
          if (isPreLayout) {
            yield call([preLayoutData, preLayoutData.getPreLayout], pcbId)
          } else if (IMPEDANCE_POST_LIST.includes(pkg.type)) {
            setting = yield call([componentSetting, componentSetting.getPrefixLib], pcbId);
            yield call(getAuroraDB, pcbId);
          }

          const { BGA } = getPackagePowerDomain(pcbId, setting, targetDie);
          if (BGA.name) {
            newNets.forEach(net => {
              const { nets } = checkConnectCompsPinsAndNets({ designId: designId, name: targetIC, nets: [net] }, { designId: pcbId, name: BGA.name })
              _packageRelationship.push({ [IMPEDANCE_PCB]: [net], [IMPEDANCE_PACKAGE]: [...nets] })
            })
          }
        }
      }
      yield put(setPackageRelationship(_packageRelationship))
    }
    yield call(saveSetup)
    const designList = CascadeChannels.getList(IMPEDANCE, openProjectId);
    const currentItem = [...designList].find(i => i.id === verificationId);
    yield put(openTabFooter());
    yield put(changeTabMenu({
      tabSelectKeys: ["detail"],
      currentVerificationId: verificationId,
      verificationName: currentItem ? currentItem.name : IMPEDANCE,
      menuType: "simulation"
    }))
    yield put(updateLogs([], true))
    yield put(updateLogs([{ type: 'success', text: '[Layouts] The selected Nets are saved successfully.' }]))
    if (data.length === 1) {
      yield call(getVRMs);
    } else if (data.length > 1) {
      const pcbLengths = data.filter(item => item.type === IMPEDANCE_PCB);
      if (pcbLengths.length > 1) {
        yield put(updateLogs([{ type: 'normal', text: '[Layouts] Multiple PCB/Packages are detected. Please click the Trace button to trace.' }]))
      } else {
        yield call(getVRMs)
      }
    }
  }
}

function* updateImpedanceByVersion({ data, version, verificationId }) {
  let newData = { ...data };
  const { CascadeReducer: { project: { openProjectId } } } = yield select();

  if (version === IMPEDANCE_VERSION) {
    return newData;
  }

  if (versionCompareSize(version, '0.0.2')) {
    newData.powerDomains.forEach(item => {
      item.content.VRM.forEach(vrm => {
        if (!Array.isArray(vrm.VRM_COMP)) {
          vrm.VRM_COMP = [vrm.VRM_COMP]
        }
      })
    })
  }

  if (versionCompareSize(version, '0.0.3')) {
    const includeExtended = data.includeExtended;
    newData.powerDomains.forEach(item => {
      item.content.includeExtended = includeExtended;
    });
    const currentProjectDesignID = projectDesigns.getAvailablePCBsFirstId(openProjectId);

    // load PCB
    try {
      yield call(getAuroraDB, currentProjectDesignID);
    } catch (error) {
      console.error(error)
    }

    let loadSelect = [{ comp: newData.targetIC }];
    let newPowerDomain = [];
    const setting = yield call(componentSetting.getPrefixLib, currentProjectDesignID);
    const doNotStuff = yield call(componentDoNotStuff.getDoNotStuff, currentProjectDesignID);
    const table = yield call(compTableHelper.getTableData, currentProjectDesignID);
    const _pinConnection = yield call(compPinMap.getPinConnection, currentProjectDesignID);
    const pinConnection = yield call(getPowerSwitchPinMap, _pinConnection);
    const pinMap = yield call(getImpedancePinMap, currentProjectDesignID);
    if (currentProjectDesignID) {
      const pinMapSense = yield call([pinMapStore, pinMapStore.getPinMapSense], currentProjectDesignID, "pinName")
      for (let row of newData.powerDomains) {
        const { id, content } = row;
        const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [], includeExtended, extraNets = [] } = content;
        let VRMInfo = yield call(_getVRM,
          {
            designId: currentProjectDesignID,
            GroundNets: [...MAIN_REF_NETS],
            PowerNets: [...MAIN_POWER_NETS],
            ExtendNets: [],
            COMP_PREFIX_LIB: newData.setting,
            loadSelect,
            connectInductance: false,
            findExtend: includeExtended,
            isAC: true,
            PMIC: getPMIC(setting),
            powerSwitch: setting.powerSwitch,
            buckConverter: setting.discreteBuckConverter || [],
            doNotStuff,
            table,
            pinMapSense,
            pinConnection,
            pinMap,
            extraNets
          })
        yield put(updateLogs(VRMInfo.logs || []))
        const newInfo = mergeVRMInfo(VRMInfo, content);
        let newRow = {
          id: id,
          content: {
            ...content,
            ...newInfo,
            PowerNets: [...new Set([...MAIN_POWER_NETS, ...VRMInfo.PowerNets])],
          }
        }
        newPowerDomain.push(newRow)
      }
      newData.powerDomains = [...newPowerDomain];
    }
  }

  if (versionCompareSize(version, '0.0.4')) {
    newData.powerDomains.forEach(item => {
      if (!item.content.target) {
        item.content.target = [];
      }
      if (!item.content.ports) {
        item.content.ports = [];
      }
    })
  }

  if (versionCompareSize(version, '0.0.5')) {
    if (!newData.designId) {
      const designId = projectDesigns.getAvailablePCBsFirstId(openProjectId);
      newData.designId = designId
      yield call(selectTaskPCB, { verificationId, designId })
    }
  }

  if (versionCompareSize(version, '0.0.6')) {
    //Add isMultiNets to cap components to supports caps that connect to more than 2 nets
    // load PCB
    try {
      yield call(getAuroraDB, newData.designId);
    } catch (error) {
      console.error(error)
    }

    newData.powerDomains.forEach(item => {
      item.content.Components = addMultiNetsFieldToCapComps({
        pcbId: newData.designId,
        Components: item.content.Components,
        isVersionUpdate: true
      })
    })
  }

  if (versionCompareSize(version, '0.0.8')) {
    //support gnd sense ports , update sense ports json format
    newData.powerDomains.forEach(item => {
      if (item.content.sensePort && item.content.sensePort.length && !item.content.sensePorts) {
        item.content.sensePorts = item.content.sensePort.map(it => {
          return {
            powerSensePort: it,
            groundSensePort: []
          }
        })
      } else {
        item.content.sensePorts = []
      }
    })
  }

  //Support clipping to SIwavePSI solver,default open clipping
  if (versionCompareSize(version, '0.0.9') && newData.Config && newData.Config.type === PSI && newData.Config.CLIP !== 1) {
    newData.Config.CLIP = 1;
  }

  if (versionCompareSize(version, '0.0.10')) {
    newData.powerDomains.forEach(item => {
      if (item.content) {
        item.content.voltage = '1';
      }
    })
  }

  if (versionCompareSize(version, '1.0.0')) {
    try {
      if (newData.designId) {
        yield call(getAuroraDB, newData.designId);
      }
    } catch (error) {
      console.error(error)
    }
    newData = upgradeSetupDataToMulti(newData);
  }

  if (versionCompareSize(version, '1.0.1')) {
    const extraction = new ImpExtraction(newData.Config);
    if (newData.layouts) {
      newData.layouts.forEach(layout => layout.extraction = extraction);
    }
  }

  if (versionCompareSize(version, '1.0.2')) {
    let selectPowerNets = []
    if (newData.designId && newData.targetIC && newData.layouts) {
      const layout = newData.layouts.find(d => d.designId === newData.designId);
      if (layout && layout.powerDomains) {
        layout.powerDomains.forEach(item => {
          selectPowerNets.push(...item.content.MAIN_POWER_NETS)
        })
        newData.targetNets = [...new Set(selectPowerNets)];
      }
    }
  }

  if (versionCompareSize(version, '1.0.3')) {
    if (newData.layouts) {
      newData.layouts.forEach(layout => {
        layout.connectors.forEach(connector => {
          connector.from.forEach(f => {
            if (f.nets) {
              f.nets = setNewConnectorNetsSpec(f.nets);
            }
          })
          connector.to.forEach(t => {
            if (t.nets) {
              t.nets = setNewConnectorNetsSpec(t.nets);
            }
          })
        })
      })
    }
  }

  if (versionCompareSize(version, '1.0.4')) {
    if (newData.layouts) {
      newData.layouts.forEach(layout => {
        if (layout.extraction.type === SIWAVE) {
          layout.extraction['errorTolerance'] = '0.005'
        }
      })
    }
  }

  if (versionCompareSize(version, '1.1.0')) {
    const findDieIndex = newData.layouts.findIndex(item => item.index === TARGET_DIE_INDEX)
    if (findDieIndex > -1) {
      const layout = newData.layouts[findDieIndex]
      const _ICs = JSON.parse(JSON.stringify(layout.ICs || []))
      if (layout.dieCurrent) {
        _ICs.forEach(ic => ic.dieCurrent = layout.dieCurrent)
      }
      const pkgLayout = newData.layouts.find(item => item.index === TARGET_PACKAGE_INDEX)
      const newICs = []
      _ICs.forEach(ic => {
        const die = ic.to[0].components[0]
        const targetDomain = pkgLayout.powerDomains.find(domain => {
          return domain.content.Components.find(item => item.name === die)
        })
        if (targetDomain) {
          const powerNet = targetDomain.content.MAIN_POWER_NETS.length > 0 ? targetDomain.content.MAIN_POWER_NETS[0] : null
          ic.powerNet = powerNet
          if (targetDomain.content.diePorts.length === 0) {
            ic.portIndex = '1'
            newICs.push(ic)
          } else {
            targetDomain.content.diePorts.forEach(portInfo => {
              const _ic = JSON.parse(JSON.stringify(ic))
              _ic.portIndex = portInfo.port
              newICs.push(_ic)
            })
          }
        }
      })
      newData.layouts[findDieIndex].ICs = newICs
    }
  }

  if (versionCompareSize(version, '1.1.1')) {
    const findDieIndex = newData.layouts.findIndex(item => item.index === TARGET_DIE_INDEX)
    if (findDieIndex > -1) {
      const layout = newData.layouts[findDieIndex]
      const _ICs = JSON.parse(JSON.stringify(layout.ICs || []))
      const findIc = _ICs.find(ic => ic.model)
      let customType
      if (findIc) {
        const type = findIc.model.type || 'value'
        customType = type === 'CPM' ? 'CPM' : 'perPort'
      } else {
        customType = 'perPort'
      }
      newData.layouts[findDieIndex].customType = customType
    }
  }

  if (versionCompareSize(version, '1.1.2')) {
    if (newData.layouts) {
      newData.layouts.forEach(layout => {
        layout.powerDomains.forEach(domain => {
          domain.content.Components.forEach(comp => {
            if ([CAP, IPD].includes(comp.usage) && comp.model) {
              comp.models = [{ ...comp.model, key: 0 }]
            }
          })
        })
      })
    }
  }

  if (versionCompareSize(version, '1.2.0')) {
    if (newData.layouts) {
      newData.layouts.forEach(layout => {
        if (layout.type === IMPEDANCE_PCB) {
          layout.powerDomains.forEach(domain => {
            const VRMs = domain.content.VRM.map(vrm => vrm.VRM_COMP).flat();
            domain.content.Components.forEach(comp => {
              if ([IGNORE].includes(comp.usage) && VRMs.includes(comp.name)) {
                comp.usage = PMIC
              }
            })
          })
        }
      })
    }
  }

  if (versionCompareSize(version, '1.2.1')) {
    const designId = newData.designId
    const findIndex = newData.layouts.findIndex(item => item.index === TARGET_PACKAGE_INDEX)
    let targetNets = []
    if (findIndex > -1 && newData.layouts[findIndex].designId === designId) {
      newData.layouts[findIndex].powerDomains.forEach(domain => {
        targetNets.push(...domain.content.MAIN_POWER_NETS)
      })
      newData.targetNets = [...new Set(targetNets)];
    }
  }

  if (versionCompareSize(version, '1.2.2')) {
    if (newData.layouts) {
      const pkg = newData.layouts.find(item => item.index === TARGET_PACKAGE_INDEX)
      const designId = newData.designId
      if (pkg && designId !== pkg.designId) {
        const targetPCB = newData.layouts.find(item => item.designId === designId);
        if (targetPCB) {
          const MAIN_PCB_NETS = targetPCB.powerDomains.map(domain => domain.content.MAIN_POWER_NETS)
          const MAIN_PACKAGE_NETS = pkg.powerDomains.map(domain => domain.content.MAIN_POWER_NETS)
          let relationship = []
          MAIN_PCB_NETS.forEach((nets, index) => {
            if (MAIN_PACKAGE_NETS[index]) {
              relationship.push({
                [IMPEDANCE_PCB]: nets,
                [IMPEDANCE_PACKAGE]: MAIN_PACKAGE_NETS[index]
              })
            }
          })
          yield put(setPackageRelationship(relationship))
        }
      }
    }
  }

  if (versionCompareSize(version, '1.2.3')) {
    if (newData.layouts) {
      newData.layouts.forEach(layout => {
        if (layout.extraction.type === POWERSI) {
          layout.extraction['pwsiIncludeElementsWithNoNetNames'] = true
        }
      })
    }
  }

  return newData;
}

function* saveTarget(action) {
  const { id, target } = action;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === page);
  if (findIndex < 0) {
    return;
  }
  const index = _data[findIndex].powerDomains.findIndex(item => item.id === id);
  const currentData = _data[findIndex].powerDomains[index] || null;
  if (!currentData) {
    return;
  }
  currentData.content.target = target && target.length ? target : [];
  _data[findIndex].powerDomains[index] = currentData;
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* savePorts(action) {
  const { id, ports } = action;
  const { CascadeReducer: { Impedance: { data, page, designId, packageRelationship = [] } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === page);
  if (findIndex < 0) {
    return;
  }
  const index = _data[findIndex].powerDomains.findIndex(item => item.id === id);
  const currentData = _data[findIndex].powerDomains[index] || null;
  if (!currentData) {
    return;
  }
  currentData.content.ports = ports ? [...ports] : [];
  _data[findIndex].powerDomains[index] = currentData;

  if (page === designId) {
    const findPackgeIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
    if (findPackgeIndex > -1) {
      if (_data[findPackgeIndex].type === IMPEDANCE_PACKAGE_FILE) {
        const prevPairs = _data[findPackgeIndex].socket.pairs || [];
        const { ports: pairs, domains } = yield call(getPackageFilePorts, _data);
        const _pairs = pairs.map(pair => {
          const _pair = prevPairs.find(item => item.portName === pair.portName && item.port === pair.port);
          if (_pair) {
            const { libraryId, subckt, node } = _pair
            return { ...pair, libraryId, subckt, node }
          }
          return pair
        })
        _data[findPackgeIndex].socket.pairs = _pairs;
        _data[findPackgeIndex].powerDomains = domains.map(domain => ({ id: "", content: domain }));

        const findDieIndex = _data.findIndex(item => item.index === TARGET_DIE_INDEX)
        if (findDieIndex > -1) {
          const designId = _data[findPackgeIndex].designId
          const powerNet = domains[0].MAIN_POWER_NETS[0]
          const die = "DIE"
          let newICs = []
          const diePorts = domains[0].diePorts
          if (diePorts.length === 0) {
            newICs.push(new ImpDie({ die, designId: designId, portIndex: "1", powerNet }))
          } else {
            diePorts.forEach(item => {
              newICs.push(new ImpDie({ die, designId: designId, portIndex: String(item.port), powerNet }))
            })
          }
          _data[findDieIndex].ICs = newICs
        }
      } else {
        const isPrelayout = designConstructor.isPreLayout(_data[findPackgeIndex].designId)
        if (!isPrelayout) {
          if (!auroraDBJson.checkAuroraJson(_data[findPackgeIndex].designId) && IMPEDANCE_POST_LIST.includes(_data[findPackgeIndex].type)) {
            yield call(getAuroraDB, _data[findPackgeIndex].designId)
          }
          if (packageRelationship.length) {
            const shipIndex = packageRelationship.findIndex(ship => ship[IMPEDANCE_PCB] && ship[IMPEDANCE_PCB].some(net => currentData.content.MAIN_POWER_NETS.includes(net)));
            if (shipIndex > -1) {
              const packageNets = packageRelationship[shipIndex][IMPEDANCE_PACKAGE];
              const packageIndexs = _data[findPackgeIndex].powerDomains.map((item, index) => {
                return item.content.MAIN_POWER_NETS.some(net => packageNets.includes(net)) ? index : -1
              }).filter(item => item > -1);
              packageIndexs.forEach(rowIndex => {
                const domain = _data[findPackgeIndex].powerDomains[rowIndex];
                const BGA = domain.content.Components.find(comp => comp.usage === BGAConst);
                if (BGA && BGA.name) {
                  const compInfo = getCascadeComponents({ pcbId: _data[findPackgeIndex].designId, name: BGA.name });
                  if (compInfo) {
                    const pins = [...compInfo.pins.values()].filter(pin => domain.content.MAIN_POWER_NETS.includes(pin.net)).map(pin => pin.pin);
                    let _ports = ports.map(port => {
                      const { powerPins = [] } = port;
                      const _powerPins = powerPins.filter(pin => pins.includes(pin));
                      return { ...port, powerPins: _powerPins, importPowerPins: [], importReferencePins: [] }
                    }).filter(port => port.powerPins.length);
                    if (_ports.length) {
                      const bgaPorts = domain.content.bgaPorts.filter(port => {
                        if (domain.content.bgaPorts.some(bps => bps.powerPins.some(pps => port.powerPins.includes(pps)))) {
                          return false
                        }
                        return true
                      })
                      _data[findPackgeIndex].powerDomains[rowIndex].content.bgaPorts = [...bgaPorts, ..._ports]
                    }
                  }
                }
              })
            }
          } else {
            let packgeIndex = -1
            if (_data[findIndex].powerDomains.length === 1 && _data[findPackgeIndex].powerDomains.length === 1) {
              packgeIndex = 0
            } else if (_data[findIndex].powerDomains.length > 1 || _data[findPackgeIndex].powerDomains.length > 1) {
              packgeIndex = _data[findPackgeIndex].powerDomains.findIndex(item => {
                return item.content.MAIN_POWER_NETS.length &&
                  currentData.content.MAIN_POWER_NETS.length &&
                  _.isEqual(item.content.MAIN_POWER_NETS, currentData.content.MAIN_POWER_NETS)
              });
            }
            if (packgeIndex > -1) {
              const packageCurrentData = _data[findPackgeIndex].powerDomains[packgeIndex] || null;
              packageCurrentData.content.bgaPorts = ports ? [...ports] : [];
              _data[findPackgeIndex].powerDomains[packgeIndex] = packageCurrentData;
            }
          }
        }
      }
    }
  }

  const findSocketIndex = _data.findIndex(item => item.type === IMPEDANCE_SOCKET)
  if (findSocketIndex > -1) {
    if (_data[findSocketIndex].socket && _data[findSocketIndex].socket.pairs && _data[findSocketIndex].socket.pairs.length) {
      _data[findSocketIndex].socket.pairs = []
    }
  }

  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* saveLoadPorts(action) {
  const { load, id, ports } = action;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === page);
  if (findIndex < 0) {
    return;
  }
  const index = _data[findIndex].powerDomains.findIndex(item => item.id === id);
  const currentData = _data[findIndex].powerDomains[index] || null;
  if (!currentData) {
    return;
  }
  currentData.content.Components.find(comp => comp.name === load).loadPorts = ports ? [...ports] : [];
  _data[findIndex].powerDomains[index] = currentData;
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* updateImpedancePCB(action) {
  const { pcbId, designType } = action;
  const { CascadeReducer: { Impedance: { designId, verificationId, data, designType: prevDesignType, page } } } = yield select();
  yield put(updateDesignStatus(true));
  yield put(updateImpedanceLoading('Loading...'));
  try {
    yield call(selectTaskPCB, { verificationId, designId: pcbId })
    if (pcbId) {
      yield call(getAuroraDB, pcbId);
    }

    let designName = "";
    if (pcbId) {
      designName = designConstructor.getDesignName(pcbId);
      yield put(updateImpedanceContent({ designName }));
      yield call(saveSetup)
    }
    yield put(updateImpedanceContent({ designType }));
    const { CascadeReducer: { Impedance: { verificationId: newVerificationId, } } } = yield select();
    if (verificationId !== newVerificationId) {
      return;
    }
    const isPreLayout = designConstructor.isPreLayout(pcbId);
    if ([IMPEDANCE_PACKAGE, IMPEDANCE_PCB].includes(designType) && !isPreLayout) {
      yield* checkMaterialList(pcbId);
    }
    if (designType !== prevDesignType) {
      yield call(deleteImpedanceDomains, { verificationId, ids: data.map(p => p.powerDomainIds ? p.powerDomainIds : p.powerDomains.map(d => d.id)).flat(2) });
      if (designType === IMPEDANCE_PACKAGE) {
        lastVerificationTask = yield call(updateDesignPackage, { pcbId })
      } else if (designType === IMPEDANCE_PCB) {
        yield put(updateImpedanceContent({ data: [], status: true }));
        lastVerificationTask = yield call(updatePCBDesign, { pcbId })
      }
    } else if (designType === IMPEDANCE_PCB) {
      if (designId !== pcbId) {
        lastVerificationTask = yield call(updatePCBDesign, { pcbId })
      }
    } else if (designType === IMPEDANCE_PACKAGE) {
      lastVerificationTask = yield call(updateDesignPackage, { pcbId })
    }
    yield delay(100);
    if (page === designId) {
      lastVerificationTask = yield call(changePageByDesign, { page: pcbId })
    }
    yield put(updatePCB(pcbId))

    yield delay(100);
    yield call(saveSetup)
    lastVerificationTask = null;
  } catch (error) {
    console.error(error)
  }
  yield put(updateDesignStatus(false))
  yield put(updateImpedanceLoading(false));
}

function* updatePCBDesign({ pcbId }) {
  const { CascadeReducer: { Impedance: { verificationId, data, targetIC, designId, Options, parallelExtraction } } } = yield select();
  let pcbLog = [];
  yield put(updateLogs([], true))
  if (!data.length) {
    const isPreLayout = designConstructor.isPreLayout(pcbId);
    yield put(updateImpedanceContent({ targetIC: "", targetDie: [], powerNetSelect: { select: [] } }));
    const version = yield call(componentSetting.getVersion, pcbId);
    const COMP_PREFIX_LIB = { version: version }
    const pcbName = designConstructor.getDesignName(pcbId);
    const vendor = designConstructor.getDesignVendor(pcbId)
    const meshPologen = designConstructor.getDesignMeshPolygon(designId);
    const extraction = new ImpExtraction({ parallelExtraction, type: vendor === SPD ? POWERSI : meshPologen ? HFSS : SIWAVE });
    if (auroraDBJson.isFlexBoard(pcbId)) {
      extraction.CLIP = 0
    }
    const _data = [new ImpLayout({ index: TARGET_PCB_INDEX, designId: pcbId, designName: pcbName, type: 'pcb', COMP_PREFIX_LIB, extraction })];
    yield call(saveLayouts, { data: _data, update: true, verificationId });
    if (isPreLayout) {
      yield delay(500);
      const preData = yield call([preLayoutData, preLayoutData.getPreLayout], pcbId);
      const { content = {} } = preData;
      const { components = [] } = content;
      const ic = components.find(item => item.type === IC);
      let targetIC = ic ? ic.name : ""
      yield call(changeTargetIC, { value: targetIC, pcbId })
    }
    return;
  }

  const { CascadeReducer: { Impedance: { verificationId: newVerificationId, } } } = yield select();
  if (verificationId !== newVerificationId) {
    return;
  }
  const fromPmic = Options ? Options.fromPmic : false;
  const isPreLayout = designConstructor.isPreLayout(pcbId)
  if (data.length === 1) {
    const setting = yield call(componentSetting.getPrefixLib, pcbId);
    const doNotStuff = yield call(componentDoNotStuff.getDoNotStuff, pcbId);
    const table = yield call(compTableHelper.getTableData, pcbId);
    const netsInfo = getNets(pcbId);
    let ICs = []
    if (!netsInfo || !netsInfo.loadComponents || !netsInfo.loadComponents.map(comp => comp.name).includes(targetIC)) {
      pcbLog.push("[Update] TargetIC does not exist.")
      yield put(updateImpedanceContent({ targetIC: "", data: [] }));
      yield put(updateSelectPowerNets({ select: [], allPowerNets: [], allNets: [], open: false }))
      const version = yield call(componentSetting.getVersion, pcbId);
      const COMP_PREFIX_LIB = { version: version }
      const pcbName = designConstructor.getDesignName(pcbId);
      const extraction = data[0].extraction || {}
      const _data = [new ImpLayout({ index: TARGET_PCB_INDEX, designId: pcbId, designName: pcbName, type: 'pcb', COMP_PREFIX_LIB, extraction })];
      yield call(deleteImpedanceDomains, { verificationId, ids: data.map(p => p.powerDomainIds ? p.powerDomainIds : p.powerDomains.map(d => d.id)).flat(2) });
      yield put(updateImpedanceContent({ data: _data, targetIC: "", targetDie: [], powerNetSelect: { select: [] } }));
      yield call(saveLayouts, { data: _data, update: true, verificationId });
      yield call(saveSetup);
    } else {
      const { powerNets, groundNet, allNets } = getPowerDomain({ chip: targetIC, designId: pcbId, COMP_PREFIX_LIB: setting });
      let deleteTableDatas = [], select = [];
      data[0].powerDomains.forEach(d => {
        const { id, content = {} } = d;
        const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [] } = content;
        if (!MAIN_POWER_NETS.every(item => netsInfo.nets.includes(item))) {
          pcbLog.push(`[Update][Power Domains] ${MAIN_POWER_NETS.join(',')} does not exist.`)
          deleteTableDatas.push(id)
        } else if (!MAIN_REF_NETS.includes(groundNet)) {
          pcbLog.push(`[Update][Power Domains] ${MAIN_REF_NETS.join(',')} does not exist.`)
          deleteTableDatas.push(id)
        } else {
          select.push(...MAIN_POWER_NETS)
        }
      })
      yield put(updateSelectPowerNets({ select, allPowerNets: [...new Set([...powerNets, ...select])], allNets: [...allNets], open: false }))
      const newTableData = data[0].powerDomains.filter(item => !deleteTableDatas.includes(item.id));
      yield call(deleteImpedanceDomains, { verificationId, ids: deleteTableDatas });
      yield call(saveSetup)
      let loadSelect = [{ comp: targetIC }], newData = [];
      const pinMapSense = yield call([pinMapStore, pinMapStore.getPinMapSense], designId, "pinName");
      const _pinConnection = yield call(compPinMap.getPinConnection, designId);
      const pinConnection = yield call(getPowerSwitchPinMap, _pinConnection);
      const pinMap = yield call(getImpedancePinMap, designId);
      const ic = getImpedanceLayoutComp(targetIC, pcbId, IC);
      for (let row of newTableData) {
        const { id, content } = row;
        const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [], includeExtended, ports: _ports, extraNets = [] } = content;
        let VRMInfo = yield call(_getVRM,
          {
            designId: pcbId,
            GroundNets: [...MAIN_REF_NETS],
            PowerNets: [...MAIN_POWER_NETS],
            ExtendNets: [],
            COMP_PREFIX_LIB: setting,
            loadSelect,
            connectInductance: false,
            findExtend: includeExtended,
            isAC: true,
            PMIC: getPMIC(setting),
            powerSwitch: setting.powerSwitch,
            buckConverter: setting.discreteBuckConverter || [],
            doNotStuff,
            table,
            pinMapSense,
            pinConnection,
            pinMap,
            extraNets,
            fromPmic
          })
        yield put(updateLogs(VRMInfo.logs || []))
        if (VRMInfo.DEBUG_MONITOR.length) {
          VRMInfo.DEBUG_MONITOR.forEach(monitor => {
            const _monitor = monitor.filter(item => item.type === 'comp');
            const last = _monitor[_monitor.length - 1].name;
            ic.to.push({ designId: pcbId, components: [last] })
          })
        }
        const { ports, deletePower = [], deleteRefe = [] } = filterPortsByPCB(pcbId, targetIC, MAIN_POWER_NETS, MAIN_REF_NETS, _ports, isPreLayout);
        if (deletePower.length) {
          pcbLog.push(`[Update][Power Domains][${MAIN_POWER_NETS.join(',')}][Ports] Pins "${deletePower.join(',')}" does not exist.`)
        }
        if (deleteRefe.length) {
          pcbLog.push(`[Update][Power Domains][${MAIN_REF_NETS.join(',')}][Ports] Pins "${deleteRefe.join(',')}" does not exist.`)
        }
        const componentUpdate = getCompUpdateLog({ ...VRMInfo, MAIN_POWER_NETS }, content);
        pcbLog.push(...componentUpdate)
        const newInfo = mergeVRMInfo(VRMInfo, { ...content, ports }, isPreLayout);
        let newRow = {
          id: id,
          content: {
            ...content,
            ...newInfo,
            PowerNets: [...new Set([...MAIN_POWER_NETS, ...VRMInfo.PowerNets])],
          }
        }
        newData.push(newRow)
      }
      ICs.push(ic)
      const _data = [...data];
      const _layout = data[0];
      _layout.ICs = ICs
      const newDomains = getCompsBetweenPowerNets(designId, newData, doNotStuff)
      let _domains = [];
      for (let newDomain of newDomains) {
        if (!newDomain.domainComps) {
          _domains.push(newDomain);
          continue;
        }
        const domainComps = yield call(updateComponentDecapModel, {
          components: newDomain.domainComps,
          prevComps: [],
          designId: designId,
          voltage: newDomain.content.voltage || "1"
        })
        delete newDomain.domainComps;
        domainComps.forEach(cap => {
          const findIndex = newDomain.content.Components.findIndex(comp => comp.name === cap.name)
          if (findIndex < 0) {
            newDomain.content.Components.push(cap)
          } else if (newDomain.content.Components[findIndex].usage !== cap.usage) {
            newDomain.content.Components[findIndex].usage = cap.usage
          }
        })
        _domains.push(newDomain);
      }
      _layout.powerDomains = _domains
      const { connectors = [] } = _layout;
      const VRMs = newData.map(domain => (domain.content && domain.content.VRM && domain.content.VRM.map(vrm => vrm.VRM_COMP)) || []).flat(3);
      const PMICs = [...new Set(VRMs)].filter(vrm => !connectors.find(conn => conn.name === vrm));
      _layout.PMICs = PMICs.map(pmic => getImpedanceLayoutComp(pmic, pcbId, PMIC));
      const version = yield call(componentSetting.getVersion, pcbId);
      const COMP_PREFIX_LIB = { version: version }
      const pcbName = designConstructor.getDesignName(pcbId);
      _layout.designId = pcbId;
      _layout.designName = pcbName;
      _layout.COMP_PREFIX_LIB = COMP_PREFIX_LIB;
      let newAdditionalNets = _layout.additionalNets || [];
      if (newAdditionalNets.length) {
        const nets = getAllCascadeNets({ pcbId });
        const oldNets = getAllCascadeNets({ pcbId: designId });
        newAdditionalNets = oldNets.length === newAdditionalNets.length ? nets : newAdditionalNets.filter(net => nets.includes(net))
        _layout.additionalNets = [...newAdditionalNets];
      }
      _data[0] = _layout
      yield call(saveLayouts, { data: _data, update: true, verificationId });
      if (pcbLog.length) {
        yield put(openTabFooter())
      }
      yield put(updatePCBLog(pcbLog))
    }
    return;
  }

  if (data.length > 1) {
    const setting = yield call(componentSetting.getPrefixLib, pcbId);
    const doNotStuff = yield call(componentDoNotStuff.getDoNotStuff, pcbId);
    const table = yield call(compTableHelper.getTableData, pcbId);
    let layouts = [...data];
    if (!layouts.find(item => item.designId === pcbId)) {
      const pcbLayoutIndex = layouts.findIndex(item => item.designId === designId)
      const pcbLayout = pcbLayoutIndex > -1 ? layouts[pcbLayoutIndex] : {}
      const netsInfo = getNets(pcbId);
      let ICs = []
      const loadComponents = netsInfo && netsInfo.loadComponents ? netsInfo.loadComponents.map(comp => comp.name) : []
      const pcbAllNets = netsInfo && netsInfo.nets ? netsInfo.nets : []
      if (!netsInfo || !netsInfo.loadComponents || !netsInfo.loadComponents.map(comp => comp.name).includes(targetIC)) {
        pcbLog.push("[Update] TargetIC does not exist.")
        yield put(updateImpedanceContent({ targetIC: "", data: [] }));
        yield put(updateSelectPowerNets({ select: [], allPowerNets: [], allNets: [], open: false }))
        const version = yield call(componentSetting.getVersion, pcbId);
        const COMP_PREFIX_LIB = { version: version }
        const pcbName = designConstructor.getDesignName(pcbId);
        const extraction = data[0].extraction || {}
        const _data = [new ImpLayout({ index: TARGET_PCB_INDEX, designId: pcbId, designName: pcbName, type: 'pcb', COMP_PREFIX_LIB, extraction })];
        yield call(deleteImpedanceDomains, { verificationId, ids: data.map(p => p.powerDomainIds ? p.powerDomainIds : p.powerDomains.map(d => d.id)).flat(2) });
        yield put(updateImpedanceContent({ data: _data, targetIC: "", targetDie: [], powerNetSelect: { select: [] } }));
        yield call(saveLayouts, { data: _data, update: true, verificationId });
        yield call(saveSetup);
        return
      } else {
        const { powerNets, groundNet, allNets } = getPowerDomain({ chip: targetIC, designId: pcbId, COMP_PREFIX_LIB: setting });
        let deleteTableDatas = [], select = [];
        pcbLayout.powerDomains.forEach(d => {
          const { id, content = {} } = d;
          const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [] } = content;
          if (!MAIN_POWER_NETS.every(item => netsInfo.nets.includes(item))) {
            pcbLog.push(`[Update][Power Domains] ${MAIN_POWER_NETS.join(',')} does not exist.`)
            deleteTableDatas.push(id)
          } else if (!MAIN_REF_NETS.every(item => netsInfo.nets.includes(item))) {
            pcbLog.push(`[Update][Power Domains] ${MAIN_REF_NETS.join(',')} does not exist.`)
            deleteTableDatas.push(id)
          } else {
            select.push(...MAIN_POWER_NETS)
          }
        })
        yield put(updateSelectPowerNets({ select, allPowerNets: [...new Set([...powerNets, ...select])], allNets: [...allNets], open: false }))
        const newTableData = pcbLayout.powerDomains.filter(item => !deleteTableDatas.includes(item.id));
        yield call(deleteImpedanceDomains, { verificationId, ids: deleteTableDatas });
        yield call(saveSetup)
        let loadSelect = [{ comp: targetIC }], newData = [];
        const pinMapSense = yield call([pinMapStore, pinMapStore.getPinMapSense], pcbId, "pinName");
        const pinConnection = yield call(compPinMap.getPinConnection, pcbId);
        const pinMap = yield call(getImpedancePinMap, pcbId);
        const ic = getImpedanceLayoutComp(targetIC, pcbId, IC);
        for (let row of newTableData) {
          const { id, content } = row;
          const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [], includeExtended, ports: _ports, extraNets = [] } = content;
          let VRMInfo = yield call(_getVRM,
            {
              designId: pcbId,
              GroundNets: [...MAIN_REF_NETS],
              PowerNets: [...MAIN_POWER_NETS],
              ExtendNets: [],
              COMP_PREFIX_LIB: setting,
              loadSelect,
              connectInductance: false,
              findExtend: includeExtended,
              isAC: true,
              PMIC: getPMIC(setting),
              powerSwitch: setting.powerSwitch,
              buckConverter: setting.discreteBuckConverter || [],
              doNotStuff,
              table,
              pinMapSense,
              pinConnection,
              pinMap,
              extraNets,
              fromPmic
            })
          yield put(updateLogs(VRMInfo.logs || []))
          if (VRMInfo.DEBUG_MONITOR.length) {
            VRMInfo.DEBUG_MONITOR.forEach(monitor => {
              const _monitor = monitor.filter(item => item.type === 'comp');
              const last = _monitor[_monitor.length - 1].name;
              ic.to.push({ designId: pcbId, components: [last] })
            })
          }
          const { ports, deletePower = [], deleteRefe = [] } = filterPortsByPCB(pcbId, targetIC, MAIN_POWER_NETS, MAIN_REF_NETS, _ports, isPreLayout);
          if (deletePower.length) {
            pcbLog.push(`[Update][Power Domains][${MAIN_POWER_NETS.join(',')}][Ports] Pins "${deletePower.join(',')}" does not exist.`)
          }
          if (deleteRefe.length) {
            pcbLog.push(`[Update][Power Domains][${MAIN_REF_NETS.join(',')}][Ports] Pins "${deleteRefe.join(',')}" does not exist.`)
          }
          const componentUpdate = getCompUpdateLog({ ...VRMInfo, MAIN_POWER_NETS }, content);
          pcbLog.push(...componentUpdate)
          const newInfo = mergeVRMInfo(VRMInfo, { ...content, ports }, isPreLayout);
          let newRow = {
            id: id,
            content: {
              ...content,
              ...newInfo,
              PowerNets: [...new Set([...MAIN_POWER_NETS, ...VRMInfo.PowerNets])],
            }
          }
          newData.push(newRow)
        }
        ICs.push(ic)
        pcbLayout.ICs = ICs
        const newDomains = getCompsBetweenPowerNets(designId, newData, doNotStuff)
        let _domains = [];
        for (let newDomain of newDomains) {
          if (!newDomain.domainComps) {
            _domains.push(newDomain);
            continue;
          }
          const domainComps = yield call(updateComponentDecapModel, {
            components: newDomain.domainComps,
            prevComps: [],
            designId: designId,
            voltage: newDomain.content.voltage || "1"
          })
          delete newDomain.domainComps;
          domainComps.forEach(cap => {
            const findIndex = newDomain.content.Components.findIndex(comp => comp.name === cap.name)
            if (findIndex < 0) {
              newDomain.content.Components.push(cap)
            } else if (newDomain.content.Components[findIndex].usage !== cap.usage) {
              newDomain.content.Components[findIndex].usage = cap.usage
            }
          })
          _domains.push(newDomain);
        }
        pcbLayout.powerDomains = _domains
        const connectors = pcbLayout.connectors
        let newConnectors = []
        if (connectors && connectors.length) {
          yield* connectors.map(function* (connector) {
            const name = connector.name
            if (loadComponents.includes(name)) {
              const fromComp = connector.from.length && connector.from[0].components ? connector.from[0].components[0] : null
              if (loadComponents.includes(fromComp)) {
                connector.from[0].designId = pcbId
              } else {
                yield put(updateLogs([{ type: 'error', text: `[Update][Power Domains] Can not find ${fromComp}.` }]))
                connector.from = []
              }

              const toNets = connector.to.length && connector.to[0].nets ? connector.to[0].nets : {}
              const newToNets = {}
              let toClearAll = false
              Object.keys(toNets).forEach(key => {
                const comp = key.split('-')[0]
                const id = key.split('-')[1]
                const nets = toNets[key]
                if (comp === name && id === designId) {
                  if (nets.every(value => pcbAllNets.includes(value))) {
                    newToNets[`${name}-${pcbId}`] = nets;
                  } else {
                    newToNets[`${name}-${pcbId}`] = [];
                    toClearAll = true;
                  }
                } else {
                  newToNets[key] = nets
                }
              })
              if (toClearAll) {
                yield put(updateLogs([{ type: 'error', text: `[Update][Power Domains] Can not find net connection on ${name}.` }]))
                Object.keys(newToNets).forEach(key => newToNets[key] = []);
              }
              if (Object.keys(newToNets).length) {
                connector.to[0].nets = newToNets
              }
              newConnectors.push(connector)
            } else {
              yield put(updateLogs([{ type: 'error', text: `[Update][Power Domains] Can not find ${name}.` }]))
            }
          })
        }
        pcbLayout.connectors = newConnectors.filter(item => !!item)

        const VRMs = newData.map(domain => (domain.content && domain.content.VRM && domain.content.VRM.map(vrm => vrm.VRM_COMP)) || []).flat(3);
        const PMICs = [...new Set(VRMs)].filter(vrm => !pcbLayout.connectors.find(conn => conn.name === vrm));
        pcbLayout.PMICs = PMICs.map(pmic => getImpedanceLayoutComp(pmic, pcbId, PMIC));
        const version = yield call(componentSetting.getVersion, pcbId);
        const COMP_PREFIX_LIB = { version: version }
        const pcbName = designConstructor.getDesignName(pcbId);
        pcbLayout.designId = pcbId;
        pcbLayout.designName = pcbName;
        pcbLayout.COMP_PREFIX_LIB = COMP_PREFIX_LIB;
        let newAdditionalNets = pcbLayout.additionalNets || [];
        if (newAdditionalNets.length) {
          const nets = getAllCascadeNets({ pcbId });
          const oldNets = getAllCascadeNets({ pcbId: designId });
          newAdditionalNets = oldNets.length === newAdditionalNets.length ? nets : newAdditionalNets.filter(net => nets.includes(net))
          pcbLayout.additionalNets = [...newAdditionalNets];
        }
      }

      const vendor = designConstructor.getDesignVendor(pcbId)
      let extraction = vendor === SPD ? new ImpExtraction({ parallelExtraction, type: POWERSI }) : new ImpExtraction({ parallelExtraction });
      if (data.length) {
        const layout = data.find(item => item.index !== TARGET_DIE_INDEX);
        if (layout) {
          extraction = new ImpExtraction({ parallelExtraction, ...(layout.extraction || {}) });
        }
      }
      pcbLayout.extraction = extraction

      const connectIndex = layouts.findIndex(item => item.index > pcbLayout.index)
      if (connectIndex > -1) {
        const _layout = layouts[connectIndex]
        const nextConnectors = _layout.connectors
        if (nextConnectors && nextConnectors.length) {
          nextConnectors.forEach(connector => {
            const fromComp = connector.from.length && connector.from[0].components[0] ? connector.from[0].components[0] : null
            const fromDesignId = connector.from.length && connector.from[0].designId ? connector.from[0].designId : null
            if (fromDesignId === designId) {
              if (loadComponents.includes(fromComp)) {
                connector.from[0].designId = pcbId
              } else {
                connector.from = []
              }
            }
            const fromNets = connector.from.length && connector.from[0].nets ? connector.from[0].nets : {}
            const newFromNets = {}
            let fromClearAll = false
            Object.keys(fromNets).forEach(key => {
              const comp = key.split('-')[0]
              const id = key.split('-')[1]
              const nets = fromNets[key]
              if (comp === fromComp && id === designId) {
                if (nets.every(value => pcbAllNets.includes(value))) {
                  newFromNets[`${fromComp}-${pcbId}`] = nets;
                } else {
                  newFromNets[`${fromComp}-${pcbId}`] = [];
                  fromClearAll = true;
                }
              } else {
                newFromNets[key] = nets
              }
            })
            if (fromClearAll) {
              Object.keys(newFromNets).forEach(key => newFromNets[key] = []);
            }
            if (Object.keys(newFromNets).length) {
              connector.from[0].nets = newFromNets
            }
          })
        }
        layouts[connectIndex].connectors = nextConnectors
      }
      layouts[pcbLayoutIndex] = pcbLayout
    }
    yield put(updatePCB(pcbId))
    yield call(saveLayouts, { data: layouts, update: true, verificationId });
    yield delay(100)
    yield call(getVRMs);
    yield call(saveSetup)
    return;
  }
}

function* openPowerNetSelectPanel(action) {
  const { obj: { open, isLoadingNets = false } } = action;
  if (!open || !isLoadingNets) {
    yield put(updateOpenTargetICLoading(false));
    return;
  }
  //open power nets panel
  const { CascadeReducer: { project: { openProjectId },
    Impedance: { targetIC, verificationId, designId, powerNetSelect } } } = yield select();
  if (powerNetSelect && powerNetSelect.allPowerNets && powerNetSelect.allPowerNets.length) {
    yield put(updateOpenTargetICLoading(false));
    return;
  }
  const designExist = projectDesigns.getDesignExist(openProjectId, designId)
  if (targetIC && designId && designExist && verificationId) {
    const setting = yield fork(componentSetting.getPrefixLib, designId);
    const { powerNets, allNets } = getPowerDomain({ chip: targetIC, designId, COMP_PREFIX_LIB: setting });
    const targetNets = powerNetSelect.select
    yield put(updateSelectedPowerNets({ select: targetNets, allPowerNets: [...new Set([...powerNets, ...targetNets])], allNets: [...allNets], open: true }))
    yield put(updateOpenTargetICLoading(false))
  }
}

function* openDiePowerNetSelectPanel(action) {
  const { obj: { open, isLoadingNets = false } } = action;
  if (!open || !isLoadingNets) {
    yield put(updateOpenTargetDieLoading(false));
    return;
  }
  //open power nets panel
  const { CascadeReducer: { project: { openProjectId },
    Impedance: { verificationId, designId, powerNetSelect, targetDie } } } = yield select();
  if (powerNetSelect && powerNetSelect.allPowerNets && powerNetSelect.allPowerNets.length) {
    yield put(updateOpenTargetDieLoading(false));
    return;
  }
  const designExist = projectDesigns.getDesignExist(openProjectId, designId)
  if (targetDie && targetDie.length && designId && designExist && verificationId) {
    const setting = yield call(componentSetting.getPrefixLib, designId);
    const { powerNets, allNets } = getPackagePowerDomain(designId, setting, targetDie);
    const targetNets = powerNetSelect.select
    yield put(updateSelectedPowerNets({ select: targetNets, allPowerNets: [...new Set([...powerNets, ...targetNets])], allNets: [...allNets], open: true }))
    yield put(updateOpenTargetDieLoading(false))
  }
}

function* reAssignDecapModel() {
  const { CascadeReducer: { Impedance: { data = [] } } } = yield select();

  yield put(updateImpedanceContent({ modelAssignLoading: true }));
  let _data = [...data];

  let existModelParts = [];
  yield* _data.map(function* (layout) {
    const { designId } = layout
    yield* layout.powerDomains.map(function* (item) {
      const info = yield call(updateComponentDecapModel, {
        designId,
        components: item.content.Components,
        prevComps: [],
        existModelParts,
        type: "re-assign",
        saveLib: false,
        voltage: item.content.voltage || "1"
      });
      item.content.Components = info.components;
      existModelParts = info.existModelParts;
    })
  })

  yield put(updateImpedanceContent({ data: _data, status: true, modelAssignLoading: false }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
  const { CascadeReducer: { project: { applyModelList, openProjectId } } } = yield select();
  yield call(updateLibSetting, { librarySettings: applyModelList, projectId: openProjectId });
}

function* deleteSensePath(action) {
  const { key, id, senseType } = action;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === page);
  if (findIndex < 0) {
    return;
  }
  const index = _data[findIndex].powerDomains.findIndex(item => item.id === id);
  const currentData = _data[findIndex].powerDomains[index] || null;
  if (!currentData) {
    return;
  }
  if (senseType === "power") {
    currentData.content.sensePorts.splice(key);
  } else if (senseType === "gnd") {
    currentData.content.sensePorts[key].groundSensePort = [];
  }
  _data[findIndex].powerDomains[index] = currentData;
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

let saveAdditionWork
function* saveAdditionalNets(action) {
  const { nets } = action;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  const findIndex = data.findIndex(item => item.designId === page);
  if (findIndex > -1) {
    let layouts = [...data];
    layouts[findIndex].additionalNets = nets
    yield put(updateImpedanceContent({ data: layouts }));
    yield put({ type: SAVE_POWER_DOMAIN, data: layouts });
  }
}

function* getImpedancePinMap(pcbId) {
  let pinMap = yield call(compPinMap.getPinMapData, pcbId);

  let pinMapList = []
  yield* pinMap.map(function* (_map) {
    let data = [];
    if (_map.libraryId) {
      try {
        const res = yield call([pinMapStore, pinMapStore.getPinMapLibrary], _map, pcbId, "pinName")
        data = res && res.config && res.config.pinTable ? [...res.config.pinTable] : [];
      } catch (error) {
        console.error("Can not find library file");
      }
    }
    pinMapList.push({ ..._map, data })
  })
  return pinMapList
}

// Impedance Package saga function
function* updateDesignPackage({ pcbId }) {
  const { CascadeReducer: { Impedance: { parallelExtraction, verificationId } } } = yield select();
  yield put(updateLogs([], true))
  yield call(deletePackageDomains);
  yield put(updateImpedanceContent({ data: [], targetIC: "", targetDie: [], status: true }));
  yield put(updateSelectPowerNets({ select: [], allPowerNets: [], allNets: [], open: false }))
  const isPreLayout = designConstructor.isPreLayout(pcbId);
  const version = yield call(componentSetting.getVersion, pcbId);
  const COMP_PREFIX_LIB = { version: version }
  const designName = designConstructor.getDesignName(pcbId);
  const vendor = designConstructor.getDesignVendor(pcbId)
  const meshPologen = designConstructor.getDesignMeshPolygon(pcbId);
  const extraction = new ImpExtraction({ parallelExtraction, type: vendor === SPD ? POWERSI : meshPologen ? HFSS : SIWAVE });
  if (auroraDBJson.isFlexBoard(pcbId)) {
    extraction.CLIP = 0
  }
  const _data = [new ImpLayout({ index: TARGET_PACKAGE_INDEX, designId: pcbId, designName, type: IMPEDANCE_PACKAGE, COMP_PREFIX_LIB, extraction })];
  yield call(saveLayouts, { data: _data, update: true, verificationId });
  if (isPreLayout) {
    const preData = yield call([preLayoutData, preLayoutData.getPreLayout], pcbId);
    const { content = {} } = preData;
    const { components = [] } = content;
    const Dies = components.filter(item => item.type === DIE).map(item => item.name);
    if (Dies.length) {
      yield put(updateImpedanceContent({ targetDie: Dies }));
      yield call(saveSetup);
    }
    yield call(updatePackageDomain, pcbId)
  }
}

function* switchDie(action) {
  const { die } = action;
  yield put(updateSelectPowerNets({ open: false }))
  const { CascadeReducer: { Impedance: { targetDie = [], data, designId, verificationId } } } = yield select();
  if (!_.isEqual(die, targetDie)) {
    let _data = [...data]
    const findIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
    if (findIndex < 0) {
      return;
    }

    yield put(updateImpedanceContent({ targetDie: die }));
    const pkgDesignId = _data[findIndex].designId
    if (pkgDesignId !== designId) {
      yield call(saveSetup);
      yield call(updatePackageDomain, pkgDesignId)
    } else {
      let _data = [...data];
      const setting = yield call(componentSetting.getPrefixLib, designId);
      const { powerNets, allNets, DIE, BGA } = getPackagePowerDomain(designId, setting, die);
      yield put(updateSelectPowerNets({ select: [], allPowerNets: [...powerNets], allNets: [...allNets], open: die && die.length ? true : false }))
      yield delay(10);
      yield call(saveSetup);

      const bgaObj = getImpedanceLayoutComp(BGA.name, designId, BGAConst);
      const dieObj = DIE.map(die => {
        const _dieObj = getImpedanceLayoutComp(die.name, designId, DIEConst)
        return _dieObj
      })

      const dieIndex = _data.findIndex(item => item.index === TARGET_DIE_INDEX)
      if (dieIndex > -1) {
        _data[dieIndex].ICs = []
        _data[dieIndex].customType = 'perPort'
      }

      const { ballSizeMap } = _data[findIndex]
      const ballSizeMapObj = new BallSizeMap({ ballSizeMap, comps: [...dieObj, bgaObj], designId })
      const _ballSizeMap = ballSizeMapObj.getBallSizeMap()

      _data[findIndex].Dies = dieObj;
      _data[findIndex].Bgas = [bgaObj];
      _data[findIndex].powerDomains = [];
      _data[findIndex].ballSizeMap = _ballSizeMap;

      yield put(updateImpedanceContent({ data: _data, status: true }));
      yield call(saveLayouts, { data: _data, update: true, verificationId })
    }
  }
}

function* deletePackageDomains() {
  const { CascadeReducer: { Impedance: { verificationId, data = [] } } } = yield select();
  const findIndex = data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
  if (findIndex > -1) {
    yield call(deleteImpedanceDomains, { verificationId, ids: data[findIndex].powerDomains.map(d => d.id) });
    let _data = [...data];
    _data[findIndex].powerDomains = [];
    yield put(updateImpedanceContent({ data: _data, status: true }));
  }
}

function* updatePackageDomain(pcbId, fromPCB) {
  const { CascadeReducer: { project: { openProjectId }, Impedance: { targetDie, verificationId, data = [], targetIC, designId: currentDesignId, designType, powerNetSelect: { select: selectNets = [] }, packageRelationship = [], limitBoundaryPowerPinsLumpedPort } } } = yield select();

  const isPreLayout = designConstructor.isPreLayout(pcbId);
  let setting = new CascadeCompRLCPrefixLib({})
  if (isPreLayout) {
    yield call([preLayoutData, preLayoutData.getPreLayout], pcbId)
  } else {
    setting = yield call([componentSetting, componentSetting.getPrefixLib], pcbId);
    yield call(getAuroraDB, pcbId);
  }

  let _data = [...data];
  if (!fromPCB) {
    const designList = CascadeChannels.getList(IMPEDANCE, openProjectId);
    const currentItem = [...designList].find(i => i.id === verificationId);
    yield put(openTabFooter());
    yield put(changeTabMenu({
      tabSelectKeys: ["detail"],
      currentVerificationId: verificationId,
      verificationName: currentItem ? currentItem.name : IMPEDANCE,
      menuType: "simulation"
    }))
    yield put(updateLogs([], true))
    yield delay(100);
  }
  const { allNets, powerNets, referenceNets, DIE, BGA } = getPackagePowerDomain(pcbId, setting, targetDie);
  if (!BGA.name) {
    return;
  }
  let _powerNets = [...powerNets];
  if (targetIC && selectNets.length && currentDesignId !== pcbId && !isPreLayout) {
    if (packageRelationship.length) {
      _powerNets = packageRelationship.map(ship => ship[IMPEDANCE_PACKAGE]).flat(2);
    } else {
      const isPCBPrelayout = designConstructor.isPreLayout(currentDesignId);
      let _nets = [], _packageRelationship = [];
      if (isPCBPrelayout) {
        let index = 0;
        for (let selectNet of selectNets) {
          const nets = _powerNets[index] ? [_powerNets[index]] : [];
          _nets.push(...nets);
          _packageRelationship.push({ [IMPEDANCE_PCB]: [selectNet], [IMPEDANCE_PACKAGE]: [...nets] });
          index++
        }
      } else {
        for (let selectNet of selectNets) {
          const { nets } = checkConnectCompsPinsAndNets({ designId: currentDesignId, name: targetIC, nets: [selectNet] }, { designId: pcbId, name: BGA.name })
          _nets.push(...nets.filter(net => !referenceNets.includes(net)));
          _packageRelationship.push({ [IMPEDANCE_PCB]: [selectNet], [IMPEDANCE_PACKAGE]: [...nets] });
        }
      }
      if (_nets.length) {
        _powerNets = [..._nets];
      }
      yield put(setPackageRelationship(_packageRelationship))
    }
  } else if (!isPreLayout) {
    _powerNets = selectNets.filter(item => allNets.includes(item))
  }
  if (isPreLayout) {
    if (designType !== IMPEDANCE_PACKAGE) {
      if (packageRelationship.length) {
        _powerNets = packageRelationship.map(ship => ship[IMPEDANCE_PACKAGE]).flat(2);
      } else {
        let _packageRelationship = [], _nets = [];
        const targetPCB = _data.find(item => item.designId === currentDesignId);
        if (targetPCB) {
          const MAIN_PCB_NETS = targetPCB.powerDomains.map(domain => domain.content.MAIN_POWER_NETS)
          MAIN_PCB_NETS.forEach((nets, index) => {
            _packageRelationship.push({ [IMPEDANCE_PCB]: nets, [IMPEDANCE_PACKAGE]: _powerNets[index] ? [_powerNets[index]] : [] })
            _nets.push(_powerNets[index])
          })
          if (_nets.length) {
            _powerNets = [..._nets];
          }
          yield put(setPackageRelationship(_packageRelationship))
        }
      }
    } else {
      yield put(updateSelectPowerNets({ select: _powerNets }));
    }
  }
  yield put(updateImpedanceLoading('Loading...'));
  const findIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
  if (findIndex < 0) {
    yield put(updateImpedanceLoading(false));
    return;
  }

  _powerNets = [...new Set(_powerNets)]
  const designName = designConstructor.getDesignName(pcbId);
  if (_powerNets.length) {
    yield put(updateLogs([{ type: 'success', text: `[Package] [${designName}] Found ${_powerNets.join(', ')}` }]))
  }

  let powerDomains = [];
  const _targetDie = [];
  const prevPowerDomains = _data[findIndex].powerDomains;
  yield call(deletePackageDomains);
  yield delay(100);

  for (let powerNet of _powerNets) {
    const lastPowerDomain = prevPowerDomains.find(item => item.content.MAIN_POWER_NETS && item.content.MAIN_POWER_NETS.includes(powerNet));
    const lastComponents = lastPowerDomain ? lastPowerDomain.content.Components || [] : prevPowerDomains.map(item => item.content.Components || []).flat();
    const packageVRMs = yield call(getPkgDomainInfo, {
      pcbId,
      powerNet,
      referenceNets,
      DIE: DIE.map(die => die.name),
      BGA: BGA.name,
      setting,
      limitBoundaryPowerPinsLumpedPort
    })

    if (!packageVRMs.add) {
      continue;
    }
    packageVRMs.domain.Components = yield call(updateComponentDecapModel, {
      components: packageVRMs.domain ? packageVRMs.domain.Components : [],
      prevComps: lastComponents,
      designId: pcbId
    })
    const { Die = [] } = setting
    const die = Die.filter(item => {
      return packageVRMs.domain.Components.find(comp => comp.name === item)
    })
    if (die.length && !_targetDie.some(d => die.includes(d))) {
      _targetDie.push(...die)
    }
    const findDomain = prevPowerDomains.find(domain => domain.content.MAIN_POWER_NETS.includes(powerNet));
    if (findDomain) {
      const { bgaPorts = [], diePorts = [] } = findDomain.content;
      packageVRMs.domain = { ...packageVRMs.domain, bgaPorts, diePorts }
    } else {
      const { CascadeReducer: { Impedance: { packageRelationship = [] } } } = yield select();
      const relationship = packageRelationship.find(item => item[IMPEDANCE_PACKAGE].includes(powerNet));
      if (relationship && relationship[IMPEDANCE_PCB]) {
        const targetPCB = _data.find(item => item.designId === currentDesignId);
        const pcbPorts = targetPCB.powerDomains.filter(item => item.content.MAIN_POWER_NETS.some(net => relationship[IMPEDANCE_PCB].includes(net))).map(item => item.content.ports).flat(2)
        if (pcbPorts.length) {
          if (BGA && BGA.name) {
            const compInfo = getCascadeComponents({ pcbId, name: BGA.name });
            if (compInfo) {
              if (isPreLayout) {
                packageVRMs.domain.bgaPorts = [...pcbPorts]
              } else {
                const pins = [...compInfo.pins.values()].filter(pin => powerNet.includes(pin.net)).map(pin => pin.pin);
                let _ports = pcbPorts.map(port => {
                  const { powerPins = [] } = port;
                  const _powerPins = powerPins.filter(pin => pins.includes(pin));
                  return { ...port, powerPins: _powerPins, importPowerPins: [], importReferencePins: [], target: [] }
                }).filter(port => port.powerPins.length);
                if (_ports.length) {
                  packageVRMs.domain.bgaPorts = _ports;
                }
              }
            }
          }
        }
      }
    }

    powerDomains.push({
      id: "",
      content: { ...packageVRMs.domain }
    })
  }

  yield call(packageDomainsHandle, { powerDomains, pcbId, setting, BGA, _targetDie, _powerNets })
}

function* savePackagePorts(action) {
  const { id, ports, portType } = action;
  const { CascadeReducer: { Impedance: { data, designId } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
  if (findIndex < 0) {
    return;
  }
  const index = _data[findIndex].powerDomains.findIndex(item => item.id === id);
  const currentData = _data[findIndex].powerDomains[index] || null;
  if (!currentData) {
    return;
  }
  currentData.content[portType] = ports ? [...ports] : [];
  _data[findIndex].powerDomains[index] = currentData;

  if (portType === 'diePorts') {
    const findDieIndex = _data.findIndex(item => item.index === TARGET_DIE_INDEX)
    if (findDieIndex > -1) {
      let newICs = []
      const pkgDesignId = _data[findIndex].designId
      _data[findIndex].powerDomains.forEach(domain => {
        const { content } = domain
        const { Components = [], diePorts = [] } = content
        const dieInfo = Components.find(item => item.usage === DIEConst)
        const die = dieInfo && dieInfo.name ? dieInfo.name : null
        const powerNet = content.MAIN_POWER_NETS.length ? content.MAIN_POWER_NETS[0] : null
        if (diePorts.length === 0) {
          newICs.push(new ImpDie({ die, designId: pkgDesignId, portIndex: "1", powerNet }))
        } else {
          diePorts.forEach(item => {
            newICs.push(new ImpDie({ die, designId: pkgDesignId, portIndex: String(item.port), powerNet }))
          })
        }
      })
      _data[findDieIndex].ICs = newICs
      _data[findDieIndex].customType = 'perPort'
    }
  }
  if (portType === 'bgaPorts') {
    const findPCBIndex = _data.findIndex(item => item.designId === designId);
    if (findPCBIndex > -1) {
      const pcbIsPreLayout = designConstructor.isPreLayout(designId)
      if (!pcbIsPreLayout) {
        let pcbIndex
        if (_data[findIndex].powerDomains.length === 1 && _data[findPCBIndex].powerDomains.length === 1) {
          pcbIndex = 0
        } else if (_data[findIndex].powerDomains.length > 1 || _data[findPCBIndex].powerDomains.length > 1) {
          pcbIndex = _data[findPCBIndex].powerDomains.findIndex(item => {
            return item.content.MAIN_POWER_NETS.length &&
              currentData.content.MAIN_POWER_NETS.length &&
              _.isEqual(item.content.MAIN_POWER_NETS, currentData.content.MAIN_POWER_NETS)
          });
        }
        const pcbCurrentData = _data[findPCBIndex].powerDomains[pcbIndex] || null;
        if (pcbIndex > -1) {
          const _ports = ports ? JSON.parse(JSON.stringify(ports)) : [];
          _ports.forEach(item => delete item.target)
          pcbCurrentData.content.ports = _ports
          _data[findPCBIndex].powerDomains[pcbIndex] = pcbCurrentData;
        }
      }
    }

    const findSocketIndex = _data.findIndex(item => item.type === IMPEDANCE_SOCKET)
    if (findSocketIndex > -1) {
      if (_data[findSocketIndex].socket && _data[findSocketIndex].socket.pairs && _data[findSocketIndex].socket.pairs.length) {
        _data[findSocketIndex].socket.pairs = []
      }
    }
  }

  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* updatePackageNets(action) {
  const { id, nets } = action;
  const { CascadeReducer: { Impedance: { data, targetDie, limitBoundaryPowerPinsLumpedPort } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
  if (findIndex < 0) {
    return;
  }
  const index = _data[findIndex].powerDomains.findIndex(item => item.id === id);
  if (index < 0) { return }
  _data[findIndex].powerDomains[index].content = { ..._data[findIndex].powerDomains[index].content, ...nets }
  const { PowerNets, ReferenceNets, Components = [] } = _data[findIndex].powerDomains[index].content;
  if (PowerNets.length && ReferenceNets.length) {
    const pcbId = _data[findIndex].designId;
    const setting = yield call([componentSetting, componentSetting.getPrefixLib], pcbId);

    const { DIE, BGA } = getPackagePowerDomain(pcbId, setting, targetDie);
    const packageVRMs = yield call(getPkgDomainInfo, {
      pcbId,
      powerNet: PowerNets[0],
      referenceNets: ReferenceNets,
      DIE: DIE.map(die => die.name),
      BGA: BGA.name,
      setting,
      custom: true,
      limitBoundaryPowerPinsLumpedPort
    })
    if (!packageVRMs.add) {
      yield put(updateImpedanceContent({ data: _data, status: true }));
      yield put({ type: SAVE_POWER_DOMAIN, data: _data });
      return;
    }

    packageVRMs.domain.Components = yield call(updateComponentDecapModel, {
      components: packageVRMs.domain ? packageVRMs.domain.Components : [],
      prevComps: Components,
      designId: pcbId
    })

    _data[findIndex].powerDomains[index].content = { ...packageVRMs.domain };
    const findDieIndex = _data.findIndex(item => item.index === TARGET_DIE_INDEX);
    if (findDieIndex > -1) {
      const { Components = [] } = packageVRMs.domain
      const comp = Components.find(item => item.usage === DIEConst)
      const powerNetExist = _data[findDieIndex].ICs.findIndex(ic => ic.powerNet === PowerNets[0])
      if (comp && comp.name && powerNetExist < 0) {
        const newIC = new ImpDie({ die: [comp.name], designId: _data[findIndex].designId, portIndex: "1", powerNet: PowerNets[0] })
        _data[findDieIndex].ICs.push(newIC)
      }
    }
  }
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* refindPackagePins(action) {
  const { id } = action;
  const { CascadeReducer: { Impedance: { data, designId, targetDie } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
  if (findIndex < 0) {
    return;
  }
  const setting = yield call(componentSetting.getPrefixLib, _data[findIndex].designId);
  const index = _data[findIndex].powerDomains.findIndex(item => item.id === id);
  if (index < 0) { return }
  let currentData = _data[findIndex].powerDomains[index];
  if (!currentData) {
    return;
  }
  const { content } = currentData;
  const { PowerNets, ReferenceNets, Components = [], diePorts = [] } = content;
  const BGA = Components.find(item => item.COMP_TYPE === 'BGA');
  const DIE = Components.filter(item => item.COMP_TYPE === 'DIE');
  if (!BGA || !DIE) {
    return;
  }
  const components = getNewPackageComp({ PowerNets, ReferenceNets, designId: _data[findIndex].designId, BGA: BGA ? BGA.name : '', DIE: DIE.map(die => die.name), setting });
  currentData.content.Components = yield call(updateComponentDecapModel, {
    components: components ? components : [],
    prevComps: Components,
    designId: _data[findIndex].designId
  });
  _data[findIndex].powerDomains[index] = { ...currentData };

  if (!_data[findIndex].Dies.some(die => DIE.map(die => die.name).includes(die.name))) {
    const dieObj = DIE.map(die => {
      const _dieObj = getImpedanceLayoutComp(die.name, _data[findIndex].designId, DIEConst)
      _dieObj.to = [{ components: [BGA.name], designId: _data[findIndex].designId }];
      return _dieObj
    })
    _data[findIndex].Dies.push(...dieObj);
  }
  const dieIndex = _data.findIndex(item => item.index === TARGET_DIE_INDEX)
  const dieNames = DIE.map(item => item.name)
  if (dieIndex > -1) {
    let ics = _data[dieIndex].ICs
    dieNames.forEach(item => {
      if (!ics.find(ic => ic.to[0].components[0] === item)) {
        if (diePorts.length === 0) {
          ics.push(new ImpDie({ die: [item], designId: _data[findIndex].designId, portIndex: "1", powerNet: PowerNets[0] }))
        } else {
          diePorts.forEach(item => {
            ics.push(new ImpDie({ die: [item], designId: _data[findIndex].designId, portIndex: String(item.port), powerNet: PowerNets[0] }))
          })
        }
      }
    })
    _data[dieIndex].ICs = ics
  }
  const _targetDie = targetDie
  dieNames.forEach(item => {
    if (!_targetDie.includes(item)) {
      _targetDie.push(item)
    }
  })
  yield put(updateImpedanceContent({ data: _data, targetDie: _targetDie, status: true }));
  yield delay(10);
  yield call(saveSetup)
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* switchPackagePorts(action) {
  const { lumped, compType } = action;
  const { CascadeReducer: { Impedance: { data, designId: currentDesignId, targetIC, limitBoundaryPowerPinsLumpedPort } } } = yield select();
  yield put(updateImpedanceLoading('Loading...'));
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
  const findPCBIndex = _data.findIndex(item => item.type === IMPEDANCE_PCB);
  const pcbIsPreLayout = designConstructor.isPreLayout(currentDesignId)
  if (findIndex < 0) {
    return;
  }
  const designId = _data[findIndex].designId;
  const portType = compType === BGAConst ? 'bgaPorts' : 'diePorts';

  if (compType === BGAConst) {
    const findSocketIndex = _data.findIndex(item => item.type === IMPEDANCE_SOCKET)
    if (findSocketIndex > -1) {
      if (_data[findSocketIndex].socket && _data[findSocketIndex].socket.pairs && _data[findSocketIndex].socket.pairs.length) {
        _data[findSocketIndex].socket.pairs = []
      }
    }
  }

  if (compType === 'BGA') {
    const findSocketIndex = _data.findIndex(item => item.type === IMPEDANCE_SOCKET)
    if (findSocketIndex > -1) {
      if (_data[findSocketIndex].socket && _data[findSocketIndex].socket.pairs && _data[findSocketIndex].socket.pairs.length) {
        _data[findSocketIndex].socket.pairs = []
      }
    }
  }

  if (compType === 'BGA') {
    const findSocketIndex = _data.findIndex(item => item.type === IMPEDANCE_SOCKET)
    if (findSocketIndex > -1) {
      if (_data[findSocketIndex].socket && _data[findSocketIndex].socket.pairs && _data[findSocketIndex].socket.pairs.length) {
        _data[findSocketIndex].socket.pairs = []
      }
    }
  }

  if (lumped) {
    if (compType === BGAConst) {
      _data[findIndex].powerDomains.forEach(row => {
        const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [], Components = [] } = row.content
        const bgaComp = Components.find(item => item.usage === BGAConst)
        const comp = bgaComp ? bgaComp.name : ''
        const ports = limitBoundaryPowerPinsLumpedPort ? getPowerPinsLumpedPort(designId, comp, MAIN_POWER_NETS, MAIN_REF_NETS) : []
        row.content[portType] = ports
      })
      if (findPCBIndex > -1 && !pcbIsPreLayout) {
        _data[findPCBIndex].powerDomains.forEach(row => {
          const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [] } = row.content
          const ports = limitBoundaryPowerPinsLumpedPort ? getPowerPinsLumpedPort(currentDesignId, targetIC, MAIN_POWER_NETS, MAIN_REF_NETS) : []
          row.content.ports = ports
        })
      }
    } else {
      _data[findIndex].powerDomains.forEach(row => {
        const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [], Components = [] } = row.content
        const dieComp = Components.find(item => item.usage === DIEConst)
        const comp = dieComp ? dieComp.name : ''
        const ports = limitBoundaryPowerPinsLumpedPort ? getPowerPinsLumpedPort(designId, comp, MAIN_POWER_NETS, MAIN_REF_NETS) : []
        row.content[portType] = ports
      })
    }
    yield put(updateImpedanceContent({ data: _data, status: true }));
  } else {
    try {
      yield call(getLayoutDB, designId);
    } catch (error) {
      console.error(error)
      return;
    }

    for (let i = 0; i < _data[findIndex].powerDomains.length; i++) {
      let _content = _data[findIndex].powerDomains[i].content || {};
      // if (_content[portType] && _content[portType].length) {
      //   continue;
      // }

      const { PowerNets, ReferenceNets, Components } = _content

      const component = Components.find(item => item.COMP_TYPE === compType);
      if (!component) {
        continue;
      }

      const DesignData = LayoutData.getLayout(designId, true);
      const filterData = getPortData(DesignData, component.name, PowerNets, ReferenceNets);
      const { powerPins, referencePins, data: PCBData } = filterData;
      let newPorts = []
      if (PowerNets.length === 1 && powerPins[PowerNets[0]] && powerPins[PowerNets[0]].length === 1 &&
        ReferenceNets.length === 1 && referencePins[ReferenceNets[0]] && referencePins[ReferenceNets[0]].length === 1) {
        newPorts = [{ port: "1", powerPins: powerPins[PowerNets[0]], referencePins: referencePins[ReferenceNets[0]] }]
      } else {
        const powers = Object.values(powerPins).flat(2), refe = Object.values(referencePins).flat(2);
        const pinsInfo = PCBData.getComponent(component.name).mPinsLocationList;
        const powerInfo = pinsInfo.filter(pin => powers.includes(pin.pin)).map(pin => ({ ...pin, ...pin.mLocation })),
          refeInfo = pinsInfo.filter(pin => refe.includes(pin.pin)).map(pin => ({ ...pin, ...pin.mLocation }));
        const powerInfoWithRefe = autoSplitRefeByPower(powerInfo, refeInfo, []);
        newPorts = powers.map((p, index) => {
          const find = powerInfoWithRefe.find(item => item.pinNumber === p);
          return { port: String(index + 1), powerPins: [p], referencePins: find ? [...find.refePins] : [] }
        });
      }

      _data[findIndex].powerDomains[i].content[portType] = newPorts

      if (compType === 'BGA' && findPCBIndex > -1 && !pcbIsPreLayout) {
        let pcbIndex
        if (_data[findIndex].powerDomains.length === 1 && _data[findPCBIndex].powerDomains.length === 1) {
          pcbIndex = 0
        } else if (_data[findIndex].powerDomains.length > 1 || _data[findPCBIndex].powerDomains.length > 1) {
          pcbIndex = _data[findPCBIndex].powerDomains.findIndex(item => {
            return item.content.MAIN_POWER_NETS.length &&
              _data[findIndex].powerDomains[i].content.MAIN_POWER_NETS.length &&
              _.isEqual(item.content.MAIN_POWER_NETS, _data[findIndex].powerDomains[i].content.MAIN_POWER_NETS)
          });
        }
        const pcbCurrentData = _data[findPCBIndex].powerDomains[pcbIndex] || null;
        if (pcbIndex > -1) {
          const _ports = newPorts ? JSON.parse(JSON.stringify(newPorts)) : [];
          _ports.forEach(item => delete item.target)
          pcbCurrentData.content.ports = _ports
          _data[findPCBIndex].powerDomains[pcbIndex] = pcbCurrentData;
        }
      }
    }
  }

  const findDieIndex = _data.findIndex(item => item.index === TARGET_DIE_INDEX)
  if (findDieIndex > -1 && compType !== 'BGA') {
    let newICs = []
    const pkgDesignId = _data[findIndex].designId
    _data[findIndex].powerDomains.forEach(domain => {
      const { content } = domain
      const { Components = [], diePorts = [] } = content
      const dieInfo = Components.find(item => item.usage === DIEConst)
      const die = dieInfo && dieInfo.name ? dieInfo.name : null
      const powerNet = content.MAIN_POWER_NETS.length ? content.MAIN_POWER_NETS[0] : null
      if (diePorts.length === 0) {
        newICs.push(new ImpDie({ die, designId: pkgDesignId, portIndex: "1", powerNet }))
      } else {
        diePorts.forEach(item => {
          newICs.push(new ImpDie({ die, designId: pkgDesignId, portIndex: String(item.port), powerNet }))
        })
      }
    })
    _data[findDieIndex].ICs = newICs
    _data[findDieIndex].customType = 'perPort'
  }
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield delay(5);
  yield put({ type: SAVE_POWER_DOMAIN, data: [..._data] });
  yield put(updateImpedanceLoading(false));
}

function* updateBallSize(action) {
  const { pcbId, ballShape, ballSize, ballHeight, ballMiddle, ballMaterial, notGroupPositivePin, compTab } = action
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  let _data = JSON.parse(JSON.stringify(data));
  const index = _data.findIndex(item => item.designId === pcbId);
  if (index < 0) {
    return;
  }
  const ballSizeMap = _data[index].ballSizeMap || {};
  ballSizeMap[compTab] = { ballShape, ballSize, ballHeight, ballMiddle, ballMaterial }
  _data[index].ballSizeMap = { ...ballSizeMap }

  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: [..._data] });
}

function* updatePkgDomain(action) {
  const { update } = action;
  yield put(needUpdateCompSetting(false));

  if (!update) {
    return;
  }

  if (update === 'updateVersion') {
    const { CascadeReducer: { Impedance: { data, designId, verificationId } } } = yield select();
    let _data = [...data];
    const version = yield call([componentSetting, componentSetting.getVersion], designId);
    const findIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
    _data[findIndex].COMP_PREFIX_LIB = { version: version };
    yield call(saveLayouts, { data: _data, update: true, verificationId });
    return;
  }

  const { CascadeReducer: { Impedance: { data, designId, verificationId, targetDie, powerNetSelect: { select: selectNets = [] }, limitBoundaryPowerPinsLumpedPort } } } = yield select();
  const version = yield call([componentSetting, componentSetting.getVersion], designId);

  yield put(updateImpedanceLoading('Loading...'));
  yield delay(10);

  const setting = yield call(componentSetting.getPrefixLib, designId);
  const _targetDie = targetDie.filter(item => setting.Die.includes(item));
  const { DIE, BGA, powerNets, referenceNets, allNets } = getPackagePowerDomain(designId, setting, _targetDie);

  let _data = [...data];
  const findIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
  if (findIndex < 0) {
    yield put(updateImpedanceLoading(false));
    return;
  }
  yield call(deleteImpedanceDomains, { verificationId, ids: _data[findIndex].powerDomains.map(d => d.id) });

  let _powerNets = selectNets.filter(item => allNets.includes(item))
  let powerDomains = []
  for (let powerNet of _powerNets) {
    const packageVRMs = yield call(getPkgDomainInfo, {
      pcbId: designId,
      powerNet,
      referenceNets,
      DIE: DIE.map(die => die.name),
      BGA: BGA.name,
      setting,
      limitBoundaryPowerPinsLumpedPort
    })

    if (!packageVRMs.add) {
      continue;
    }

    const prevData = _data[findIndex].powerDomains.find(item => item.content.PowerNets.some(p => p === powerNet));
    const prevComps = prevData ? prevData.content.Components : _data[findIndex].powerDomains.map(item => item.content.Components || []).flat()
    packageVRMs.domain.Components = yield call(updateComponentDecapModel, {
      components: packageVRMs.domain ? packageVRMs.domain.Components : [],
      prevComps: prevComps,
      designId
    })

    powerDomains.push({
      id: "",
      content: { ...packageVRMs.domain }
    })
  }

  _data[findIndex].powerDomains = [...powerDomains]

  const bgaObj = getImpedanceLayoutComp(BGA.name, designId, BGAConst);
  bgaObj.from = [{ components: DIE.map(die => die.name), designId }];
  const dieObj = DIE.map(die => {
    const _dieObj = getImpedanceLayoutComp(die.name, designId, DIEConst)
    _dieObj.to = [{ components: [BGA.name], designId }];
    return _dieObj
  })

  const ballSizeMapObj = new BallSizeMap({ comps: [...dieObj, bgaObj], designId })
  const _ballSizeMap = ballSizeMapObj.getBallSizeMap()

  let targetNets = []
  _data[findIndex].powerDomains.forEach(domain => {
    targetNets.push(...domain.content.MAIN_POWER_NETS)
  })
  targetNets = [...new Set(targetNets)];

  yield put(updateSelectedPowerNets({ select: targetNets, allPowerNets: [], allNets: [], open: false }))

  const dieIndex = _data.findIndex(item => item.index === TARGET_DIE_INDEX)
  if (dieIndex > -1) {
    const oldICs = _data[dieIndex].ICs || []
    let newICs = []
    let notUpdate = true
    _data[findIndex].powerDomains.forEach(domain => {
      const { content } = domain
      const { Components = [], diePorts = [] } = content
      const dieInfo = Components.find(item => item.usage === DIEConst)
      const die = dieInfo && dieInfo.name ? dieInfo.name : null
      const powerNet = content.MAIN_POWER_NETS.length ? content.MAIN_POWER_NETS[0] : null
      const ports = diePorts.length ? diePorts : [{ port: 1 }]
      const filterICs = oldICs.filter(ic => ic.to && ic.to[0] && ic.to[0].components && ic.to[0].components[0] === die)
      if (ports.length !== filterICs.length) {
        notUpdate = false
      }
      ports.forEach(p => {
        const portIndex = String(p.port)
        const oldIC = notUpdate ? filterICs.find(ic => ic.portIndex === portIndex && ic.powerNet === powerNet) || null : null
        if (notUpdate && !oldIC) notUpdate = false
        const newIC = oldIC ? Object.assign({}, oldIC, { portIndex, powerNet, to: [{ designId, components: [die] }] }) : new ImpDie({ die, designId, portIndex, powerNet })
        newICs.push(newIC)
      })
    })
    _data[dieIndex].ICs = newICs
    _data[dieIndex].customType = notUpdate ? _data[dieIndex].customType || 'perPort' : 'perPort'
  }

  _data[findIndex].Dies = dieObj;
  _data[findIndex].Bgas = [bgaObj];
  _data[findIndex].ballSizeMap = _ballSizeMap;
  _data[findIndex].COMP_PREFIX_LIB = { version: version }
  yield put(updateImpedanceContent({ targetDie: _targetDie }));
  yield delay(10);
  yield call(saveSetup);
  yield call(saveLayouts, { data: _data, update: true, verificationId });
  yield put(updateImpedanceLoading(false));
}

function* saveWireBondFile(action) {
  const { libraryId, designId } = action;
  if (!designId) {
    return;
  }
  try {
    yield call(savePackageWireBondProfile, { libraryId: libraryId || null, designId });
  } catch (error) {
    console.error(error)
  }
}
// End (Impedance Package saga)

function* changePageByDesign(action) {
  const { page } = action;
  const designName = designConstructor.getDesignName(page)
  yield put(updateImpedanceLoading(`Loading PCB - ${designName}...`));
  if (page && page !== OVERVIEW) {
    yield delay(100);
    yield call(getAuroraDB, page);
  }
  yield put(updateImpedanceContent({ page }));
  yield put(updateImpedanceLoading(false));
}

function* createLayout(action) {
  const { pcbId, connectors, asInterposer, asPassiveBoard } = action;
  const { CascadeReducer: { Impedance: { data, parallelExtraction, verificationId } } } = yield select();
  let _data = JSON.parse(JSON.stringify(data));
  const version = yield call(componentSetting.getVersion, pcbId);
  const COMP_PREFIX_LIB = { version: version }
  const designName = designConstructor.getDesignName(pcbId);
  const isPreLayout = designConstructor.isPreLayout(pcbId);
  const vendor = designConstructor.getDesignVendor(pcbId)
  const type = isPreLayout ? designConstructor.getPreLayoutType(pcbId) : designConstructor.getDesignType(pcbId);
  const meshPologen = designConstructor.getDesignMeshPolygon(pcbId);
  let extraction = new ImpExtraction({ parallelExtraction, type: vendor === SPD ? POWERSI : meshPologen ? HFSS : SIWAVE });
  if (data.length) {
    const layout = data.find(item => item.index !== TARGET_DIE_INDEX);
    if (layout) {
      extraction = new ImpExtraction({ parallelExtraction, ...(layout.extraction || {}) });
    }
  }
  if (auroraDBJson.isFlexBoard(pcbId) || asInterposer) {
    extraction.CLIP = 0
  }
  if ([IMPEDANCE_PACKAGE, IMPEDANCE_PCB].includes(type) && !isPreLayout) {
    yield* checkMaterialList(pcbId);
  }
  if (type === IMPEDANCE_PACKAGE) {
    const newLayout = new ImpLayout({ index: TARGET_PACKAGE_INDEX, designId: pcbId, designName, type, COMP_PREFIX_LIB, extraction });
    _data = _data.filter(item => item.index !== TARGET_PACKAGE_INDEX);
    _data.forEach(layout => {
      layout.ICs.forEach(ic => {
        ic.applyCurrent = false
      })
    })
    _data.push(newLayout);
    yield put(updateImpedanceContent({ data: _data, status: true }));
    let Dies = [];
    if (isPreLayout) {
      const preData = yield call([preLayoutData, preLayoutData.getPreLayout], pcbId);
      const { content = {} } = preData;
      const { components = [] } = content;
      Dies = components.filter(item => item.type === DIE).map(item => item.name);
    } else {
      const setting = yield call([componentSetting, componentSetting.getPrefixLib], pcbId);
      const { Die = [] } = setting;
      Dies = Die;
    }
    if (Dies.length > 0) {
      yield put(updateImpedanceContent({ targetDie: Dies }));
      yield call(saveSetup);
    }
    yield call(updatePackageDomain, pcbId)
    return;
  }
  let maxIndex = getConnectorLayoutIndex(connectors, _data);
  let newLayoutIndex = _data.findIndex(item => item.designId === pcbId);
  if (newLayoutIndex < 0) {
    const newLayout = new ImpLayout({ index: maxIndex + 1, designId: pcbId, designName, type: asInterposer ? IMPEDANCE_INTERPOSER_LAYOUT : type, COMP_PREFIX_LIB, extraction, asPassiveBoard });
    _data.push(newLayout);
    newLayoutIndex = _data.length - 1;
  } else {
    maxIndex = _data[newLayoutIndex].index - 1;
  }

  let newConnectorsPCB = [], interposerLayout = [];
  if (asInterposer) {
    interposerLayout.push(pcbId);
  }
  if (connectors.length) {
    if (_data[newLayoutIndex].type === IMPEDANCE_INTERPOSER_LAYOUT) {
      interposerLayout.push(pcbId);
    }
    for (let connector of connectors) {
      const { name, netShip, designId: _designId } = connector;
      if (!name) continue;
      let currentConnIndex = _data[newLayoutIndex].connectors.findIndex(c => c.name === name);
      _data[newLayoutIndex].PMICs = _data[newLayoutIndex].PMICs.filter(c => c.name !== name);
      if (currentConnIndex < 0) {
        let component = getImpedanceLayoutComp(name, pcbId, CONNECTOR);
        _data[newLayoutIndex].connectors.push(component);
        currentConnIndex = _data[newLayoutIndex].connectors.length - 1;
      }
      newConnectorsPCB.push(pcbId);
      for (let ship of netShip) {
        const { designId, connector, nets: connectNets, asInterposer, asPassiveBoard } = ship;
        if (!connector) continue;
        let layoutIndex = _data.findIndex(item => item.designId === designId);
        if (layoutIndex < 0) {
          const version = yield call(componentSetting.getVersion, designId);
          const COMP_PREFIX_LIB = { version: version }
          const designName = designConstructor.getDesignName(designId);
          const type = designConstructor.getDesignType(designId);
          if (auroraDBJson.isFlexBoard(designId) || asInterposer) {
            extraction.CLIP = 0
          } else {
            extraction.CLIP = 1
          }
          const _newLayout = new ImpLayout({ index: maxIndex + 2, designId, designName, type: asInterposer ? IMPEDANCE_INTERPOSER_LAYOUT : type, COMP_PREFIX_LIB, extraction, asPassiveBoard });
          _data.push(_newLayout);
          layoutIndex = _data.length - 1;
        }

        let connComp = getImpedanceLayoutComp(connector, designId, CONNECTOR);
        let currentKey = _data[layoutIndex].index < _data[newLayoutIndex].index ? 'from' : 'to';
        let connKey = currentKey === 'to' ? 'from' : 'to';
        if (_data[layoutIndex].type === IMPEDANCE_INTERPOSER_LAYOUT) {
          interposerLayout.push(designId);
        } else {
          newConnectorsPCB.push(designId);
        }

        let nets = {
          [`${name}-${_designId}`]: [],
          [`${connector}-${designId}`]: []
        }
        for (let connectNet of connectNets) {
          if (!connectNet[0] || !connectNet[1]) {
            continue;
          }
          nets[`${name}-${_designId}`].push(connectNet[0]);
          nets[`${connector}-${designId}`].push(connectNet[1]);
        }
        _data[newLayoutIndex].connectors[currentConnIndex][currentKey] = _data[newLayoutIndex].connectors[currentConnIndex][currentKey].filter(item => item.designId !== designId || (item.designId === designId && !item.components.includes(connector)))
        _data[newLayoutIndex].connectors[currentConnIndex][currentKey].push({ designId, components: [connector], nets });

        let connIndex = _data[layoutIndex].connectors.findIndex(c => c.name === connector);
        _data[layoutIndex].PMICs = _data[layoutIndex].PMICs.filter(c => c.name !== connector);
        if (connIndex < 0) {
          _data[layoutIndex].connectors.push(connComp);
          connIndex = _data[layoutIndex].connectors.length - 1
        }
        _data[layoutIndex].connectors[connIndex][connKey] = _data[layoutIndex].connectors[connIndex][connKey].filter(item => item.designId !== pcbId || (item.designId === pcbId && !item.components.includes(name)))
        _data[layoutIndex].connectors[connIndex][connKey].push({ designId: pcbId, components: [name], nets })
      }
    }
  }
  yield call(saveLayouts, { data: _data, update: true, verificationId });
  if (newConnectorsPCB.length) {
    yield call(getVRMs, { designIds: newConnectorsPCB })
  }
  if (interposerLayout.length) {
    yield call(getInterposers, { designIds: interposerLayout })
  }
}

const compTypes = ['connectors', 'Bgas', 'Dies', 'ICs', 'PMICs'];
function* deleteLayout(action) {
  const { pcbId, index } = action;
  const { CascadeReducer: { Impedance: { data, verificationId } } } = yield select();

  yield put(updateImpedanceLoading(true));

  let _data = [];
  const isPackage = data.find(item => item.designId === pcbId && item.index === TARGET_PACKAGE_INDEX);
  const isDie = data.find(item => item.designId === pcbId && item.index === TARGET_DIE_INDEX);
  const isSocket = data.find(item => item.designId === pcbId && item.type === IMPEDANCE_SOCKET && item.index === index);
  if (isSocket) {
    const targetIndex = data.findIndex(item => item.designId === pcbId && item.type === IMPEDANCE_SOCKET && item.index === index);
    if (targetIndex > -1) {
      _data = JSON.parse(JSON.stringify(data))
      const nextLayout = data.length > targetIndex + 1 ? data[targetIndex + 1] : null
      const nextLayoutType = nextLayout ? nextLayout.type : null
      if (nextLayoutType === IMPEDANCE_PACKAGE) {
        for (let i = 0; i < targetIndex; i++) {
          _data[i].index -= 1;
        }
      } else {
        for (let i = targetIndex; i < data.length; i++) {
          _data[i].index -= 1;
        }
      }
      _data.splice(targetIndex, 1);
    }
  } else {
    for (let i = 0; i < data.length; i++) {
      const layout = data[i];
      if (layout.designId === pcbId) {
        if (i > 0 && data[i - 1].type === IMPEDANCE_SOCKET) {
          data[i - 1]._skip = true;
        }
        if (i < data.length - 1 && data[i + 1].type === IMPEDANCE_SOCKET) {
          data[i + 1]._skip = true;
        }
      }
    }

    for (let layout of data) {
      if (layout._skip) {
        continue;
      };

      if (isPackage && layout.index === TARGET_DIE_INDEX) {
        continue;
      }

      if (layout.designId !== pcbId) {
        let _layout = { ...layout };
        for (let compType of compTypes) {
          if (!_layout[compType]) {
            continue;
          }
          _layout[compType].forEach(conn => {
            conn.from = conn.from.filter(item => item.designId !== pcbId);
            conn.to = conn.to.filter(item => item.designId !== pcbId);
          })
        }
        _data.push(layout);
      }
    }
  }
  if (isDie || isPackage) {
    yield put(updateImpedanceContent({ hasInterposer: false }));
    if (isPackage) {
      yield put(updateImpedanceContent({ targetDie: [], packageRelationship: [] }));
    }
    yield delay(10);
    yield call(saveSetup);
  }
  yield call(saveLayouts, { data: _data, update: true, verificationId });
  yield put(updateImpedanceLoading(false));
}

function* deleteLayoutConnector(action) {
  const { pcbId, connector } = action;
  const { CascadeReducer: { Impedance: { data, verificationId } } } = yield select();
  let _data = [...data];
  const checkComps = ['Bgas', 'Dies', 'ICs', 'PMICs', 'connectors']
  const findIndex = _data.findIndex(item => item.designId === pcbId);
  if (findIndex > -1) {
    const conn = _data[findIndex].connectors.find(iten => iten.name === connector);
    if (conn) {
      _data[findIndex].connectors = _data[findIndex].connectors.filter(c => c.name !== connector);
      const connection = [...conn.from, ...conn.to];
      for (let connect of connection) {
        const { components, designId } = connect;
        const findIndex = _data.findIndex(item => item.designId === designId);
        if (findIndex < 0) {
          continue;
        }
        checkComps.forEach(type => {
          if (_data[findIndex][type]) {
            _data[findIndex][type] = _data[findIndex][type].map(comp => {
              if (components.includes(comp.name)) {
                let newComp = { ...comp };
                newComp.from.forEach(f => {
                  f.components = f.components.filter(fc => fc !== connector);
                  f.nets && delete f.nets[`${connector}-${pcbId}`];
                })
                newComp.from = newComp.from.filter(f => f.components.length);

                newComp.to.forEach(t => {
                  t.components = t.components.filter(tc => tc !== connector);
                  t.nets && delete t.nets[`${connector}-${pcbId}`];
                })
                newComp.to = newComp.to.filter(t => t.components.length);
                return newComp;
              }
              return comp;
            })
          }
        })
      }
    }
    yield call(saveLayouts, { data: _data, update: true, verificationId });
  }
}

function* traceByLayout() {
  yield call(getVRMs);
}

function* deleteShip(action) {
  const { ship, connector } = action;
  const { designId, connector: connName } = ship
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  let _data = [...data];
  const designIndex = _data.findIndex(item => item.designId === designId);
  if (designIndex > -1) {
    let connIndex = _data[designIndex].connectors.findIndex(item => item.name === connName);
    if (connIndex > -1) {
      const fromIndex = _data[designIndex].connectors[connIndex].from.findIndex(item => item.components.includes(connector.name) && item.designId === connector.designId);
      if (fromIndex > -1) {
        const fromItem = _data[designIndex].connectors[connIndex].from[fromIndex];
        fromItem.components = fromItem.components.filter(comp => comp !== connector.name);
        if (!fromItem.components.length) {
          _data[designIndex].connectors[connIndex].from.splice(fromIndex, 1)
        }
      }

      const toIndex = _data[designIndex].connectors[connIndex].to.findIndex(item => item.components.includes(connector.name) && item.designId === connector.designId);
      if (toIndex > -1) {
        const toItem = _data[designIndex].connectors[connIndex].to[toIndex];
        toItem.components = toItem.components.filter(comp => comp !== connector.name);
        if (!toItem.components.length) {
          _data[designIndex].connectors[connIndex].to.splice(toIndex, 1)
        }
      }
    }
  }

  const { designId: _designId, name } = connector;
  const _designIndex = _data.findIndex(item => item.designId === _designId);
  if (_designIndex > -1) {
    let connIndex = _data[_designIndex].connectors.findIndex(item => item.name === name);
    if (connIndex > -1) {
      const fromIndex = _data[_designIndex].connectors[connIndex].from.findIndex(item => item.components.includes(ship.connector) && item.designId === ship.designId);
      if (fromIndex > -1) {
        const fromItem = _data[_designIndex].connectors[connIndex].from[fromIndex];
        fromItem.components = fromItem.components.filter(comp => comp !== ship.connector);
        if (!fromItem.components.length) {
          _data[_designIndex].connectors[connIndex].from.splice(fromIndex, 1)
        }
      }

      const toIndex = _data[_designIndex].connectors[connIndex].to.findIndex(item => item.components.includes(ship.connector) && item.designId === ship.designId);
      if (toIndex > -1) {
        const toItem = _data[_designIndex].connectors[connIndex].to[toIndex];
        toItem.components = toItem.components.filter(comp => comp !== ship.connector);
        if (!toItem.components.length) {
          _data[_designIndex].connectors[connIndex].to.splice(toIndex, 1)
        }
      }
    }
  }

  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: [..._data] });
}

function* createDie(action) {
  const { update } = action
  const { CascadeReducer: { Impedance: { data, verificationId } } } = yield select();
  yield put(updateImpedanceLoading(true));
  yield delay(100)

  let _data = JSON.parse(JSON.stringify(data));
  const newLayout = new ImpLayout({ index: TARGET_DIE_INDEX, designId: IMPEDANCE_DIE, designName: 'Die', type: IMPEDANCE_DIE });
  const pkgIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX)
  if (pkgIndex < 0) {
    return;
  }
  let newICs = []
  const pkgDesignId = _data[pkgIndex].designId
  _data[pkgIndex].powerDomains.forEach(domain => {
    const { content } = domain
    const die = content.Components.find(item => item.usage === DIE).name
    const powerNet = content.MAIN_POWER_NETS.length ? content.MAIN_POWER_NETS[0] : null
    if (content.diePorts.length === 0) {
      newICs.push(new ImpDie({ die, designId: pkgDesignId, portIndex: "1", powerNet }))
    } else {
      content.diePorts.forEach(item => {
        const ic = new ImpDie({ die, designId: pkgDesignId, portIndex: String(item.port), powerNet })
        newICs.push(ic)
      })
    }
  })

  newLayout.ICs = [...newICs]
  newLayout.customType = 'perPort'
  _data = _data.filter(item => item.index !== TARGET_DIE_INDEX);
  if (update) {
    _data.forEach(layout => {
      if (layout.extraction && layout.extraction.enableLinearSweep) {
        const length = layout.extraction.customFrequencySweep.length
        if (length > 0 && layout.extraction.customFrequencySweep[length - 1].end === '2e8') {
          layout.extraction.customFrequencySweep[length - 1].end = '2e9'
        }
      } else if (layout.extraction && layout.extraction.FMAX && layout.extraction.FMAX === '2e8') {
        layout.extraction.FMAX = '2e9'
      }
    })
  }
  _data.push(newLayout);
  _data[pkgIndex].Dies.forEach(item => item.from = [{ designId: IMPEDANCE_DIE, components: ['Die'] }]);
  yield call(saveLayouts, { data: _data, update: true, verificationId });
  yield put(updateImpedanceLoading(false));
}

function* saveOnDieModel(action) {
  const { model, targetDie, modelPowerNet, modelIndex, apply, customType, dieCurrentList } = action;
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  let _data = JSON.parse(JSON.stringify(data));
  const dieIndex = _data.findIndex(item => item.type === IMPEDANCE_DIE)
  const pkg = _data.find(item => IMPEDANCE_PACKAGE_LIST.includes(item.type))
  if (dieIndex < -1) {
    return;
  }
  const prevCustomType = _data[dieIndex].customType
  _data[dieIndex].customType = customType
  if (customType === 'perPort') {
    if (apply) {
      _data[dieIndex].ICs.forEach(ic => {
        if (ic.to[0].components[0] === targetDie) {
          if (model.type === 'value') {
            ic.model = model
          } else {
            const { pairs = [], ...modelInfo } = model
            const domainIndex = pkg.powerDomains.findIndex(item => item.content.PowerNets && item.content.PowerNets.length && item.content.PowerNets[0] === ic.powerNet)
            let pin = ic.portIndex
            if (domainIndex > -1) {
              const port = (pkg.powerDomains[domainIndex].content.diePorts || []).find(p => String(p.port) === String(ic.portIndex));
              if (port && port.portName) {
                pin = port.portName
              }
            }
            const newPairs = JSON.parse(JSON.stringify(pairs))
            if (newPairs.length) {
              newPairs[0].pin = pin
            }
            ic.model = { ...modelInfo, pairs: [...newPairs] }
          }
        }
      })
    } else {
      _data[dieIndex].ICs.forEach(ic => {
        if (ic.powerNet === modelPowerNet && ic.portIndex === modelIndex && ic.to[0].components[0] === targetDie) {
          ic.model = model
        } else if (prevCustomType !== customType) {
          ic.model = {
            rdieValue: "10m",
            cdieValue: "100n",
            type: "value"
          }
        }
      })
    }
  } else if (customType === 'unified') {
    const { pairs = [], ...modelInfo } = model;
    const lastPair = pairs.length ? pairs[pairs.length - 1] : {};
    const _pairs = JSON.parse(JSON.stringify(pairs));

    _data[dieIndex].ICs.forEach((ic, index) => {
      if (ic.to[0].components[0] !== targetDie) return;

      const pairIndex = _pairs.findIndex(p => p.pin.startsWith(ic.powerNet + '-'));
      if (pairIndex !== -1) {
        const selected = _pairs.splice(pairIndex, 1)[0];
        selected.pin = selected.pin.split('-')[1]
        ic.model = {
          ...modelInfo,
          pairs: [selected, lastPair],
        };

        if (dieCurrentList.length > index) {
          ic.dieCurrent = dieCurrentList[index];
        }
      }
    });
  } else if (customType === 'CPM') {
    const pkgIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX)
    const pkgDesignId = _data[pkgIndex].designId
    const { cpmPairs } = model
    if (cpmPairs && cpmPairs.length) {
      let newICs = []
      for (let domain of _data[pkgIndex].powerDomains) {
        const { PowerNets = [], ReferenceNets = [], Components = [] } = domain.content;
        const component = Components.find(item => item.usage === "DIE");
        if (!component) {
          continue;
        }
        const die = component && component.name ? component.name : null
        const cpmPins = cpmPairs.filter(item => [...PowerNets, ...ReferenceNets].includes(item.net));
        if (!cpmPins.length) {
          continue;
        }
        const newPorts = getDiePortsByCPM({
          packageId: pkgDesignId,
          component: die,
          PowerNets,
          ReferenceNets,
          cpmPins
        });
        const _ports = newPorts && newPorts.length ? newPorts : domain.content.diePorts;
        domain.content.diePorts = _ports;
        const powerNet = PowerNets.length ? PowerNets[0] : null
        if (_ports.length === 0) {
          newICs.push(new ImpDie({ die, designId: pkgDesignId, portIndex: "1", powerNet }))
        } else {
          _ports.forEach(item => {
            newICs.push(new ImpDie({ die, designId: pkgDesignId, portIndex: String(item.port), powerNet }))
          })
        }
      }
      _data[dieIndex].ICs = newICs
    }

    const { pairs = [], ...modelInfo } = model;
    const lastPair = pairs.length ? pairs[pairs.length - 1] : {};
    const _pairs = JSON.parse(JSON.stringify(pairs));
    _data[dieIndex].ICs.forEach((ic, index) => {
      if (ic.to[0].components[0] !== targetDie) return;
      const pairIndex = _pairs.findIndex(p => p.pin.startsWith(ic.powerNet + '-'));
      if (pairIndex !== -1) {
        const selected = _pairs.splice(pairIndex, 1)[0];
        selected.pin = selected.pin.split('-')[1]
        ic.model = {
          ...modelInfo,
          pairs: [selected, lastPair],
        };
      } else {
        ic.model = {
          ...modelInfo,
          pairs: [],
        };
      }
    });
  }
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: [..._data] });
}

function* updateDecapGroup(action) {
  const { file } = action;

  const { CascadeReducer: { Impedance: { verificationId } } } = yield select();
  try {
    if (file) {

      if (Array.isArray(file)) {
        // file is powerDomainGroups data
        yield put(updateImpedanceContent({ powerDomainGroups: file, powerDomainGroupsErrorMsg: undefined }));
        yield delay(100);
        yield call(saveSetup);
        return;
      }

      // file is powerDomainGroups excel file
      const res = yield call(uploadDecapGroupExcel, { verificationId, file });
      const { powerDomainGroups } = res;
      yield put(updateImpedanceContent({ powerDomainGroups, powerDomainGroupsErrorMsg: undefined }));
      return;
    }

    // file delete
    yield put(updateImpedanceContent({ powerDomainGroups: undefined, powerDomainGroupsErrorMsg: undefined }));
    yield delay(100);
    yield call(saveSetup)
  } catch (e) {
    yield put(updateImpedanceContent({ powerDomainGroupsErrorMsg: e }));
    console.error(e)
  }
}

function* updateDecapModel(action) {
  const { file, pcbId, display } = action;
  const { CascadeReducer: { project: { openProjectId, applyModelList }, library: { DecapList }, Impedance: { data, verificationId } } } = yield select();
  const newData = [...data];
  const findIndex = newData.findIndex(item => item.designId === pcbId)
  if (findIndex < 0) {
    return;
  }
  yield put(updateImpedanceLoading(true));
  const designList = CascadeChannels.getList(IMPEDANCE, openProjectId);
  const currentItem = [...designList].find(i => i.id === verificationId);
  yield put(openTabFooter());
  yield put(changeTabMenu({
    tabSelectKeys: ["detail"],
    currentVerificationId: verificationId,
    verificationName: currentItem ? currentItem.name : IMPEDANCE,
    menuType: "simulation"
  }))
  try {
    if (file) {
      const res = yield call(uploadDecapModelExcel, { file, type: display });
      if (!res) {
        yield put(updateLogs([{ type: 'error', text: `Parse file failed!` }]))
        return
      }
      const subcktsMap = new Map();// key - file, value :[ { name, ports }... ]
      const capModelMap = new Map();// key - component name, value :{ name, subcktName, id, type, libraryType }
      const partModelMap = new Map();// key - component part, value :{ name, subcktName, id, type, libraryType }
      for (let item of res) {
        const { componentName, fileName: parseFileName, subckt, part } = item;
        const matchParseName = parseFileName.replace(/\.s(\d*p|np)$/, '')
        let fileInfo
        for (let decap of DecapList) {
          if (decap.format === 'Folder') {
            if (decap.children && decap.children.length) {
              fileInfo = decap.children.find(d => {
                const matchDecapName = d.name.replace(/\.s(\d*p|np)$/, '')
                const isFileNameMatch = d.name === parseFileName || matchDecapName === parseFileName || matchDecapName.includes(matchParseName)
                return d.type === (subckt ? DECAP_SPICE : DECAP_TOUCHSTONE) && isFileNameMatch
              })
              if (fileInfo) {
                break
              }
            }
          } else {
            const matchDecapName = decap.name.replace(/\.s(\d*p|np)$/, '')
            const isFileNameMatch = decap.name === parseFileName || matchDecapName === parseFileName || matchDecapName.includes(matchParseName)
            if (decap.type === (subckt ? DECAP_SPICE : DECAP_TOUCHSTONE) && isFileNameMatch) {
              fileInfo = decap
              break
            }
          }
        }
        if (fileInfo) {
          let model;
          const fileName = fileInfo.name
          if (fileInfo.dataType === DECAP_SPICE) {
            if (!subcktsMap.has(fileName)) {
              const res = yield call(getLibraryFileInfo, fileInfo.id);
              const { models: subckts } = parseSPModelSelector(res);
              subcktsMap.set(fileName, subckts)
            }
            const subkctInfo = subcktsMap.get(fileName).find(_subckt => _subckt.name === subckt)
            if (subkctInfo) {
              model = {
                name: fileName,
                subcktName: subckt,
                id: fileInfo.id,
                type: 'Decap',
                libraryType: DECAP_SPICE
              }
            }
          } else {
            model = {
              name: fileName,
              subcktName: '',
              id: fileInfo.id,
              type: fileInfo.dataType,
              libraryType: fileInfo.dataType
            }
          }
          if (model) {
            if (display === COMPONENTBASED) {
              capModelMap.set(componentName, { ...model })
            } else if (display === PARTBASED) {
              partModelMap.set(part, { ...model })
            }
          }
        } else {
          yield put(updateLogs([{ type: 'normal', text: `${parseFileName}${subckt ? ` - ${subckt}` : ''} does not exist in decap library.` }]))
        }
      }

      let _applyModelList = [...applyModelList]

      if (display === COMPONENTBASED) {
        newData[findIndex].powerDomains.forEach(item => {
          item.content.Components = item.content.Components.map(comp => {
            if (capModelMap.has(comp.name)) {
              return { ...comp, models: [{ ...capModelMap.get(comp.name), apply: false }] };
            } else {
              return { ...comp }
            }
          })
        })
      } else if (display === PARTBASED) {
        newData[findIndex].powerDomains.forEach(item => {
          item.content.Components = item.content.Components.map(comp => {
            const { part } = comp
            const partNumber = auroraDBJson.getPartNumberByPartName(pcbId, part);
            const _part = partModelMap.has(partNumber) ? partNumber : (partModelMap.has(part) ? part : null);
            if (_part) {
              const model = partModelMap.get(_part)
              const findIndex = applyModelList.findIndex(m => m.partName === _part);
              let applyModel = { model, partName: _part };
              if (findIndex > -1) {
                _applyModelList[findIndex] = { ...applyModel }
              } else {
                _applyModelList = [..._applyModelList, { ...applyModel }]
              }
              return { ...comp, models: [{ ...model, apply: true }] };
            } else {
              const { models, ..._comp } = comp
              return _comp
            }
          })
        })
      }
      yield call(updateLibSetting, { librarySettings: _applyModelList, projectId: openProjectId })
      yield put(updateModelSetting(_applyModelList))
      yield put(updateImpedanceContent({ data: newData, status: true }));
      yield put({ type: SAVE_POWER_DOMAIN, data: newData });
      yield put(updateImpedanceLoading(false));
    }
  } catch (e) {
    yield put(updateImpedanceLoading(false));
    yield put(updateLogs([{ type: 'error', text: `Upload file failed!` }]))
    message.error('Upload file failed!');
    console.error(e)
  }
}

function* saveComponentsTableDisplay(action) {
  const { display, pcbId, clearModel } = action
  const { CascadeReducer: { Impedance: { componentsTableDisplay, data } } } = yield select();
  const prevDisplay = componentsTableDisplay
  if (!prevDisplay || prevDisplay !== display) {
    yield put(updateImpedanceLoading(true));
    try {
      yield put(updateImpedanceContent({ componentsTableDisplay: display }));
      yield delay(500);
      yield call(saveSetup);
      if (prevDisplay === COMPONENTBASED && display === PARTBASED && clearModel) {
        const newData = [...data];
        const findIndex = newData.findIndex(item => item.designId === pcbId)
        if (findIndex < 0) {
          return;
        }
        newData[findIndex].powerDomains.forEach(item => {
          item.content.Components.forEach(comp => {
            if (comp.usage === CAP) {
              delete comp.models
            }
          })
        })
        yield put(updateImpedanceContent({ data: newData, status: true }));
        yield put({ type: SAVE_POWER_DOMAIN, data: newData });
      }
      yield put(updateImpedanceLoading(false));
    } catch (error) {
      yield put(updateImpedanceLoading(false));
      console.error(error)
    }
  }
}

function* changeUsage(action) {
  const { compNames, part, id, usage } = action;
  const { CascadeReducer: { Impedance: { data, page } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === page);
  if (findIndex < 0) {
    return;
  }
  let { ICs, connectors = [], ballSizeMap } = _data[findIndex]
  const powerDomains = _data[findIndex].powerDomains;
  const index = powerDomains.findIndex(item => item.id === id);
  const currentData = powerDomains[index] || null;
  if (!currentData) {
    return;
  }
  const { DEBUG_MONITOR } = currentData.content
  let monitorComps = []
  const anotherLoadComps = currentData.content.Components.filter(item => item.usage === LOAD && item.part !== part)
  const anotherPowerLoadComps = []
  powerDomains.forEach(item => {
    if (item.id !== id) {
      const loadCompInfo = item.content.Components.filter(i => i.usage === LOAD)
      loadCompInfo.forEach(comp => {
        if (!anotherPowerLoadComps.includes(comp.name)) {
          anotherPowerLoadComps.push(comp.name)
        }
      })
    }
  })
  let monitorList = anotherLoadComps.map(comp => comp.loadMonitor || [])
  monitorList = [...monitorList, DEBUG_MONITOR].flat(3)
  let comps = [...new Set(monitorList.filter(item => item.type === 'comp').map(item => item.name))]
  let monitorNets = [...new Set(monitorList.filter(item => item.type === 'net').map(item => item.name))]
  monitorComps.push(...comps)

  currentData.content.Components.forEach(item => {
    if (item.part === part && compNames.includes(item.name)) {
      item.usage = usage;
      if (usage === IGNORE) {
        let loadComps = []
        if (item.loadMonitor) {
          item.loadMonitor.forEach(monitor => {
            const comps = monitor.filter(item => item.type === 'comp').map(item => item.name)
            loadComps.push(...comps)
          })
          loadComps.forEach(loadComp => {
            if (!monitorComps.includes(loadComp)) {
              const currentComp = currentData.content.Components.find(comp => comp.name === loadComp)
              if (currentComp && currentComp.usage) {
                currentComp.usage = IGNORE
              }
            }
          })
        }
        delete item.loadMonitor
        delete item.loadPorts
        if (!anotherPowerLoadComps.includes(item.name)) {
          ICs = ICs.filter(ic => ic.name !== item.name)
        }
      }
    }
  })

  if (usage === IGNORE) {
    currentData.content.extraVRM = currentData.content.extraVRM.filter(item => {
      const { powerPin } = item;
      powerPin.forEach(power => {
        const { comp, pins = [] } = power;
        const compInfo = getCascadeComponents({ pcbId: page, name: comp });
        if (!compInfo) {
          return false
        }
        const _pins = [...compInfo.pins.values()].filter(pin => pins.includes(pin.pin));
        const nets = _pins.map(pin => pin.net);
        return nets.some(net => monitorNets.includes(net))
      })
      return false
    });
  }

  powerDomains[index] = currentData;
  _data[findIndex].powerDomains = powerDomains;
  _data[findIndex].ICs = ICs;
  const _connectors = connectors.filter(item => {
    return powerDomains.find(domain => {
      const vrms = domain.content.VRM.map(it => [...(it.VRM_COMP || []), it.inductance]).flat(2)
      return domain.content.Components.find(comp => comp.name === item.name && comp.usage === CONNECTOR && vrms.includes(comp.name))
    })
  })
  const ballSizeMapObj = new BallSizeMap({ ballSizeMap, comps: [...ICs, ..._connectors], designId: page })
  _data[findIndex].ballSizeMap = ballSizeMapObj.getBallSizeMap()

  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
  if (usage === LOAD) {
    yield delay(500);
    yield call(getVRMfromNewLoad, { id, compNames })
  }
}

function* getVRMfromNewLoad(action) {
  const { CascadeReducer: { Impedance: { data, page, designId: currentDesignId, Options, verificationId } } } = yield select();
  const { id, compNames, postDesignId } = action;
  if (!postDesignId && page === OVERVIEW) {
    return;
  }
  yield put(updateImpedanceLoading(true));
  const designId = postDesignId || page;
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === designId);
  if (findIndex < 0) { return };
  const index = _data[findIndex].powerDomains.findIndex(item => item.id === id);
  if (index < 0) { return }
  let { ICs = [], ballSizeMap, netExtensionType = SENSE } = _data[findIndex]
  let currentData = _data[findIndex].powerDomains[index];
  const { id: _id, content } = currentData;
  const { MAIN_REF_NETS = [], PowerNets, ReferenceNets, includeExtended, extraNets = [], Components, VRM, extraVRM = [] } = content;
  const setting = yield call(componentSetting.getPrefixLib, designId);
  const doNotStuff = yield call(componentDoNotStuff.getDoNotStuff, designId);
  const table = yield call(compTableHelper.getTableData, designId);
  const _pinConnection = yield call(compPinMap.getPinConnection, designId);
  const pinConnection = yield call(getPowerSwitchPinMap, _pinConnection);
  const pinMap = yield call(getImpedancePinMap, designId);
  let VRMComps = [];
  VRM.forEach(item => {
    VRMComps.push(...item.VRM_COMP)
  });
  const _VRMComps = [...new Set(VRMComps)]
  const specify = _VRMComps.map(comp => {
    return { name: comp }
  })
  let Comps = [...Components]
  let _extraNets = [...extraNets]
  let _extraVRM = [...extraVRM];

  if (PowerNets && PowerNets.length && ReferenceNets && ReferenceNets.length) {
    const pinMapSense = yield call([pinMapStore, pinMapStore.getPinMapSense], designId, "pinName")
    const fromPmic = Options ? Options.fromPmic : false;
    yield* compNames.map(function* (compName) {
      Comps.find(comp => comp.name === compName).loadMonitor = []
      const compInfo = getCascadeComponents({ pcbId: designId, name: compName });
      const compNets = compInfo ? [...compInfo.pins.values()].map(item => item.net) : []
      const _powerNet = [...PowerNets, ...extraNets].find(net => compNets.includes(net))
      const ic = getImpedanceLayoutComp(compName, designId, IC);
      if (extraNets.length && compNets.some(net => extraNets.includes(net))) {
        for (let _powerNet of extraNets) {
          if (!compNets.includes(_powerNet)) {
            continue
          }
          let VRMInfo = yield call(_getVRM, {
            designId: designId,
            GroundNets: [...MAIN_REF_NETS],
            PowerNets: [_powerNet],
            ExtendNets: [],
            COMP_PREFIX_LIB: setting,
            loadSelect: [{ comp: compName }],
            connectInductance: false,
            findExtend: includeExtended,
            isAC: true,
            PMIC: [],
            powerSwitch: setting.powerSwitch,
            buckConverter: setting.discreteBuckConverter || [],
            doNotStuff,
            table,
            pinMapSense,
            pinConnection,
            pinMap,
            specify,
            fuzzyMatch: true,
            fullPaths: netExtensionType === SENSE ? true : false,
            fromPmic
          });
          yield put(updateLogs(VRMInfo.logs || []))
          const { Components: _Components, DEBUG_MONITOR = [], PowerNets: _PowerNets, VRM } = VRMInfo
          VRM.forEach(item => {
            const { powerPin = [] } = item;
            for (let power of powerPin) {
              const { net, comp } = power
              for (let _net of net) {
                const component = getCascadeComponents({ pcbId: designId, name: comp })
                if (component) {
                  const pins = [...component.pins.values()].filter(pin => pin.net === _net).map(pin => pin.pin)
                  if (!_extraVRM.find(vrm => vrm.powerPin.some(p => p.comp === comp && _.isEqual(p.pins, pins)))) {
                    _extraVRM.push({
                      ...item,
                      powerPin: [{ comp, net: [_net], pins }]
                    })
                  }
                }
              }
            }
          })
          _Components.forEach(vrmComp => {
            if (vrmComp.name === compName) {
              const compIndex = Comps.findIndex(comp => comp.name === compName)
              Comps[compIndex].loadMonitor ? Comps[compIndex].loadMonitor.push(...DEBUG_MONITOR) : Comps[compIndex].loadMonitor = DEBUG_MONITOR;
              const compInfo = getCascadeComponents({ pcbId: designId, name: compName });
              const pins = compInfo ? [...compInfo.pins.values()] : [];
              Comps[compIndex].pins = pins.filter(pin => [...PowerNets, ...extraNets, ...MAIN_REF_NETS].includes(pin.net))
              vrmComp.loadMonitor = Comps[compIndex].loadMonitor;
              vrmComp.pins = Comps[compIndex].pins;
            }

            if (Comps.map(comp => comp.name).includes(vrmComp.name)) {
              const _comp = Comps.find(comp => comp.name === vrmComp.name)
              const index = Comps.findIndex(comp => comp.name === vrmComp.name)
              if (_comp.usage === IGNORE && vrmComp.usage !== IGNORE) {
                const part = Comps.find(item => item.part === vrmComp.part && item.name !== vrmComp.name)
                if (part && part.model) {
                  vrmComp.model = { ...part.model }
                }
                if (part && part.value) {
                  vrmComp.value = part.value
                }
                Comps.splice(index, 1, vrmComp)
              }
            } else {
              const part = Comps.find(item => item.part === vrmComp.part)
              if (part && part.models && part.models.length) {
                vrmComp.models = [...part.models]
              }
              Comps.push(vrmComp)
            }
          })
          _PowerNets.forEach(net => {
            if (![...PowerNets, ...extraNets].includes(net)) {
              _extraNets.push(net)
            }
          })

          if (DEBUG_MONITOR.length) {
            DEBUG_MONITOR.forEach(monitor => {
              const _monitor = monitor.filter(item => item.type === 'comp');
              const last = _monitor[_monitor.length - 1].name;
              ic.to.push({ designId: designId, components: [last] })
            })
          }
        }
      } else if (_powerNet) {
        const loadMonitor = [{ name: compName, type: 'comp' }, { name: _powerNet, type: 'net' }]
        Comps.find(comp => comp.name === compName).loadMonitor = [loadMonitor]
        specify.forEach(item => {
          ic.to.push({ designId: designId, components: [item.name] })
        })
      }
      const haveIC = ICs.find(item => item.name === ic.name)
      if (haveIC) {
        ic.to.forEach(_ic => {
          _ic.components.forEach(_comp => {
            const comp = haveIC.to.find(item => item.components.includes(_comp))
            if (!comp) {
              haveIC.to.push(_ic)
            }
          })
        })
      } else {
        ICs.push(ic)
      }
    });
  }
  currentData = {
    id: _id,
    content: {
      ...content,
      Components: Comps,
      extraNets: [...new Set(_extraNets)],
      extraVRM: _extraVRM
    }
  }
  _data[findIndex].powerDomains[index] = currentData;
  const newDomains = getCompsBetweenPowerNets(designId, _data[findIndex].powerDomains, doNotStuff)
  let _domains = [];
  for (let newDomain of newDomains) {
    if (!newDomain.domainComps) {
      _domains.push(newDomain);
      continue;
    }
    const domainComps = yield call(updateComponentDecapModel, {
      components: newDomain.domainComps,
      prevComps: [],
      designId: designId,
      voltage: newDomain.content.voltage || "1"
    })
    delete newDomain.domainComps;
    domainComps.forEach(cap => {
      const findIndex = newDomain.content.Components.findIndex(comp => comp.name === cap.name)
      if (findIndex < 0) {
        newDomain.content.Components.push(cap)
      } else if (newDomain.content.Components[findIndex].usage !== cap.usage) {
        newDomain.content.Components[findIndex].usage = cap.usage
      }
    })
    _domains.push(newDomain);
  }
  _data[findIndex].powerDomains = _domains
  const newPowerDomains = _data[findIndex].powerDomains.map(item => ({ id: item.id, ...item.content }));
  const VRMs = newPowerDomains.map(pow => (pow.VRM && pow.VRM.map(vrm => vrm.VRM_COMP)) || []).flat(3);
  const PMICs = [...new Set(VRMs)].filter(vrm => !_data[findIndex].connectors.find(conn => conn.name === vrm));
  _data[findIndex].PMICs = PMICs.map(pmic => getImpedanceLayoutComp(pmic, designId, PMIC));
  _data[findIndex].ICs = ICs
  const _connectors = _data[findIndex].connectors.filter(item => {
    return _domains.find(domain => {
      const vrms = domain.content.VRM.map(it => [...(it.VRM_COMP || []), it.inductance]).flat(2)
      return domain.content.Components.find(comp => comp.name === item.name && comp.usage === CONNECTOR && vrms.includes(comp.name))
    })
  })
  const ballSizeMapObj = new BallSizeMap({ ballSizeMap, comps: [...ICs, ..._connectors], designId: designId })
  _data[findIndex].ballSizeMap = ballSizeMapObj.getBallSizeMap()

  const netExtensionData = getNetExtensionData(_data, currentDesignId)
  const portImpedanceNets = getPortImpedanceNets(_data[findIndex].powerDomains, _data[findIndex].designId, _data[findIndex].portImpedanceNets, netExtensionData, _data[findIndex].type);
  _data[findIndex].portImpedanceNets = portImpedanceNets;
  try {
    yield call(saveLayouts, { data: _data, update: true, verificationId });
  } catch (e) {
    console.error(e)
  }
  yield put(updateImpedanceLoading(false));
}

function* savePMICVoltage(action) {
  const { value, name, usage } = action
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  let _data = [...data];
  if (usage === PMIC) {
    const findIndex = _data.findIndex(item => item.PMICs && item.PMICs.length > 0);
    if (findIndex < 0) {
      return;
    }
    let { PMICs } = _data[findIndex]
    PMICs.forEach(item => {
      if (item.name === name) {
        item.voltage = value
      }
    })
    _data[findIndex].PMICs = PMICs;
  } else if (usage === VRM) {
    const info = name.replace('[', '').replace(']', '').split(', ');
    const pwr = info && info.length ? info[0] : ""
    const gnd = info && info.length ? info[1] : ""
    _data.forEach(item => {
      let { powerDomains = [] } = item
      powerDomains.forEach(domain => {
        const { content: { VRM = [] } } = domain
        VRM.forEach(vrm => {
          if (!vrm.VRM_COMP || !vrm.VRM_COMP.length) {
            const _gnd = vrm.groundPin && vrm.groundPin.length ? vrm.groundPin[0].comp : '';
            const _pwr = vrm.powerPin && vrm.powerPin.length ? vrm.powerPin[0].comp : '';
            if (pwr === _pwr && gnd === _gnd) {
              vrm.voltage = value
            }
          }
        })
      })
      item.powerDomains = powerDomains
    })
  }
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: _data });
}

function* saveDieRleakAndRrdl(action) {
  const { rleak, rdl, apply, rComp, rPowerNet, rPortIndex } = action
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  let _data = [...data];
  const dieIndex = _data.findIndex(item => item.type === IMPEDANCE_DIE)
  if (dieIndex < 0) {
    return;
  }
  if (apply) {
    _data[dieIndex].ICs.forEach(ic => {
      if (ic.to[0].components[0] === rComp) {
        ic.rleak = rleak
        ic.rdl = rdl
      }
    })
  } else {
    _data[dieIndex].ICs.forEach(ic => {
      if (ic.powerNet === rPowerNet && ic.portIndex === rPortIndex && ic.to[0].components[0] === rComp) {
        ic.rleak = rleak
        ic.rdl = rdl
      }
    })
  }
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: [..._data] });
}

function* saveInterposer(action) {
  const { info, interposerDie, interposerPowerNet, interposerIndex, apply } = action
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  let _data = [...data];
  const dieIndex = _data.findIndex(item => item.type === IMPEDANCE_DIE)
  if (dieIndex < 0) {
    return;
  }
  const interposerType = info && info.interposerType ? info.interposerType : ""
  const prevInterposerType = _data[dieIndex].interposerType
  _data[dieIndex].interposerType = interposerType
  if (interposerType === 'perPort') {
    const { pairs = [], ..._info } = info;
    const _pairs = pairs.map(item => {
      return {
        pin: item.pin,
        node: item.node
      }
    })
    if (apply) {
      _data[dieIndex].ICs.forEach(ic => {
        if (ic.to[0].components[0] === interposerDie) {
          ic.interposer = { ..._info, pairs: _pairs }
        }
      })
    } else {
      _data[dieIndex].ICs.forEach(ic => {
        if (ic.powerNet === interposerPowerNet && ic.portIndex === interposerIndex && ic.to[0].components[0] === interposerDie) {
          ic.interposer = { ..._info, pairs: _pairs }
        } else if (prevInterposerType !== interposerType) {
          ic.interposer = new ImpInterposer()
        }
      })
    }
  } else if (interposerType === 'unified') {
    const { pairs = [], ..._info } = info;
    _data[dieIndex].ICs.forEach((ic, index) => {
      if (ic.to[0].components[0] === interposerDie) {
        let _pairs = []
        pairs.forEach(item => {
          if (item.powerNet === ic.powerNet && item.port === ic.portIndex) {
            _pairs.push({
              pin: item.pin,
              node: item.node
            })
          }
        })
        ic.interposer = { ..._info, pairs: _pairs }
      };
    });
  }
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: [..._data] });
}

function* saveInterposerNode(action) {
  const { value, key, name, powerNet, portIndex } = action
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  let _data = [...data];
  const dieIndex = _data.findIndex(item => item.type === IMPEDANCE_DIE)
  if (dieIndex < 0) {
    return;
  }
  _data[dieIndex].ICs.forEach(ic => {
    if (ic.powerNet === powerNet && ic.portIndex === portIndex && ic.to[0].components[0] === name) {
      if (ic.interposer && ic.interposer.pairs && ic.interposer.pairs.length) {
        const pairs = ic.interposer.pairs
        let _pairs = [...pairs]
        const pairIndex = _pairs.findIndex(item => item.pin === key)
        if (pairIndex > -1) {
          _pairs[pairIndex].node = value
          ic.interposer.pairs = [..._pairs]
        }
      }
    }
  })
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: [..._data] });
}

function* switchPackage(action) {
  const { designId } = action
  const { CascadeReducer: { project: { openProjectId }, Impedance: { verificationId, targetDie = [], data = [], targetIC, designId: currentDesignId, powerNetSelect: { select: selectNets }, limitBoundaryPowerPinsLumpedPort, parallelExtraction } } } = yield select();
  let _data = [...data]
  const findIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
  if (findIndex < 0) {
    return;
  }
  if (_data[findIndex].type === IMPEDANCE_PACKAGE_FILE) {
    const version = yield call(componentSetting.getVersion, designId);
    const COMP_PREFIX_LIB = { version: version }
    const designName = designConstructor.getDesignName(designId);
    const isPreLayout = designConstructor.isPreLayout(designId);
    const vendor = designConstructor.getDesignVendor(designId)
    const type = isPreLayout ? designConstructor.getPreLayoutType(designId) : designConstructor.getDesignType(designId);
    let extraction = vendor === SPD ? new ImpExtraction({ parallelExtraction, type: POWERSI }) : new ImpExtraction({ parallelExtraction });
    const newLayout = new ImpLayout({ index: TARGET_PACKAGE_INDEX, designId, designName, type, COMP_PREFIX_LIB, extraction });
    _data = _data.filter(item => item.index !== TARGET_PACKAGE_INDEX);
    _data.forEach(layout => {
      layout.ICs.forEach(ic => {
        ic.applyCurrent = false
      })
    })
    _data.push(newLayout);
    yield put(updateImpedanceContent({ data: _data, status: true }));
    let Dies = [];
    if (isPreLayout) {
      const preData = yield call([preLayoutData, preLayoutData.getPreLayout], designId);
      const { content = {} } = preData;
      const { components = [] } = content;
      Dies = components.filter(item => item.type === DIE).map(item => item.name);
    } else {
      const setting = yield call([componentSetting, componentSetting.getPrefixLib], designId);
      const { Die = [] } = setting;
      Dies = Die;
    }
    if (Dies.length > 0) {
      yield put(updateImpedanceContent({ targetDie: Dies }));
      yield call(saveSetup);
    }
    yield call(updatePackageDomain, designId)
    return;
  }
  if (_data[findIndex].designId !== designId) {
    const designName = designConstructor.getDesignName(designId);
    const isPreLayout = designConstructor.isPreLayout(designId);
    let setting = new CascadeCompRLCPrefixLib({})
    let Dies = []
    if (isPreLayout) {
      const preData = yield call([preLayoutData, preLayoutData.getPreLayout], designId);
      const { content = {} } = preData;
      const { components = [] } = content;
      Dies = components.filter(item => item.type === 'DIE').map(item => item.name);
    } else {
      setting = yield call([componentSetting, componentSetting.getPrefixLib], designId);
      const { Die = [] } = setting;
      Dies = Die;
      yield call(getAuroraDB, designId);
      yield* checkMaterialList(designId);
    }

    const designList = CascadeChannels.getList(IMPEDANCE, openProjectId);
    const currentItem = [...designList].find(i => i.id === verificationId);
    yield put(openTabFooter());
    yield put(changeTabMenu({
      tabSelectKeys: ["detail"],
      currentVerificationId: verificationId,
      verificationName: currentItem ? currentItem.name : IMPEDANCE,
      menuType: "simulation"
    }))
    yield put(updateLogs([], true))

    if (!Dies.length) {
      yield put(updateLogs([{ type: 'error', text: `[Update] Die does not exist.` }]))
      return
    }

    let powerDomains = [];
    let _targetDie = [];
    if (targetDie.every(comp => Dies.includes(comp))) {
      for (let item of _data[findIndex].powerDomains) {
        const { Components, diePorts, bgaPorts, MAIN_POWER_NETS, MAIN_REF_NETS } = item.content
        const dieCompInfo = Components.find(comp => comp.usage === 'DIE')
        const dieComp = dieCompInfo ? [dieCompInfo.name] : []

        const { powerNets, referenceNets, DIE, BGA } = getPackagePowerDomain(designId, setting, dieComp);
        let _powerNets = powerNets.filter(net => MAIN_POWER_NETS.includes(net));
        if (targetIC && selectNets.length && currentDesignId !== designId && !isPreLayout) {
          let _nets = [], _packageRelationship = [];
          for (let selectNet of selectNets) {
            const { nets } = checkConnectCompsPinsAndNets({ designId: currentDesignId, name: targetIC, nets: [selectNet] }, { designId, name: BGA.name })
            _nets.push(...nets.filter(net => MAIN_POWER_NETS.includes(net)));
            _packageRelationship.push({ [IMPEDANCE_PCB]: [selectNet], [IMPEDANCE_PACKAGE]: [...nets] });
          }
          if (_nets.length) {
            _powerNets = [..._nets];
          }
          yield put(setPackageRelationship(_packageRelationship))
        }
        if (isPreLayout) {
          let _packageRelationship = [];
          const targetPCB = _data.find(item => item.designId === currentDesignId);
          if (targetPCB) {
            const MAIN_PCB_NETS = targetPCB.powerDomains.map(domain => domain.content.MAIN_POWER_NETS)
            MAIN_PCB_NETS.forEach((nets, index) => {
              _packageRelationship.push({ [IMPEDANCE_PCB]: nets, [IMPEDANCE_PACKAGE]: _powerNets[index] ? [_powerNets[index]] : [] })
            })
            yield put(setPackageRelationship(_packageRelationship))
          }
        }
        if (!_powerNets.length) {
          yield put(updateLogs([{ type: 'error', text: `[Update] PowerNet does not exist.` }]))
          continue
        }

        const deletePowerNets = MAIN_POWER_NETS.filter(item => !_powerNets.includes(item))
        const deleteRefNets = MAIN_REF_NETS.filter(item => !referenceNets.includes(item))
        if (deletePowerNets.length) {
          yield put(updateLogs([{ type: 'normal', text: `[Update][Power Domains] ${deletePowerNets.join(',')} does not exist.` }]))
        } else if (deleteRefNets.length) {
          yield put(updateLogs([{ type: 'normal', text: `[Update][Power Domains] ${deleteRefNets.join(',')} does not exist.` }]))
        }

        yield put(updateImpedanceLoading('Loading...'));
        for (let powerNet of _powerNets) {
          const packageVRMs = yield call(getPkgDomainInfo, {
            pcbId: designId,
            powerNet,
            referenceNets,
            DIE: DIE.map(die => die.name),
            BGA: BGA.name,
            setting,
            limitBoundaryPowerPinsLumpedPort
          })

          if (!packageVRMs.add) {
            continue;
          }

          const { newDiePorts, newBgaPorts, deleteDiePower, deleteDieRefe, deleteBgaPower, deleteBgaRefe } = filterPortsByPackage(designId, dieCompInfo.name, BGA.name, [powerNet], referenceNets, diePorts, bgaPorts)
          packageVRMs.domain.diePorts = newDiePorts
          packageVRMs.domain.bgaPorts = newBgaPorts
          if (deleteDiePower.length) {
            yield put(updateLogs([{ type: 'normal', text: `[Update][Power Domains][${powerNet}][DiePorts] Pins "${deleteDiePower.join(',')}" does not exist.` }]))
          }
          if (deleteDieRefe.length) {
            yield put(updateLogs([{ type: 'normal', text: `[Update][Power Domains][${referenceNets.join(',')}][DiePorts] Pins "${deleteDieRefe.join(',')}" does not exist.` }]))
          }
          if (deleteBgaPower.length) {
            yield put(updateLogs([{ type: 'normal', text: `[Update][Power Domains][${powerNet}][BgaPorts] Pins "${deleteBgaPower.join(',')}" does not exist.` }]))
          }
          if (deleteBgaRefe.length) {
            yield put(updateLogs([{ type: 'normal', text: `[Update][Power Domains][${referenceNets.join(',')}][BgaPorts] Pins "${deleteBgaRefe.join(',')}" does not exist.` }]))
          }
          packageVRMs.domain.Components = yield call(updateComponentDecapModel, {
            components: packageVRMs.domain ? packageVRMs.domain.Components : [],
            prevComps: Components,
            designId
          })
          const componentUpdate = getCompUpdateLog(packageVRMs.domain, item.content);
          const componentUpdateLogs = componentUpdate.map(item => { return { type: 'normal', text: item } })
          yield put(updateLogs(componentUpdateLogs))

          powerDomains.push({
            id: "",
            content: { ...packageVRMs.domain }
          })
        }
        _targetDie.push(dieCompInfo.name)
      }
    } else {
      const { powerNets, referenceNets, DIE, BGA } = getPackagePowerDomain(designId, setting, Dies);
      let _powerNets = [...powerNets];
      if (targetIC && selectNets.length && currentDesignId !== designId && !isPreLayout) {
        const isPCBPrelayout = designConstructor.isPreLayout(currentDesignId);
        let _nets = [], _packageRelationship = [];
        if (isPCBPrelayout) {
          let index = 0;
          for (let selectNet of selectNets) {
            const nets = _powerNets[index] ? [_powerNets[index]] : [];
            _nets.push(...nets);
            _packageRelationship.push({ [IMPEDANCE_PCB]: [selectNet], [IMPEDANCE_PACKAGE]: [...nets] });
            index++
          }
        } else {
          for (let selectNet of selectNets) {
            const { nets } = checkConnectCompsPinsAndNets({ designId: currentDesignId, name: targetIC, nets: [selectNet] }, { designId, name: BGA.name })
            _nets.push(...nets.filter(net => !referenceNets.includes(net)));
            _packageRelationship.push({ [IMPEDANCE_PCB]: [selectNet], [IMPEDANCE_PACKAGE]: [...nets] });
          }
        }
        if (_nets.length) {
          _powerNets = [..._nets];
        }
        yield put(setPackageRelationship(_packageRelationship))
      }
      if (isPreLayout) {
        let _packageRelationship = [];
        const targetPCB = _data.find(item => item.designId === currentDesignId);
        if (targetPCB) {
          const MAIN_PCB_NETS = targetPCB.powerDomains.map(domain => domain.content.MAIN_POWER_NETS)
          MAIN_PCB_NETS.forEach((nets, index) => {
            _packageRelationship.push({ [IMPEDANCE_PCB]: nets, [IMPEDANCE_PACKAGE]: _powerNets[index] ? [_powerNets[index]] : [] })
          })
          yield put(setPackageRelationship(_packageRelationship))
        }
      }
      if (!_powerNets.length) {
        yield put(updateLogs([{ type: 'error', text: `[Update] PowerNet does not exist.` }]))
      }
      yield put(updateImpedanceLoading('Loading...'));
      for (let powerNet of _powerNets) {
        const lastPowerDomain = _data[findIndex].powerDomains.find(item => item.content.MAIN_POWER_NETS && item.content.MAIN_POWER_NETS.includes(powerNet));
        const lastComponents = lastPowerDomain ? lastPowerDomain.content.Components || [] : _data[findIndex].powerDomains.map(item => item.content.Components || []).flat();
        const packageVRMs = yield call(getPkgDomainInfo, {
          pcbId: designId,
          powerNet,
          referenceNets,
          DIE: DIE.map(die => die.name),
          BGA: BGA.name,
          setting,
          limitBoundaryPowerPinsLumpedPort
        })

        if (!packageVRMs.add) {
          continue;
        }
        packageVRMs.domain.Components = yield call(updateComponentDecapModel, {
          components: packageVRMs.domain ? packageVRMs.domain.Components : [],
          prevComps: lastComponents,
          designId
        })

        const die = Dies.find(item => {
          return packageVRMs.domain.Components.find(comp => comp.name === item)
        })
        if (die) {
          _targetDie.push(die)
        }

        powerDomains.push({
          id: "",
          content: { ...packageVRMs.domain }
        })
      }
    }

    _targetDie = [...new Set(_targetDie)]
    const { DIE, BGA } = getPackagePowerDomain(designId, setting, _targetDie);
    const bgaObj = getImpedanceLayoutComp(BGA.name, designId, BGAConst);
    bgaObj.from = [{ components: DIE.map(die => die.name), designId }];
    const dieObj = DIE.map(die => {
      const _dieObj = getImpedanceLayoutComp(die.name, designId, DIEConst)
      _dieObj.to = [{ components: [BGA.name], designId }];
      return _dieObj
    })

    if (currentDesignId !== designId && targetIC) {
      bgaObj.to = [{ components: [targetIC], designId: currentDesignId }];
      const currentIndex = _data.findIndex(item => item.designId === currentDesignId);
      if (currentIndex > -1) {
        const icIndex = _data[currentIndex].ICs.findIndex(item => item.name === targetIC);
        if (icIndex > -1) {
          _data[currentIndex].ICs[icIndex].from = [{ components: DIE.map(die => die.name), designId }]
        }
      }
    }

    const dieIndex = _data.findIndex(item => item.index === TARGET_DIE_INDEX)
    const dieNames = DIE.map(item => item.name)
    if (dieIndex > -1) {
      let ics = _data[dieIndex].ICs
      ics = ics.filter(ic => dieNames.includes(ic.to[0].components[0]))

      let newICs = []
      powerDomains.forEach(domain => {
        const { content } = domain
        const dieCompInfo = content.Components.find(comp => comp.usage === 'DIE')
        const die = dieCompInfo ? dieCompInfo.name : ''
        const powerNet = content.MAIN_POWER_NETS.length ? content.MAIN_POWER_NETS[0] : null
        const findIc = ics.find(ic => ic.to[0].components[0] === die)
        if (!findIc) {
          newICs.push(new ImpDie({ die, designId: designId, portIndex: "1", powerNet }))
        } else {
          const ic = JSON.parse(JSON.stringify(findIc))
          ic.to[0].designId = designId
          ic.powerNet = powerNet
          ic.portIndex = '1'
          newICs.push(ic)
        }
      })
      _data[dieIndex].ICs = JSON.parse(JSON.stringify(newICs))
    }

    const { ballSizeMap } = _data[findIndex]
    const ballSizeMapObj = new BallSizeMap({ ballSizeMap, comps: [...dieObj, bgaObj], designId })
    const _ballSizeMap = ballSizeMapObj.getBallSizeMap()

    const version = yield call(componentSetting.getVersion, designId);
    const COMP_PREFIX_LIB = { version: version }
    const extraction = new ImpExtraction({ parallelExtraction, ...(_data[findIndex].extraction || {}) });

    _data[findIndex].designId = designId
    _data[findIndex].designName = designName
    _data[findIndex].extraction = extraction
    _data[findIndex].COMP_PREFIX_LIB = COMP_PREFIX_LIB
    _data[findIndex].Dies = dieObj;
    _data[findIndex].Bgas = [bgaObj];
    _data[findIndex].powerDomains = powerDomains;
    _data[findIndex].ballSizeMap = _ballSizeMap;

    const findSocketIndex = _data.findIndex(item => item.type === IMPEDANCE_SOCKET)
    if (findSocketIndex > -1) {
      if (_data[findSocketIndex].socket && _data[findSocketIndex].socket.pairs && _data[findSocketIndex].socket.pairs.length) {
        _data[findSocketIndex].socket.pairs = []
      }
    }

    yield put(updateImpedanceContent({ targetDie: _targetDie }));
    yield call(saveSetup);

    yield put(updateLogs([{ type: 'success', text: `[Package] [${designName}] Found ${powerDomains.length} Power Domains` }, { type: 'normal', text: `[Package] Saving...` }]))
    yield delay(100)

    yield put(updateImpedanceLoading(false));
    try {
      yield call(saveLayouts, { data: _data, update: true, verificationId });
      yield put(updateLogs([{ type: 'normal', text: `[Package] Save completed.` }]))
    } catch (e) {
      yield put(updateLogs([{ type: 'error', text: `[Package] Save failed...` }]))
      console.error("Package Error:" + e)
    }
  }
}

function* switchPcb(action) {
  const { pcbId, prevPcbId } = action
  const { CascadeReducer: { project: { openProjectId }, Impedance: { verificationId, data = [], parallelExtraction } } } = yield select();
  const _data = [...data]
  const findIndex = _data.findIndex(item => item.designId === prevPcbId);
  if (findIndex < 0) {
    return;
  }
  if (_data[findIndex].designId !== pcbId) {
    const designList = CascadeChannels.getList(IMPEDANCE, openProjectId);
    const currentItem = [...designList].find(i => i.id === verificationId);
    yield put(openTabFooter());
    yield put(changeTabMenu({
      tabSelectKeys: ["detail"],
      currentVerificationId: verificationId,
      verificationName: currentItem ? currentItem.name : IMPEDANCE,
      menuType: "simulation"
    }))
    yield put(updateLogs([], true))
    yield delay(100);
    try {
      if (pcbId) {
        yield call(getAuroraDB, pcbId);
      }
      const designName = designConstructor.getDesignName(pcbId);
      const isPreLayout = designConstructor.isPreLayout(pcbId)
      if (!_data.find(item => item.designId === pcbId)) {
        const pcbLayout = _data[findIndex]
        const netsInfo = getNets(pcbId);
        const allNets = netsInfo && netsInfo.nets ? netsInfo.nets : []
        const loadComponents = netsInfo && netsInfo.loadComponents ? netsInfo.loadComponents.map(comp => comp.name) : []
        if (!isPreLayout) {
          yield* checkMaterialList(pcbId);
        }
        let connectors = pcbLayout.connectors
        let newConnectors = []
        if (connectors && connectors.length) {
          yield* connectors.map(function* (connector) {
            const name = connector.name
            if (loadComponents.includes(name)) {
              const fromComp = connector.from.length && connector.from[0].components ? connector.from[0].components[0] : null
              const fromDesignId = connector.from.length && connector.from[0].designId ? connector.from[0].designId : null
              if (fromDesignId === prevPcbId) {
                if (loadComponents.includes(fromComp)) {
                  connector.from[0].designId = pcbId
                } else {
                  yield put(updateLogs([{ type: 'error', text: `[Update][${designName}] Can not find ${fromComp}.` }]))
                  connector.from = []
                }
              }
              const fromNets = connector.from.length && connector.from[0].nets ? connector.from[0].nets : {}
              const newFromNets = {}
              let fromClearAll = false;
              Object.keys(fromNets).forEach(key => {
                const comp = key.split('-')[0]
                const id = key.split('-')[1]
                const nets = fromNets[key]
                if (comp === name && id === prevPcbId) {
                  if (nets.every(value => allNets.includes(value))) {
                    newFromNets[`${name}-${pcbId}`] = nets;
                  } else {
                    newFromNets[`${name}-${pcbId}`] = [];
                    fromClearAll = true;
                  }
                } else {
                  newFromNets[key] = nets
                }
              })
              if (fromClearAll) {
                yield put(updateLogs([{ type: 'error', text: `[Update][${designName}] Can not find net connection on ${name}.` }]))
                Object.keys(newFromNets).forEach(key => newFromNets[key] = []);
              }
              if (Object.keys(newFromNets).length) {
                connector.from[0].nets = newFromNets
              }

              let toLogs = [];
              connector.to.map(t => {
                let removeComp = []
                t.designId = pcbId;
                t.components = t.components.filter(comp => {
                  if (loadComponents.includes(comp)) {
                    return true
                  }
                  removeComp.includes(comp);
                  return false
                })
                if (removeComp.length) {
                  toLogs.push({ type: 'error', text: `[Update][${designName}] Can not find ${removeComp.join(', ')}` })
                }
                if (!t.components.length) {
                  return null
                }
                return t
              }).filter(t => !!t);
              yield put(updateLogs(toLogs))
              const toNets = connector.to.length && connector.to[0].nets ? connector.to[0].nets : {}
              const newToNets = {}
              let toClearAll = false
              Object.keys(toNets).forEach(key => {
                const comp = key.split('-')[0]
                const id = key.split('-')[1]
                const nets = toNets[key]
                if (comp === name && id === prevPcbId) {
                  if (nets.every(value => allNets.includes(value))) {
                    newToNets[`${name}-${pcbId}`] = nets;
                  } else {
                    newToNets[`${name}-${pcbId}`] = [];
                    toClearAll = true;
                  }
                } else {
                  newToNets[key] = nets
                }
              })
              if (toClearAll) {
                yield put(updateLogs([{ type: 'error', text: `[Update][${designName}] Can not find net connection on ${name}.` }]))
                Object.keys(newToNets).forEach(key => newToNets[key] = []);
              }
              if (Object.keys(newToNets).length) {
                connector.to[0].nets = newToNets
              }
              newConnectors.push(connector)
            } else {
              yield put(updateLogs([{ type: 'error', text: `[Update][${designName}] Can not find ${name}.` }]))
            }
          })
        }
        pcbLayout.connectors = newConnectors.filter(item => !!item)
        pcbLayout.PMICs = pcbLayout.PMICs.map(item => {
          return { ...item, designId: pcbId }
        })
        pcbLayout.designId = pcbId
        pcbLayout.designName = designName
        pcbLayout.ICs = []
        const vendor = designConstructor.getDesignVendor(pcbId)
        let extraction = vendor === SPD ? new ImpExtraction({ parallelExtraction, ...pcbLayout.extraction, type: POWERSI }) : new ImpExtraction({ parallelExtraction, ...pcbLayout.extraction });
        pcbLayout.extraction = extraction
        _data[findIndex] = pcbLayout

        const lastLayoutIndex = _data.findIndex(item => item.index === _data[findIndex].index - 1)
        if (lastLayoutIndex > -1) {
          const layout = _data[lastLayoutIndex]
          let lastConnectors = layout.connectors
          if (lastConnectors && lastConnectors.length) {
            lastConnectors.forEach(connector => {
              const toComp = connector.to.length && connector.to[0].components[0] ? connector.to[0].components[0] : null
              const toDesignId = connector.to.length && connector.to[0].designId ? connector.to[0].designId : null;
              if (toDesignId === prevPcbId) {
                if (loadComponents.includes(toComp)) {
                  connector.to[0].designId = pcbId
                } else {
                  connector.to = []
                }
              }
              const toNets = connector.to.length && connector.to[0].nets ? connector.to[0].nets : {}
              const newToNets = {}
              let toClearAll = false
              Object.keys(toNets).forEach(key => {
                const comp = key.split('-')[0]
                const id = key.split('-')[1]
                const nets = toNets[key]
                if (comp === toComp && id === prevPcbId) {
                  if (nets.every(value => allNets.includes(value))) {
                    newToNets[`${toComp}-${pcbId}`] = nets;
                  } else {
                    newToNets[`${toComp}-${pcbId}`] = [];
                    toClearAll = true;
                  }
                } else {
                  newToNets[key] = nets
                }
              })
              if (toClearAll) {
                Object.keys(newToNets).forEach(key => newToNets[key] = []);
              }
              if (Object.keys(newToNets).length) {
                connector.to[0].nets = newToNets
              }
            })
          }
          _data[lastLayoutIndex].connectors = lastConnectors
        }

        const nextLayoutIndex = _data.findIndex(item => item.index > _data[findIndex].index)
        if (nextLayoutIndex > -1) {
          const layout = _data[nextLayoutIndex]
          const nextConnectors = layout.connectors
          if (nextConnectors && nextConnectors.length) {
            nextConnectors.forEach(connector => {
              const fromComp = connector.from.length && connector.from[0].components[0] ? connector.from[0].components[0] : null
              const fromDesignId = connector.from.length && connector.from[0].designId ? connector.from[0].designId : null
              if (fromDesignId === prevPcbId) {
                if (loadComponents.includes(fromComp)) {
                  connector.from[0].designId = pcbId
                } else {
                  connector.from = []
                }
              }
              const fromNets = connector.from.length && connector.from[0].nets ? connector.from[0].nets : {}
              const newFromNets = {}
              let fromClearAll = false
              Object.keys(fromNets).forEach(key => {
                const comp = key.split('-')[0]
                const id = key.split('-')[1]
                const nets = fromNets[key]
                if (comp === fromComp && id === prevPcbId) {
                  if (nets.every(value => allNets.includes(value))) {
                    newFromNets[`${fromComp}-${pcbId}`] = nets;
                  } else {
                    newFromNets[`${fromComp}-${pcbId}`] = [];
                    fromClearAll = true;
                  }
                } else {
                  newFromNets[key] = nets
                }
              })
              if (fromClearAll) {
                Object.keys(newFromNets).forEach(key => newFromNets[key] = []);
              }
              if (Object.keys(newFromNets).length) {
                connector.from[0].nets = newFromNets
              }
            })
          }
          _data[nextLayoutIndex].connectors = nextConnectors
        }
        yield call(saveLayouts, { data: _data, update: true, verificationId });
        yield delay(100)
        yield call(getVRMs, { notClearLog: true });
        yield call(saveSetup)
        yield put(updateLogs([{ type: 'success', text: `[Update][${designName}] Switching completed.` }]))
      } else {
        yield put(updateLogs([{ type: 'error', text: `[Update] ${designName} has already exist.` }]))
      }
    } catch (error) {
      yield put(updateLogs([{ type: 'error', text: `[Update] Switching failed.` }]))
      console.error(error)
    }
  }
}

function* getPowerSwitchPinMap(pinConnection) {
  let _pinConnection = [];
  yield* pinConnection.map(function* (connection) {
    if (connection.type === POWER_SWITCH && connection.libraryId) {
      try {
        const libraryData = yield call(getLibraryDataInfo, connection.libraryId);
        const { config = {} } = libraryData;
        const { pinTable = [] } = config;
        _pinConnection.push({ ...connection, pinMap: pinTable })
      } catch (e) {
        _pinConnection.push(connection)
      }
    } else {
      _pinConnection.push(connection)
    }
  })
  return _pinConnection;
}

function* saveHasInterposer(action) {
  const { hasInterposer } = action
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  let _data = [...data];
  const dieIndex = _data.findIndex(item => item.type === IMPEDANCE_DIE)
  if (dieIndex < 0) {
    return;
  }

  if (hasInterposer) {
    _data[dieIndex].ICs.forEach(ic => {
      ic.interposer = new ImpInterposer()
    })
    _data[dieIndex].interposerType = 'perPort'
  } else {
    _data[dieIndex].ICs.forEach(ic => {
      delete ic.interposer
    })
  }
  yield put(updateImpedanceContent({ data: _data, hasInterposer: hasInterposer, update: true }));
  yield delay(10);
  yield call(saveSetup);
  yield put({ type: SAVE_POWER_DOMAIN, data: [..._data] });
}

function* updateCurrentStatus(action) {
  const { enable, designId, name } = action
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === designId);
  if (findIndex > -1) {
    const findICIndex = _data[findIndex].ICs.findIndex(item => item.name === name);
    if (findICIndex > -1) {
      const ic = _data[findIndex].ICs[findICIndex]
      ic.applyCurrent = enable
      _data[findIndex].ICs[findICIndex] = ic
      yield put(updateImpedanceContent({ data: _data, status: true }));
      yield put({ type: SAVE_POWER_DOMAIN, data: [..._data] });
    }
  }
}

function* saveTransientTimeSetting(action) {
  const { startTime, stopTime, stepTime } = action
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  let _data = [...data];
  _data.forEach(item => {
    (item.ICs || []).forEach(ic => {
      if (item.type === IMPEDANCE_DIE || (item.type === IMPEDANCE_PCB && ic.applyCurrent)) {
        if (ic.dieCurrent) {
          ic.dieCurrent.startTime = startTime
          ic.dieCurrent.stopTime = stopTime
          ic.dieCurrent.stepTime = stepTime
        } else {
          ic.dieCurrent = {
            startTime: startTime,
            stopTime: stopTime,
            stepTime: stepTime
          }
        }
      }
    })
  })
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: [..._data] });
}

function* createModel(action) {
  const { layoutType, addModelIndex } = action
  const { CascadeReducer: { Impedance: { data, verificationId } } } = yield select();
  let _data = JSON.parse(JSON.stringify(data))
  if (layoutType === IMPEDANCE_SOCKET) {
    const newLayout = new ImpLayout({ index: addModelIndex + 1, designId: IMPEDANCE_SOCKET, designName: 'Socket', type: IMPEDANCE_SOCKET });
    if (addModelIndex === TARGET_PACKAGE_INDEX) {
      let insertIndex = addModelIndex + 1;
      _data.splice(insertIndex, 0, newLayout);
      for (let i = 0; i < _data.length; i++) {
        if (_data[i].type === 'pcb' && _data[i].index === addModelIndex + 1) {
          _data[i].index = newLayout.index + 1;
          break;
        }
      }
    } else {
      let insertIndex = _data.findIndex(item => item.index === addModelIndex) + 1;
      newLayout.index = _data[insertIndex].index;
      _data.splice(insertIndex, 0, newLayout);
      for (let i = insertIndex + 1; i < _data.length; i++) {
        _data[i].index += 1;
      }
    }
  }
  yield call(saveLayouts, { data: _data, update: true, verificationId });
}

function* saveSocket(action) {
  const { files, pairs, targetSocketIndex } = action
  const { CascadeReducer: { Impedance: { data, verificationId } } } = yield select();
  let _data = JSON.parse(JSON.stringify(data))
  const findIndex = _data.findIndex(item => item.index === targetSocketIndex)
  if (findIndex > -1) {
    _data[findIndex].socket = new ImpSocket({ files, pairs })
    yield call(saveLayouts, { data: _data, update: true, verificationId });
  }
}

function* usePackageFileToCreateLayout() {
  const files = []
  const { CascadeReducer: { Impedance: { data, targetIC, designId, verificationId } } } = yield select();
  const { ports: pairs, domains } = yield call(getPackageFilePorts, data);
  let _data = JSON.parse(JSON.stringify(data))
  _data.forEach(layout => {
    layout.ICs.forEach(ic => {
      ic.applyCurrent = false
    })
  })

  const bgaObj = { name: "BGA", usage: BGAConst, from: [], to: [] };
  const dieObj = { name: "DIE", usage: DIEConst, from: [], to: [] };
  bgaObj.from = [{ components: ["DIE"], designId: IMPEDANCE_PACKAGE_FILE }];
  dieObj.to = [{ components: ["BGA"], designId: IMPEDANCE_PACKAGE_FILE }];

  if (targetIC) {
    bgaObj.to = [{ components: [targetIC], designId }];
    const currentIndex = _data.findIndex(item => item.designId === designId);
    if (currentIndex > -1) {
      const icIndex = _data[currentIndex].ICs.findIndex(item => item.name === targetIC);
      if (icIndex > -1) {
        _data[currentIndex].ICs[icIndex].from = [{ components: ["BGA"], designId: IMPEDANCE_PACKAGE_FILE }]
      }
    }
  }
  const newLayout = new ImpLayout({
    index: TARGET_PACKAGE_INDEX,
    designId: IMPEDANCE_PACKAGE_FILE,
    designName: "Package",
    type: IMPEDANCE_PACKAGE_FILE,
    socket: { files, pairs },
    powerDomains: domains.map(d => ({ id: "", content: d })),
    Dies: [dieObj],
    Bgas: [bgaObj]
  });
  yield put(updateImpedanceContent({ targetDie: ["DIE"] }));
  yield delay(10);
  yield call(saveSetup);
  yield call(saveLayouts, { data: [newLayout, ..._data], update: true, verificationId });
}

function* getPackageFilePorts(data) {
  const { CascadeReducer: { Impedance: { designId } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === designId);
  if (findIndex < -1) {
    return;
  }
  let ports = [], domains = [];
  _data[findIndex].powerDomains.forEach(domain => {
    const { content } = domain;
    const { ports: domainPorts, MAIN_POWER_NETS, MAIN_REF_NETS } = content;
    let portIndex = 1
    domains.push({
      PowerNets: [...MAIN_POWER_NETS],
      ReferenceNets: [...MAIN_REF_NETS],
      Components: [{ name: "BGA", usage: BGAConst }, { name: "DIE", usage: DIEConst }],
      MAIN_POWER_NETS: [...MAIN_POWER_NETS],
      MAIN_REF_NETS: [...MAIN_REF_NETS],
      diePorts: [...domainPorts].map(port => ({ ...port, portName: port.portName || `DIE_${port.port}` })),
      bgaPorts: [...domainPorts].map(port => ({ ...port, portName: port.portName || `BGA_${port.port}` }))
    })
    if (domainPorts && domainPorts.length) {
      for (let port of domainPorts) {
        const portName = port.portName || `BGA_${port.port}`;
        ports.push(...[
          { designId, libraryId: "", modelKey: "", nodes: [], port: String(portIndex), portName, powerNet: MAIN_POWER_NETS[0], subckt: "", type: "left" }
        ])
        portIndex++;
      }
    } else {
      ports.push(...[
        { designId, libraryId: "", modelKey: "", nodes: [], port: String(portIndex), portName: `${MAIN_POWER_NETS[0]}`, powerNet: MAIN_POWER_NETS[0], subckt: "", type: "left" }
      ])
      portIndex++;
    }
  })
  return { ports, domains }
}

function* updatePackageFile(action) {
  const { params } = action;
  const { files, pairs } = params
  const { CascadeReducer: { Impedance: { data, verificationId } } } = yield select();
  let _data = JSON.parse(JSON.stringify(data))
  const findIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX && item.type === IMPEDANCE_PACKAGE_FILE);
  if (findIndex > -1) {
    if (files && pairs) {
      const { files: _files = [], pairs: _pairs = [] } = _data[findIndex].socket || {}
      if (!_.isEqual(files, _files) || !_.isEqual(pairs, _pairs)) {
        _data[findIndex].socket = new ImpSocket({ files, pairs })
        const findDieIndex = _data.findIndex(item => item.index === TARGET_DIE_INDEX)
        let newICs = []
        _data[findIndex].powerDomains.forEach(domain => {
          const { content } = domain
          const { Components = [], MAIN_POWER_NETS = [] } = content
          const diePorts = pairs.filter(item => item.type === 'right' && item.powerNet === MAIN_POWER_NETS[0]).map(port => ({ port: port.port, portName: port.portName, powerPins: [], referencePins: [] }))
          domain.content.diePorts = diePorts;
          if (findDieIndex > -1) {
            const pkgDesignId = _data[findIndex].designId
            const dieInfo = Components.find(item => item.usage === DIEConst)
            const die = dieInfo && dieInfo.name ? dieInfo.name : null
            const powerNet = MAIN_POWER_NETS.length ? MAIN_POWER_NETS[0] : null
            if (diePorts.length === 0) {
              newICs.push(new ImpDie({ die, designId: pkgDesignId, portIndex: "1", powerNet }))
            } else {
              diePorts.forEach(item => {
                newICs.push(new ImpDie({ die, designId: pkgDesignId, portIndex: String(item.port), powerNet }))
              })
            }
            _data[findDieIndex].ICs = newICs
            _data[findDieIndex].customType = 'perPort'
          }
        })
      }
    }
    yield call(saveLayouts, { data: _data, update: true, verificationId });
  }
}

function* searchVRM(action) {
  const { designId, domain, row } = action;
  const { VRM_COMP } = row;
  const { CascadeReducer: { Impedance: { targetIC, data, designId: currentDesignId, verificationId } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === designId);
  if (findIndex < 0) { return };
  let loadSelect = [{ comp: targetIC }]
  const setting = yield call(componentSetting.getPrefixLib, designId);
  const doNotStuff = yield call(componentDoNotStuff.getDoNotStuff, designId);
  const table = yield call(compTableHelper.getTableData, designId);
  const pinMapSense = yield call([pinMapStore, pinMapStore.getPinMapSense], designId, "pinName");
  const _pinConnection = yield call(compPinMap.getPinConnection, designId);
  const pinConnection = yield call(getPowerSwitchPinMap, _pinConnection);
  const pinMap = yield call(getImpedancePinMap, designId);
  const connectors = _data[findIndex].connectors;
  const connectorRule = (item) => { return item.from.length && item.from.every(f => f.designId !== designId) }
  const { trueArray: fromConnectors, falseArray: toConnectors } = splitArrayToArrays({ array: connectors, rule: connectorRule });
  let VRMInfo = {};
  const specify = [{ name: VRM_COMP }];
  const { MAIN_POWER_NETS = [], MAIN_REF_NETS = [], includeExtended = true, extraNets = [], Components = [] } = domain;
  let fromComps = [targetIC];
  const netExtensionData = getNetExtensionData(_data, currentDesignId)
  const hasPassiveBoard = _data.find(layout => layout.asPassiveBoard === true) ? true : false
  if (currentDesignId && currentDesignId === designId) {
    VRMInfo = yield call(_getVRM,
      {
        designId,
        GroundNets: [...MAIN_REF_NETS],
        PowerNets: [...MAIN_POWER_NETS],
        ExtendNets: [],
        ExistNets: [],
        COMP_PREFIX_LIB: setting,
        loadSelect,
        connectInductance: false,
        findExtend: includeExtended,
        isAC: true,
        PMIC: getPMIC(setting),
        powerSwitch: setting.powerSwitch,
        buckConverter: setting.discreteBuckConverter || [],
        doNotStuff,
        table,
        pinMapSense,
        pinConnection,
        pinMap,
        extraNets,
        specify,
        connectors: [...toConnectors.map(to => to.name)],
        fuzzyMatch: true,
        hasPassiveBoard
      })
  } else {
    const chips = fromConnectors.map(connector => {
      const { name, from } = connector;
      let _nets = [];
      for (let f of from) {
        const { nets } = f;
        if (!nets) {
          continue
        }
        _nets.push(...(nets[`${name}-${designId}`] || []));
      }
      return _nets.some(net => MAIN_POWER_NETS.includes(net)) ? name : null;
    }).filter(item => !!item).map(name => ({ comp: name }));
    fromComps = chips.map(item => item.comp)
    VRMInfo = yield call(_getVRM, {
      designId,
      GroundNets: [...MAIN_REF_NETS],
      PowerNets: [...MAIN_POWER_NETS],
      ExtendNets: [],
      COMP_PREFIX_LIB: setting,
      loadSelect: chips,
      connectInductance: false,
      findExtend: true,
      isAC: true,
      PMIC: getPMIC(setting),
      powerSwitch: setting.powerSwitch,
      buckConverter: setting.discreteBuckConverter || [],
      doNotStuff,
      table,
      pinMapSense,
      pinConnection,
      pinMap,
      specify,
      fuzzyMatch: true,
      connectors: [...chips.map(c => c.name), ...toConnectors.map(to => to.name)],
      extraNets,
      fullPaths: netExtensionData[designId] && netExtensionData[designId].some(net => MAIN_POWER_NETS.includes(net)) ? true : false
    })
  }
  yield put(updateLogs(VRMInfo.logs || []))
  VRMInfo.Components = yield call(updateComponentDecapModel, {
    components: VRMInfo.Components,
    prevComps: Components,
    designId: currentDesignId,
    voltage: VRMInfo.voltage || "1"
  })

  if (!VRMInfo.VRM.some(vrm => vrm.VRM_COMP.includes(VRM_COMP))) {
    yield put(searchVRMLoading(true));
    return;
  }

  const domainIndex = _data[findIndex].powerDomains.findIndex(item => item.id === domain.id);
  if (domainIndex > -1) {
    const powerDomain = _data[findIndex].powerDomains[domainIndex];
    powerDomain.content.PowerNets = [...new Set([...(powerDomain.content.PowerNets || []), ...(VRMInfo.PowerNets || [])])];
    for (let vrm of (VRMInfo.VRM || [])) {
      if (!powerDomain.content.VRM.some(_vrm => {
        return _.isEqual(_vrm.VRM_COMP, vrm.VRM_COMP)
          && _vrm.groundPin.some(pin => vrm.groundPin.find(_pin => pin.comp === _pin.comp))
          && _vrm.powerPin.some(pin => vrm.powerPin.find(_pin => pin.comp === _pin.comp))
      })) {
        powerDomain.content.VRM.push(vrm);
      }
    }
    powerDomain.content.DEBUG_MONITOR.push(...VRMInfo.DEBUG_MONITOR);
    VRMInfo.Components.forEach(comp => {
      const findCompIndex = powerDomain.content.Components.findIndex(item => item.name === comp.name);
      if (findCompIndex < 0) {
        powerDomain.content.Components.push(comp);
      } else {
        powerDomain.content.Components[findCompIndex].usage = comp.usage
      }
    })
    const newDomains = getCompsBetweenPowerNets(designId, _data[findIndex].powerDomains, doNotStuff)
    let _domains = [];
    for (let newDomain of newDomains) {
      if (!newDomain.domainComps) {
        _domains.push(newDomain);
        continue;
      }
      const domainComps = yield call(updateComponentDecapModel, {
        components: newDomain.domainComps,
        prevComps: [],
        designId: designId,
        voltage: newDomain.content.voltage || "1"
      })
      delete newDomain.domainComps;
      domainComps.forEach(cap => {
        const findIndex = newDomain.content.Components.findIndex(comp => comp.name === cap.name)
        if (findIndex < 0) {
          newDomain.content.Components.push(cap)
        } else if (newDomain.content.Components[findIndex].usage !== cap.usage) {
          newDomain.content.Components[findIndex].usage = cap.usage
        }
      })
      _domains.push(newDomain);
    }
    _data[findIndex].powerDomains = _domains
  }
  const PMICs = _data[findIndex].PMICs;
  if (!PMICs.find(item => item.name === VRM_COMP)) {
    const pmic = getImpedanceLayoutComp(VRM_COMP, designId, PMIC)
    pmic.from.push({ designId: designId, components: [...fromComps] })
    _data[findIndex].PMICs.push(pmic)
    _data[findIndex].ICs.forEach(ic => {
      if (fromComps.includes(ic.name)) {
        ic.to.push({ designId, components: [VRM_COMP] })
      }
    })
    _data[findIndex].connectors.forEach(ic => {
      if (fromComps.includes(ic.name)) {
        ic.to.push({ designId, components: [VRM_COMP] })
      }
    })
  }

  yield call(saveLayouts, { data: _data, update: true, verificationId });
  yield put(searchVRMLoading(true));
}

function* removeVRM(action) {
  const { designId, domain, row } = action;
  const { VRM_COMP } = row;
  const { CascadeReducer: { Impedance: { data, verificationId } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === designId);
  if (findIndex < 0) { return };
  const domainIndex = _data[findIndex].powerDomains.findIndex(item => item.id === domain.id);
  if (domainIndex > -1) {
    const powerDomain = _data[findIndex].powerDomains[domainIndex];
    const VRM = powerDomain.content.VRM.filter(item => !_.isEqual(VRM_COMP, item.VRM_COMP));
    const MAIN_POWER_NETS = powerDomain.content.MAIN_POWER_NETS || [];
    const exsitVRM = VRM.map(item => item.VRM_COMP).flat(2);
    const DEBUG_MONITOR = powerDomain.content.DEBUG_MONITOR.filter(path => {
      const compPath = path.filter(item => item.type === 'comp');
      const vrm = compPath[compPath.length - 1].name;
      return exsitVRM.includes(vrm) ? true : false;
    })
    const exsitNets = DEBUG_MONITOR.map(path => {
      const netPath = path.filter(item => item.type === 'net').map(item => item.name);
      return [...new Set(netPath)]
    }).flat(2);
    const PowerNets = powerDomain.content.PowerNets.filter(item => [...exsitNets, ...MAIN_POWER_NETS].includes(item));
    const components = getCascadeComponentsByNets(designId, PowerNets);
    _data[findIndex].powerDomains[domainIndex].content.Components = powerDomain.content.Components.filter(component => {
      return components.find(item => item.name === component.name) ? true : false;
    })
    _data[findIndex].powerDomains[domainIndex].content.PowerNets = PowerNets
    _data[findIndex].powerDomains[domainIndex].content.VRM = VRM
    _data[findIndex].powerDomains[domainIndex].content.DEBUG_MONITOR = DEBUG_MONITOR
  }

  const vrms = _data[findIndex].powerDomains.map(domain => domain.content.VRM.map(vrm => vrm.VRM_COMP)).flat(3);
  _data[findIndex].PMICs = _data[findIndex].PMICs.filter(pmic => vrms.includes(pmic.name));
  _data[findIndex].ICs = _data[findIndex].ICs.map(ic => {
    const to = ic.to.map(t => {
      if (designId !== t.designId) {
        return t
      }
      return { designId, components: t.components.filter(comp => vrms.includes(comp)) }
    }).filter(t => t.components.length > 0 ? true : false);
    return { ...ic, to }
  })
  _data[findIndex].connectors = _data[findIndex].connectors.map(ic => {
    const to = ic.to.map(t => {
      if (designId !== t.designId) {
        return t
      }
      return { designId, components: t.components.filter(comp => vrms.includes(comp)) }
    }).filter(t => t.components.length > 0 ? true : false);
    return { ...ic, to }
  })

  yield call(saveLayouts, { data: _data, update: true, verificationId });
  yield put(searchVRMLoading(true));
}

function* getInterposers(action) {
  const { designIds = [] } = action;
  const { CascadeReducer: { Impedance: { data = [], designId: currentDesignId, verificationId } } } = yield select();

  let _data = [...data];
  yield put(updateImpedanceLoading('Loading Interposer...'));
  yield delay(100)

  yield* _data.map(function* (layout) {
    if (IMPEDANCE_POST_LIST.includes(layout.type)) {
      if (layout.designId && designIds.includes(layout.designId)) {
        const { designId, powerDomains = [], connectors = [] } = layout;
        yield call(getAuroraDB, designId);
        const connectorRule = (item) => { return item.from.length && item.from.every(f => f.designId !== designId) }
        const { trueArray: fromConnectors, falseArray: toConnectors } = splitArrayToArrays({ array: connectors, rule: connectorRule });
        let groundNets = [], Components = [], netsOrder = []

        let _toConnectors = toConnectors || []
        // add new to component
        if (!_toConnectors.length && fromConnectors.length) {
          const components = getAllCascadeComponents({ pcbId: designId })
          const filterComps = [...components.values()].filter(item => !fromConnectors.some(f => f.name === item.name));
          if (filterComps.length) {
            const toComp = filterComps[0];
            let connComp = getImpedanceLayoutComp(toComp.name, designId, CONNECTOR);
            _toConnectors.push(connComp);
            layout.connectors = [...layout.connectors, connComp]
          }
        }
        let netsGroup = {}
        for (let fromConnector of fromConnectors) {
          const { name, from = [] } = fromConnector;
          netsGroup[name] = []
          const findIndex = connectors.findIndex(item => item.name === name);
          if (findIndex > -1) {
            layout.connectors[findIndex].to = toConnectors.length ? [{ designId, components: toConnectors.map(t => t.name) }] : []
          }
          for (let f of from) {
            const fromLayout = _data.find(item => item.designId === f.designId);
            const powerNetsOrder = getLayoutNetOrder(fromLayout, 'from');
            netsOrder.push(...powerNetsOrder)
            if (fromLayout) {
              const grounds = fromLayout.powerDomains.map(domain => domain.content ? domain.content.MAIN_REF_NETS : []).flat(2)
              groundNets.push(...[...new Set(grounds)])
              const { nets = {}, components = [] } = f;
              const connectorNets = nets[`${name}-${designId}`] || [];
              for (let component of components) {
                const compNets = nets[`${component}-${f.designId}`] || [];
                const groundNetsIndex = compNets.map((net, index) => grounds.includes(net) ? index : -1).filter(index => index > -1);
                const connectorGroundNets = connectorNets.filter((net, index) => groundNetsIndex.includes(index));
                const powerNets = [...new Set(compNets)].filter(net => !grounds.includes(net)).sort((a, b) => {
                  const aIndex = powerNetsOrder.findIndex(n => n === a);
                  const bIndex = powerNetsOrder.findIndex(n => n === b);
                  return (aIndex > -1 ? aIndex : Infinity) > (bIndex > -1 ? bIndex : Infinity) ? 1 : -1;
                });
                powerNets.forEach((net) => {
                  const powerNetsIndex = compNets.map((n, index) => net === n ? index : -1).filter(index => index > -1);
                  const connectorPowerNets = connectorNets.filter((n, index) => powerNetsIndex.includes(index));
                  if (netsGroup[name]) {
                    netsGroup[name].push({ net, powerNets: [...new Set(connectorPowerNets)], referenceNets: [...new Set(connectorGroundNets)] })
                  }
                })
              }
            }
          }
          const connector = getCascadeComponents({ pcbId: designId, name });
          const pins = [...connector.pins.values()];
          netsGroup[name] = netsGroup[name].map(item => {
            const powerPins = pins.filter(pin => item.powerNets.includes(pin.net)).map(pin => pin.pin);
            const referencePins = pins.filter(pin => item.referenceNets.includes(pin.net)).map(pin => pin.pin);
            return { ...item, powerPins, referencePins }
          })
        }

        for (let toConnector of toConnectors) {
          const { name, to = [] } = toConnector;
          netsGroup[name] = [];
          const findIndex = layout.connectors.findIndex(item => item.name === name);
          if (findIndex > -1) {
            layout.connectors[findIndex].from = fromConnectors.length ? [{ designId, components: fromConnectors.map(t => t.name) }] : []
          }
          for (let t of to) {
            const { nets = {}, components = [] } = t;
            const connectorNets = nets[`${name}-${designId}`] || [];
            for (let component of components) {
              const compNets = nets[`${component}-${t.designId}`] || [];
              const groundNetsIndex = compNets.map((net, index) => groundNets.includes(net) ? index : -1).filter(index => index > -1);
              const connectorGroundNets = connectorNets.filter((net, index) => groundNetsIndex.includes(index));
              const powerNets = [...new Set(compNets)].filter(net => !groundNets.includes(net));
              powerNets.forEach((net) => {
                const powerNetsIndex = compNets.map((n, index) => net === n ? index : -1).filter(index => index > -1);
                const connectorPowerNets = connectorNets.filter((n, index) => powerNetsIndex.includes(index));
                netsGroup[name].push({ net, powerNets: [...new Set(connectorPowerNets)], referenceNets: [...new Set(connectorGroundNets)] });
              })
            }
          }
          const connector = getCascadeComponents({ pcbId: designId, name });
          const pins = [...connector.pins.values()];
          netsGroup[name] = netsGroup[name].map(item => {
            const powerPins = pins.filter(pin => item.powerNets.includes(pin.net)).map(pin => pin.pin);
            const referencePins = pins.filter(pin => item.referenceNets.includes(pin.net)).map(pin => pin.pin);
            return { ...item, powerPins, referencePins }
          })
        }
        const compNames = Object.keys(netsGroup);

        let portsMap = [];
        for (let compName of compNames) {
          let exsitIndex = [];
          let loadPorts = (netsGroup[compName] || []).map(port => {
            const portMap = portsMap.find(item => item.pins.some(pin => port.powerPins.includes(pin)));
            let portIndex = -1;
            if (portMap && !exsitIndex.includes(portMap.index)) {
              exsitIndex.includes(portMap.index)
              portIndex = portMap.index
            }
            return {
              port: portIndex,
              nets: [port.net],
              powerPins: [...new Set(port.powerPins)],
              referencePins: [...new Set([...port.referencePins])]
            }
          })
          const portsIndex = portsMap.map(port => port.index).filter(item => item > -1);
          let firstIndex = 1;
          loadPorts.forEach(port => {
            if (port.port < 1) {
              while (portsIndex.includes(firstIndex)) {
                firstIndex++;
              }
              port.port = firstIndex;
              portsMap.push({ pins: port.powerPins, index: firstIndex });
              portsIndex.push(firstIndex)
            }
          })
          Components.push({
            name: compName,
            loadPorts: loadPorts.map(port => ({ ...port, port: String(port.port) }))
          })
        }
        layout.netsOrder = netsOrder;
        if (powerDomains.length) {
          layout.powerDomains[0].content.Components = Components
        } else {
          layout.powerDomains = [{
            id: "",
            content: {
              Components,
              MAIN_POWER_NETS: [],
              MAIN_REF_NETS: [],
              ReferenceNets: [],
              PowerNets: []
            }
          }]
        }

        const netExtensionData = getNetExtensionData(_data, currentDesignId)
        const portImpedanceNets = getPortImpedanceNets(layout.powerDomains, layout.designId, layout.portImpedanceNets, netExtensionData, layout.type);
        layout.portImpedanceNets = portImpedanceNets;
      }
    }
  })
  yield call(saveLayouts, { data: _data, update: true, verificationId });
  yield put(updateImpedanceLoading(false));
}

function* setNetExtensionType(action) {
  const { netExtensionType, designId } = action;
  const { CascadeReducer: { Impedance: { data } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === designId)
  if (findIndex < 0) {
    return;
  }
  _data[findIndex].netExtensionType = netExtensionType;
  yield put(updateImpedanceContent({ data: _data, status: true }));
  yield put({ type: SAVE_POWER_DOMAIN, data: [..._data] });
}

function* updatePackageRelationship(action) {
  const { relationship } = action;
  const { CascadeReducer: { project: { openProjectId }, Impedance: { targetDie, verificationId, data = [], designId: currentDesignId, limitBoundaryPowerPinsLumpedPort } } } = yield select();
  yield put(setPackageRelationship(relationship))

  let _data = [...data];
  const pkg = _data.find(item => item.index === TARGET_PACKAGE_INDEX);
  if (!pkg) return;
  const pcbId = pkg.designId
  const isPreLayout = designConstructor.isPreLayout(pcbId);
  let setting = new CascadeCompRLCPrefixLib({})
  if (isPreLayout) {
    yield call([preLayoutData, preLayoutData.getPreLayout], pcbId)
  } else {
    setting = yield call([componentSetting, componentSetting.getPrefixLib], pcbId);
    yield call(getAuroraDB, pcbId);
  }

  const designList = CascadeChannels.getList(IMPEDANCE, openProjectId);
  const currentItem = [...designList].find(i => i.id === verificationId);
  yield put(openTabFooter());
  yield put(changeTabMenu({
    tabSelectKeys: ["detail"],
    currentVerificationId: verificationId,
    verificationName: currentItem ? currentItem.name : IMPEDANCE,
    menuType: "simulation"
  }))
  yield put(updateLogs([], true))
  yield delay(100);
  const { referenceNets, DIE, BGA } = getPackagePowerDomain(pcbId, setting, targetDie);
  if (!BGA.name) {
    return;
  }
  let _powerNets = relationship.map(ship => ship[IMPEDANCE_PACKAGE]).flat(2);

  yield put(updateImpedanceLoading('Loading...'));
  const findIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
  if (findIndex < 0) {
    yield put(updateImpedanceLoading(false));
    return;
  }

  _powerNets = [...new Set(_powerNets)]
  const designName = designConstructor.getDesignName(pcbId);
  if (_powerNets.length) {
    yield put(updateLogs([{ type: 'success', text: `[Package] [${designName}] Found ${_powerNets.join(', ')}` }]))
  }

  let powerDomains = [];
  const _targetDie = [];
  const prevPowerDomains = _data[findIndex].powerDomains;

  for (let powerNet of _powerNets) {
    const findDomain = prevPowerDomains.find(domain => domain.content.MAIN_POWER_NETS.includes(powerNet));
    if (findDomain) {
      const { Die = [] } = setting
      const die = Die.filter(item => {
        return findDomain.content.Components.find(comp => comp.name === item)
      })
      if (die.length && !_targetDie.some(d => die.includes(d))) {
        _targetDie.push(...die)
      }
      powerDomains.push({
        id: "",
        content: findDomain.content
      });
      continue;
    }

    const packageVRMs = yield call(getPkgDomainInfo, {
      pcbId,
      powerNet,
      referenceNets,
      DIE: DIE.map(die => die.name),
      BGA: BGA.name,
      setting,
      limitBoundaryPowerPinsLumpedPort
    })

    if (!packageVRMs.add) {
      continue;
    }
    packageVRMs.domain.Components = yield call(updateComponentDecapModel, {
      components: packageVRMs.domain ? packageVRMs.domain.Components : [],
      prevComps: [],
      designId: pcbId
    })
    const { Die = [] } = setting
    const die = Die.filter(item => {
      return packageVRMs.domain.Components.find(comp => comp.name === item)
    })

    if (die.length && !_targetDie.some(d => die.includes(d))) {
      _targetDie.push(...die)
    }

    const _relationship = relationship.find(item => item[IMPEDANCE_PACKAGE].includes(powerNet));
    if (_relationship && _relationship[IMPEDANCE_PCB]) {
      const targetPCB = _data.find(item => item.designId === currentDesignId);
      const pcbPorts = targetPCB.powerDomains.filter(item => item.content.MAIN_POWER_NETS.some(net => _relationship[IMPEDANCE_PCB].includes(net))).map(item => item.content.ports).flat(2)
      if (pcbPorts.length) {
        if (BGA && BGA.name) {
          const compInfo = getCascadeComponents({ pcbId, name: BGA.name });
          if (compInfo) {
            const pins = [...compInfo.pins.values()].filter(pin => powerNet.includes(pin.net)).map(pin => pin.pin);
            let _ports = pcbPorts.map(port => {
              const { powerPins = [] } = port;
              const _powerPins = powerPins.filter(pin => pins.includes(pin));
              return { ...port, powerPins: _powerPins, importPowerPins: [], importReferencePins: [], target: [] }
            }).filter(port => port.powerPins.length);
            if (_ports.length) {
              packageVRMs.domain.bgaPorts = _ports;
            }
          }
        }
      }
    }

    powerDomains.push({
      id: "",
      content: { ...packageVRMs.domain }
    })
  }

  yield call(packageDomainsHandle, { powerDomains, pcbId, setting, BGA, _targetDie, _powerNets })
}

function* packageDomainsHandle({ powerDomains, pcbId, setting, BGA, _targetDie, _powerNets }) {
  const { CascadeReducer: { Impedance: { data = [], targetIC, designId: currentDesignId, verificationId } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.index === TARGET_PACKAGE_INDEX);
  const targetDie = designConstructor.isPreLayout(pcbId) ? ['DIE'] : _targetDie;
  const { DIE: _DIE } = getPackagePowerDomain(pcbId, setting, targetDie);
  const bgaObj = getImpedanceLayoutComp(BGA.name, pcbId, BGAConst);
  bgaObj.from = [{ components: _DIE.map(die => die.name), designId: pcbId }];
  const dieObj = _DIE.map(die => {
    const _dieObj = getImpedanceLayoutComp(die.name, pcbId, DIEConst)
    _dieObj.to = [{ components: [BGA.name], designId: pcbId }];
    return _dieObj
  })

  if (currentDesignId !== pcbId && targetIC) {
    bgaObj.to = [{ components: [targetIC], designId: currentDesignId }];
    const currentIndex = _data.findIndex(item => item.designId === currentDesignId);
    if (currentIndex > -1) {
      const icIndex = _data[currentIndex].ICs.findIndex(item => item.name === targetIC);
      if (icIndex > -1) {
        _data[currentIndex].ICs[icIndex].from = [{ components: [BGA.name], designId: pcbId }]
      }
    }
  }

  const dieIndex = _data.findIndex(item => item.index === TARGET_DIE_INDEX)
  if (dieIndex > -1) {
    const oldICs = _data[dieIndex].ICs || []
    let newICs = []
    let notUpdate = true
    powerDomains.forEach(domain => {
      const { content } = domain
      const { Components = [], diePorts = [] } = content
      const dieInfo = Components.find(item => item.usage === DIEConst)
      const die = dieInfo && dieInfo.name ? dieInfo.name : null
      const powerNet = content.MAIN_POWER_NETS.length ? content.MAIN_POWER_NETS[0] : null
      const ports = diePorts.length ? diePorts : [{ port: 1 }]
      const filterICs = oldICs.filter(ic => ic.to && ic.to[0] && ic.to[0].components && ic.to[0].components[0] === die)
      if (ports.length !== filterICs.length) {
        notUpdate = false
      }
      ports.forEach(p => {
        const portIndex = String(p.port)
        const oldIC = notUpdate ? filterICs.find(ic => ic.portIndex === portIndex && ic.powerNet === powerNet) || null : null
        if (notUpdate && !oldIC) notUpdate = false
        const newIC = oldIC ? Object.assign({}, oldIC, { portIndex, powerNet, to: [{ designId: pcbId, components: [die] }] }) : new ImpDie({ die, designId: pcbId, portIndex, powerNet })
        newICs.push(newIC)
      })
    })
    _data[dieIndex].ICs = newICs
    _data[dieIndex].customType = notUpdate ? _data[dieIndex].customType || 'perPort' : 'perPort'
  }

  const { ballSizeMap } = _data[findIndex]
  const ballSizeMapObj = new BallSizeMap({ ballSizeMap, comps: [...dieObj, bgaObj], designId: pcbId })
  const _ballSizeMap = ballSizeMapObj.getBallSizeMap()

  const prevPortImpedanceNets = _data[findIndex].portImpedanceNets || [];
  const portImpedanceNets = getPortImpedanceNets(powerDomains, pcbId, prevPortImpedanceNets);

  _data[findIndex].portImpedanceNets = portImpedanceNets;
  _data[findIndex].Dies = dieObj;
  _data[findIndex].Bgas = [bgaObj];
  _data[findIndex].powerDomains = powerDomains;
  _data[findIndex].ballSizeMap = _ballSizeMap;

  yield put(updateImpedanceContent({ targetDie: [...new Set(targetDie)], data: _data }));
  yield call(saveSetup);
  const designName = designConstructor.getDesignName(pcbId);
  if (!_powerNets.length) {
    yield put(updateLogs([{ type: 'error', text: `[Package] [${designName}] Not Found Power Domains, please select Die and Power Nets.` }]))
  } else if (!targetDie.length) {
    yield put(updateLogs([{ type: 'error', text: `[Package] [${designName}] Not Found Die, please open Component Setting to set it.` }]))
  } else {
    yield put(updateLogs([{ type: 'success', text: `[Package] [${designName}] Found ${powerDomains.length} Power Domains` }, { type: 'normal', text: `[Package] Saving...` }]))
  }
  yield delay(10)

  try {
    yield call(saveLayouts, { data: _data, update: true, verificationId });
    yield put(updateImpedanceLoading(false));
    yield put(updateLogs([{ type: 'normal', text: `[Package] Save completed.` }]))
  } catch (e) {
    yield put(updateImpedanceLoading(false));
    yield put(updateLogs([{ type: 'error', text: `[Package] Save failed...` }]))
    console.error("Package Error:" + e)
  }
}

function* saveVRMPorts(action) {
  const { designId, VRMPorts } = action
  const { CascadeReducer: { Impedance: { data, verificationId } } } = yield select();
  let _data = [...data];
  const findIndex = _data.findIndex(item => item.designId === designId)
  if (findIndex < 0) {
    return;
  }

  _data[findIndex].powerDomains.forEach(domain => {
    const { content } = domain
    const { MAIN_POWER_NETS = [] } = content
    const powerNet = MAIN_POWER_NETS && MAIN_POWER_NETS.length ? MAIN_POWER_NETS[0] : null
    const findPortIndex = VRMPorts.findIndex(item => item.powerNet === powerNet)
    domain.content.VRMPorts = findPortIndex > -1 ? [...VRMPorts[findPortIndex].ports || []] : []
  })

  yield call(saveLayouts, { data: [..._data], update: true, verificationId })
}

function* updatePortImpedance(action) {
  const { portImpedance } = action;
  const { CascadeReducer: { Impedance: { data = [], verificationId } } } = yield select();

  let _data = [...data];

  _data.forEach(item => {
    const { designId } = item;
    const portImpedanceNets = portImpedance[designId];
    if (portImpedanceNets) {
      item.portImpedanceNets = portImpedanceNets;
    }
  })
  yield call(saveLayouts, { data: _data, update: true, verificationId });
}

function* ImpedanceSaga() {
  yield takeLatest(GET_IMPEDANCE_CONTENT, getImpedanceContent);
  yield takeEvery(UPDATE_TARGET_IC, changeTargetIC);
  yield takeEvery(REFIND_DOMAIN_INFO, reGetDomainRowInfo);
  yield takeEvery(DELETE_IMPEDANCE_ROW, deletePowerDomains);
  yield takeEvery(SAVE_VRM, saveVRM);
  yield takeEvery(SAVE_RLC_VALUE, saveRLCValue);
  yield takeEvery(SAVE_RL_MODEL, saveRLModel);
  yield takeEvery(SAVE_CAP_MODEL, saveModel);
  yield takeEvery(UPDATE_EXTENDED, updateExtendNets);
  yield takeEvery(MERGE_PART, mergeCompByPart);
  yield takeEvery(UPDATE_COMP_USAGE, changeCompUsage);
  yield takeEvery(SPLIT_COMP, splitComponent);
  yield takeEvery(UPDATE_COMP_PREFIX, updateComponentPrefix);
  yield takeEvery(UPDATE_EXTRACTION, updateExtraction);
  yield takeEvery(UPDATE_OPTIMIZATION, updateOpt);
  yield takeEvery(REFRESH, refreshImp);
  yield takeEvery(REMOVE_COMP, removeComp);
  yield takeEvery(ADD_ROW, addRowForDomain);
  yield takeLatest(CHANGE_NETS, changeNets);
  yield takeLatest(CHANGE_EXTRA_NETS, changeExtraNets);
  yield takeEvery(SAVE_TARGET, saveTarget);
  yield takeEvery(SAVE_PORTS, savePorts);
  yield takeEvery(SAVE_LOAD_PORTS, saveLoadPorts);
  yield takeEvery(CHANGE_PCB, updateImpedancePCB);
  yield takeEvery(POWER_NET_SELECT_PANEL, openPowerNetSelectPanel);
  yield takeEvery(DIE_POWER_NET_SELECT_PANEL, openDiePowerNetSelectPanel);
  yield takeEvery(RE_ASSIGN_DECAP_MODEL, reAssignDecapModel);
  yield takeEvery(DELETE_SENSE_PORT, deleteSensePath);
  yield takeEvery(UPDATE_OPTIONS, updateOptions);
  yield takeEvery(SAVE_PACKAGE_PORTS, savePackagePorts);
  yield takeEvery(UPDATE_PACKAGE_NETS, updatePackageNets);
  yield takeEvery(SAVE_DOMAIN_BY_NEW_NETS, refindPackagePins);
  yield takeEvery(SWITCH_PACKAGE_PORTS_TYPE, switchPackagePorts);
  yield takeEvery(SAVE_BALL_SIZE, updateBallSize);
  yield takeEvery(SET_ADDITIONAL_NETS, saveAdditionalNets);
  yield takeEvery(REFRESH_PACKAGE, updatePkgDomain);
  yield takeEvery(SWITCH_TARGET_DIE, switchDie);
  yield takeEvery(SAVE_WIRE_BOND, saveWireBondFile);
  yield takeEvery(CHANGE_PAGE, changePageByDesign);
  yield takeEvery(CREATE_NEW_LAYOUT, createLayout);
  yield takeEvery(DELETE_LAYOUT, deleteLayout);
  yield takeEvery(DELETE_LAYOUT_CONNECTOR, deleteLayoutConnector);
  yield takeEvery(TRACE_OVERVIEW, traceByLayout);
  yield takeEvery(DELETE_SHIP, deleteShip);
  yield takeEvery(CREATE_DIE, createDie);
  yield takeEvery(SAVE_ON_DIE_MODEL, saveOnDieModel);
  yield takeEvery(SAVE_MULTI_PCB_TARGET, updateMultiPCBTarget)
  yield takeEvery(UPDATE_DECAP_GROUP, updateDecapGroup);
  yield takeEvery(SAVE_DIE_CURRENT, saveDieCurrent)
  yield takeEvery(UPDATE_DECAP_MODEL, updateDecapModel);
  yield takeEvery(SAVE_COMP_TABLE_DISPLAY, saveComponentsTableDisplay);
  yield takeEvery(CHANGE_USAGE, changeUsage);
  yield takeEvery(SAVE_PMIC_VOLTAGE, savePMICVoltage);
  yield takeEvery(SAVE_RLEAK_RRDL, saveDieRleakAndRrdl);
  yield takeEvery(SWITCH_PACKAGE, switchPackage);
  yield takeEvery(SWITCH_PCB, switchPcb);
  yield takeEvery(SAVE_INTERPOSER, saveInterposer);
  yield takeEvery(SAVE_INTERPOSER_NODE, saveInterposerNode)
  yield takeEvery(SAVE_HAS_INTERPOSER, saveHasInterposer)
  yield takeEvery(UPDATE_IC_CURRENT_STATUS, updateCurrentStatus)
  yield takeEvery(SAVE_TRANSIENT_TIME_SETTING, saveTransientTimeSetting)
  yield takeEvery(CREATE_MODEL, createModel)
  yield takeEvery(SAVE_SOCKET, saveSocket)
  yield takeEvery(USE_PACGAGE_FILE, usePackageFileToCreateLayout)
  yield takeEvery(UPDATE_PACKAGE_FILE, updatePackageFile)
  yield takeEvery(SAVE_LOAD_MODEL, saveLoadModel)
  yield takeEvery(SEARCH_VRM, searchVRM);
  yield takeEvery(REMOVE_VRM, removeVRM)
  yield takeLatest(SAVE_NET_EXTENSION_TYPE, setNetExtensionType);
  yield takeEvery(REFRESH_INTERPOSER, getInterposers)
  yield takeEvery(UPDATE_PACKAGE_RELATIONSHIP, updatePackageRelationship);
  yield takeEvery(SAVE_VRM_PORTS, saveVRMPorts)
  yield takeEvery(UPDATE_PORT_IMPEDANCE, updatePortImpedance);
}

export default ImpedanceSaga;